
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7399"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7399"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("cy2cu", function(module, exports) {
/*
 * leaflet-geocoder-mapzen
 * Leaflet plugin to search (geocode) using Mapzen Search or your
 * own hosted version of the Pelias Geocoder API.
 *
 * License: MIT
 * (c) Mapzen
 */ 'use strict';
parcelRequire("1iiOo");

var $8JYDX = parcelRequire("8JYDX");

var $4F5LR = parcelRequire("4F5LR");

var $dlx9g = parcelRequire("dlx9g");

var $3iXvL = parcelRequire("3iXvL");
var $922a5df305ab5ff0$var$VERSION = '1.9.4';
var $922a5df305ab5ff0$var$MINIMUM_INPUT_LENGTH_FOR_AUTOCOMPLETE = 1;
var $922a5df305ab5ff0$var$FULL_WIDTH_MARGIN = 20; // in pixels
var $922a5df305ab5ff0$var$FULL_WIDTH_TOUCH_ADJUSTED_MARGIN = 4; // in pixels
var $922a5df305ab5ff0$var$RESULTS_HEIGHT_MARGIN = 20; // in pixels
var $922a5df305ab5ff0$var$API_RATE_LIMIT = 250; // in ms, throttled time between subsequent requests to API
// Text strings in this geocoder.
var $922a5df305ab5ff0$var$TEXT_STRINGS = {
    'INPUT_PLACEHOLDER': 'Search',
    'INPUT_TITLE_ATTRIBUTE': 'Search',
    'RESET_TITLE_ATTRIBUTE': 'Reset',
    'NO_RESULTS': 'No results were found.',
    // Error codes.
    // https://mapzen.com/documentation/search/http-status-codes/
    'ERROR_403': 'A valid API key is needed for this search feature.',
    'ERROR_404': 'The search service cannot be found. :-(',
    'ERROR_408': 'The search service took too long to respond. Try again in a second.',
    'ERROR_429': 'There were too many requests. Try again in a second.',
    'ERROR_500': 'The search service is not working right now. Please try again later.',
    'ERROR_502': 'Connection lost. Please try again later.',
    // Unhandled error code
    'ERROR_DEFAULT': 'The search service is having problems :-('
};
var $922a5df305ab5ff0$var$Geocoder = $8JYDX.Control.extend({
    version: $922a5df305ab5ff0$var$VERSION,
    // L.Evented is present in Leaflet v1+
    // L.Mixin.Events is legacy; was deprecated in Leaflet v1 and will start
    // logging deprecation warnings in console in v1.1
    includes: $8JYDX.Evented ? $8JYDX.Evented.prototype : $8JYDX.Mixin.Events,
    options: {
        position: 'topleft',
        attribution: 'Geocoding by <a href="https://mapzen.com/projects/search/">Mapzen</a>',
        url: 'https://search.mapzen.com/v1',
        placeholder: null,
        bounds: false,
        focus: true,
        layers: null,
        panToPoint: true,
        pointIcon: true,
        polygonIcon: true,
        fullWidth: 650,
        markers: true,
        overrideBbox: false,
        expanded: false,
        autocomplete: true,
        place: false,
        textStrings: $922a5df305ab5ff0$var$TEXT_STRINGS
    },
    initialize: function(apiKey, options) {
        // For IE8 compatibility (if XDomainRequest is present),
        // we set the default value of options.url to the protocol-relative
        // version, because XDomainRequest does not allow http-to-https requests
        // This is set first so it can always be overridden by the user
        if (window.XDomainRequest) this.options.url = '//search.mapzen.com/v1';
        // If the apiKey is omitted entirely and the
        // first parameter is actually the options
        if (typeof apiKey === 'object' && !!apiKey) options = apiKey;
        else this.apiKey = apiKey;
        // Deprecation warnings
        // If options.latlng is defined, warn. (Do not check for falsy values, because it can be set to false.)
        if (options && typeof options.latlng !== 'undefined') {
            // Set user-specified latlng to focus option, but don't overwrite if it's already there
            if (typeof options.focus === 'undefined') options.focus = options.latlng;
            console.warn('[leaflet-geocoder-mapzen] DEPRECATION WARNING:', 'As of v1.6.0, the `latlng` option is deprecated. It has been renamed to `focus`. `latlng` will be removed in a future version.');
        }
        // Deprecate `title` option
        if (options && typeof options.title !== 'undefined') {
            options.textStrings = options.textStrings || {};
            options.textStrings.INPUT_TITLE_ATTRIBUTE = options.title;
            console.warn('[leaflet-geocoder-mapzen] DEPRECATION WARNING:', 'As of v1.8.0, the `title` option is deprecated. Please set the property `INPUT_TITLE_ATTRIBUTE` on the `textStrings` option instead. `title` will be removed in a future version.');
        }
        // `placeholder` is not deprecated, but it is an alias for textStrings.INPUT_PLACEHOLDER
        if (options && typeof options.placeholder !== 'undefined') // textStrings.INPUT_PLACEHOLDER has priority, if defined.
        {
            if (!(options.textStrings && typeof options.textStrings.INPUT_PLACEHOLDER !== 'undefined')) {
                options.textStrings = options.textStrings || {};
                options.textStrings.INPUT_PLACEHOLDER = options.placeholder;
            }
        }
        // Merge any strings that are not customized
        if (options && typeof options.textStrings === 'object') {
            for(var prop in this.options.textStrings)if (typeof options.textStrings[prop] === 'undefined') options.textStrings[prop] = this.options.textStrings[prop];
        }
        // Now merge user-specified options
        $8JYDX.Util.setOptions(this, options);
        this.markers = [];
    },
    /**
   * Resets the geocoder control to an empty state.
   *
   * @public
   */ reset: function() {
        this._input.value = '';
        $8JYDX.DomUtil.addClass(this._reset, 'leaflet-pelias-hidden');
        this.removeMarkers();
        this.clearResults();
        this.fire('reset');
    },
    getLayers: function(params) {
        var layers = this.options.layers;
        if (!layers) return params;
        params.layers = layers;
        return params;
    },
    getBoundingBoxParam: function(params) {
        /*
     * this.options.bounds can be one of the following
     * true //Boolean - take the map bounds
     * false //Boolean - no bounds
     * L.latLngBounds(...) //Object
     * [[10, 10], [40, 60]] //Array
    */ var bounds = this.options.bounds;
        // If falsy, bail
        if (!bounds) return params;
        // If set to true, use map bounds
        // If it is a valid L.LatLngBounds object, get its values
        // If it is an array, try running it through L.LatLngBounds
        if (bounds === true && this._map) {
            bounds = this._map.getBounds();
            params = makeParamsFromLeaflet(params, bounds);
        } else if (typeof bounds === 'object' && bounds.isValid && bounds.isValid()) params = makeParamsFromLeaflet(params, bounds);
        else if ($8JYDX.Util.isArray(bounds)) {
            var latLngBounds = $8JYDX.latLngBounds(bounds);
            if (latLngBounds.isValid && latLngBounds.isValid()) params = makeParamsFromLeaflet(params, latLngBounds);
        }
        function makeParamsFromLeaflet(params, latLngBounds) {
            params['boundary.rect.min_lon'] = latLngBounds.getWest();
            params['boundary.rect.min_lat'] = latLngBounds.getSouth();
            params['boundary.rect.max_lon'] = latLngBounds.getEast();
            params['boundary.rect.max_lat'] = latLngBounds.getNorth();
            return params;
        }
        return params;
    },
    getFocusParam: function(params) {
        /**
     * this.options.focus can be one of the following
     * [50, 30]           // Array
     * {lon: 30, lat: 50} // Object
     * {lat: 50, lng: 30} // Object
     * L.latLng(50, 30)   // Object
     * true               // Boolean - take the map center
     * false              // Boolean - No latlng to be considered
     */ var focus = this.options.focus;
        if (!focus) return params;
        if (focus === true && this._map) {
            // If focus option is Boolean true, use current map center
            var mapCenter = this._map.getCenter();
            params['focus.point.lat'] = mapCenter.lat;
            params['focus.point.lon'] = mapCenter.lng;
        } else if (typeof focus === 'object') {
            // Accepts array, object and L.latLng form
            // Constructs the latlng object using Leaflet's L.latLng()
            // [50, 30]
            // {lon: 30, lat: 50}
            // {lat: 50, lng: 30}
            // L.latLng(50, 30)
            var latlng = $8JYDX.latLng(focus);
            params['focus.point.lat'] = latlng.lat;
            params['focus.point.lon'] = latlng.lng;
        }
        return params;
    },
    // @method getParams(params: Object)
    // Collects all the parameters in a single object from various options,
    // including options.bounds, options.focus, options.layers, the api key,
    // and any params that are provided as a argument to this function.
    // Note that options.params will overwrite any of these
    getParams: function(params) {
        params = params || {};
        params = this.getBoundingBoxParam(params);
        params = this.getFocusParam(params);
        params = this.getLayers(params);
        // Search API key
        if (this.apiKey) params.api_key = this.apiKey;
        var newParams = this.options.params;
        if (!newParams) return params;
        if (typeof newParams === 'object') for(var prop in newParams)params[prop] = newParams[prop];
        return params;
    },
    serialize: function(params) {
        var data = '';
        for(var key in params)if (params.hasOwnProperty(key)) {
            var param = params[key];
            var type = param.toString();
            var value;
            if (data.length) data += '&';
            switch(type){
                case '[object Array]':
                    value = param[0].toString() === '[object Object]' ? JSON.stringify(param) : param.join(',');
                    break;
                case '[object Object]':
                    value = JSON.stringify(param);
                    break;
                case '[object Date]':
                    value = param.valueOf();
                    break;
                default:
                    value = param;
                    break;
            }
            data += encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }
        return data;
    },
    search: function(input) {
        // Prevent lack of input from sending a malformed query to Pelias
        if (!input) return;
        var url = this.options.url + '/search';
        var params = {
            text: input
        };
        this.callPelias(url, params, 'search');
    },
    autocomplete: $dlx9g(function(input) {
        // Prevent lack of input from sending a malformed query to Pelias
        if (!input) return;
        var url = this.options.url + '/autocomplete';
        var params = {
            text: input
        };
        this.callPelias(url, params, 'autocomplete');
    }, $922a5df305ab5ff0$var$API_RATE_LIMIT),
    place: function(id) {
        // Prevent lack of input from sending a malformed query to Pelias
        if (!id) return;
        var url = this.options.url + '/place';
        var params = {
            ids: id
        };
        this.callPelias(url, params, 'place');
    },
    handlePlaceResponse: function(response) {
    // Placeholder for handling place response
    },
    // Timestamp of the last response which was successfully rendered to the UI.
    // The time represents when the request was *sent*, not when it was recieved.
    maxReqTimestampRendered: new Date().getTime(),
    callPelias: function(endpoint, params, type) {
        params = this.getParams(params);
        $8JYDX.DomUtil.addClass(this._search, 'leaflet-pelias-loading');
        // Track when the request began
        var reqStartedAt = new Date().getTime();
        var paramString = this.serialize(params);
        var url = endpoint + '?' + paramString;
        var self = this; // IE8 cannot .bind(this) without a polyfill.
        function handleResponse(err, response) {
            $8JYDX.DomUtil.removeClass(self._search, 'leaflet-pelias-loading');
            var results;
            try {
                results = JSON.parse(response.responseText);
            } catch (e) {
                err = {
                    code: 500,
                    message: 'Parse Error' // TODO: string
                };
            }
            if (err) {
                var errorMessage;
                switch(err.code){
                    // Error codes.
                    // https://mapzen.com/documentation/search/http-status-codes/
                    case 403:
                        errorMessage = self.options.textStrings['ERROR_403'];
                        break;
                    case 404:
                        errorMessage = self.options.textStrings['ERROR_404'];
                        break;
                    case 408:
                        errorMessage = self.options.textStrings['ERROR_408'];
                        break;
                    case 429:
                        errorMessage = self.options.textStrings['ERROR_429'];
                        break;
                    case 500:
                        errorMessage = self.options.textStrings['ERROR_500'];
                        break;
                    case 502:
                        errorMessage = self.options.textStrings['ERROR_502'];
                        break;
                    // Note the status code is 0 if CORS is not enabled on the error response
                    default:
                        errorMessage = self.options.textStrings['ERROR_DEFAULT'];
                        break;
                }
                self.showMessage(errorMessage);
                self.fire('error', {
                    results: results,
                    endpoint: endpoint,
                    requestType: type,
                    params: params,
                    errorCode: err.code,
                    errorMessage: errorMessage
                });
            }
            // There might be an error message from the geocoding service itself
            if (results && results.geocoding && results.geocoding.errors) {
                errorMessage = results.geocoding.errors[0];
                self.showMessage(errorMessage);
                self.fire('error', {
                    results: results,
                    endpoint: endpoint,
                    requestType: type,
                    params: params,
                    errorCode: err.code,
                    errorMessage: errorMessage
                });
                return;
            }
            // Autocomplete and search responses
            if (results && results.features) {
                // Check if request is stale:
                // Only for autocomplete or search endpoints
                // Ignore requests if input is currently blank
                // Ignore requests that started before a request which has already
                // been successfully rendered on to the UI.
                if (type === 'autocomplete' || type === 'search') {
                    if (self._input.value === '' || self.maxReqTimestampRendered >= reqStartedAt) return;
                    else // Record the timestamp of the request.
                    self.maxReqTimestampRendered = reqStartedAt;
                }
                // Placeholder: handle place response
                if (type === 'place') self.handlePlaceResponse(results);
                // Show results
                if (type === 'autocomplete' || type === 'search') self.showResults(results.features, params.text);
                // Fire event
                self.fire('results', {
                    results: results,
                    endpoint: endpoint,
                    requestType: type,
                    params: params
                });
            }
        }
        $4F5LR(url, handleResponse, true);
    },
    highlight: function(text, focus) {
        var r = RegExp('(' + $3iXvL(focus) + ')', 'gi');
        return text.replace(r, '<strong>$1</strong>');
    },
    getIconType: function(layer) {
        var pointIcon = this.options.pointIcon;
        var polygonIcon = this.options.polygonIcon;
        var classPrefix = 'leaflet-pelias-layer-icon-';
        if (layer.match('venue') || layer.match('address')) {
            if (pointIcon === true) return {
                type: 'class',
                value: classPrefix + 'point'
            };
            else if (pointIcon === false) return false;
            else return {
                type: 'image',
                value: pointIcon
            };
        } else {
            if (polygonIcon === true) return {
                type: 'class',
                value: classPrefix + 'polygon'
            };
            else if (polygonIcon === false) return false;
            else return {
                type: 'image',
                value: polygonIcon
            };
        }
    },
    showResults: function(features, input) {
        // Exit function if there are no features
        if (features.length === 0) {
            this.showMessage(this.options.textStrings['NO_RESULTS']);
            return;
        }
        var resultsContainer = this._results;
        // Reset and display results container
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = 'block';
        // manage result box height
        resultsContainer.style.maxHeight = this._map.getSize().y - resultsContainer.offsetTop - this._container.offsetTop - $922a5df305ab5ff0$var$RESULTS_HEIGHT_MARGIN + 'px';
        var list = $8JYDX.DomUtil.create('ul', 'leaflet-pelias-list', resultsContainer);
        for(var i = 0, j = features.length; i < j; i++){
            var feature = features[i];
            var resultItem = $8JYDX.DomUtil.create('li', 'leaflet-pelias-result', list);
            resultItem.feature = feature;
            resultItem.layer = feature.properties.layer;
            // Deprecated
            // Use L.GeoJSON.coordsToLatLng(resultItem.feature.geometry.coordinates) instead
            // This returns a L.LatLng object that can be used throughout Leaflet
            resultItem.coords = feature.geometry.coordinates;
            var icon = this.getIconType(feature.properties.layer);
            if (icon) {
                // Point or polygon icon
                // May be a class or an image path
                var layerIconContainer = $8JYDX.DomUtil.create('span', 'leaflet-pelias-layer-icon-container', resultItem);
                var layerIcon;
                if (icon.type === 'class') layerIcon = $8JYDX.DomUtil.create('div', 'leaflet-pelias-layer-icon ' + icon.value, layerIconContainer);
                else {
                    layerIcon = $8JYDX.DomUtil.create('img', 'leaflet-pelias-layer-icon', layerIconContainer);
                    layerIcon.src = icon.value;
                }
                layerIcon.title = 'layer: ' + feature.properties.layer;
            }
            resultItem.innerHTML += this.highlight(feature.properties.label, input);
        }
    },
    showMessage: function(text) {
        var resultsContainer = this._results;
        // Reset and display results container
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = 'block';
        var messageEl = $8JYDX.DomUtil.create('div', 'leaflet-pelias-message', resultsContainer);
        // Set text. This is the most cross-browser compatible method
        // and avoids the issues we have detecting either innerText vs textContent
        // (e.g. Firefox cannot detect textContent property on elements, but it's there)
        messageEl.appendChild(document.createTextNode(text));
    },
    removeMarkers: function() {
        if (this.options.markers) {
            for(var i = 0; i < this.markers.length; i++)this._map.removeLayer(this.markers[i]);
            this.markers = [];
        }
    },
    showMarker: function(text, latlng) {
        this._map.setView(latlng, this._map.getZoom() || 8);
        var markerOptions = typeof this.options.markers === 'object' ? this.options.markers : {};
        if (this.options.markers) {
            var marker = new $8JYDX.marker(latlng, markerOptions).bindPopup(text); // eslint-disable-line new-cap
            this._map.addLayer(marker);
            this.markers.push(marker);
            marker.openPopup();
        }
    },
    /**
   * Fits the map view to a given bounding box.
   * Mapzen Search / Pelias returns the 'bbox' property on 'feature'. It is
   * as an array of four numbers:
   *   [
   *     0: southwest longitude,
   *     1: southwest latitude,
   *     2: northeast longitude,
   *     3: northeast latitude
   *   ]
   * This method expects the array to be passed directly and it will be converted
   * to a boundary parameter for Leaflet's fitBounds().
   */ fitBoundingBox: function(bbox) {
        this._map.fitBounds([
            [
                bbox[1],
                bbox[0]
            ],
            [
                bbox[3],
                bbox[2]
            ]
        ], {
            animate: true,
            maxZoom: 16
        });
    },
    setSelectedResult: function(selected, originalEvent) {
        var latlng = $8JYDX.GeoJSON.coordsToLatLng(selected.feature.geometry.coordinates);
        this._input.value = selected.textContent || selected.innerText;
        var layer = selected.feature.properties.layer;
        // "point" layers (venue and address in Pelias) must always display markers
        if (layer !== 'venue' && layer !== 'address' && selected.feature.bbox && !this.options.overrideBbox) {
            this.removeMarkers();
            this.fitBoundingBox(selected.feature.bbox);
        } else {
            this.removeMarkers();
            this.showMarker(selected.innerHTML, latlng);
        }
        this.fire('select', {
            originalEvent: originalEvent,
            latlng: latlng,
            feature: selected.feature
        });
        this.blur();
        // Not all features will be guaranteed to have `gid` property - interpolated
        // addresses, for example, cannot be retrieved with `/place` and so the `gid`
        // property for them may be dropped in the future.
        if (this.options.place && selected.feature.properties.gid) this.place(selected.feature.properties.gid);
    },
    /**
   * Convenience function for focusing on the input
   * A `focus` event is fired, but it is not fired here. An event listener
   * was added to the _input element to forward the native `focus` event.
   *
   * @public
   */ focus: function() {
        // If not expanded, expand this first
        if (!$8JYDX.DomUtil.hasClass(this._container, 'leaflet-pelias-expanded')) this.expand();
        this._input.focus();
    },
    /**
   * Removes focus from geocoder control
   * A `blur` event is fired, but it is not fired here. An event listener
   * was added on the _input element to forward the native `blur` event.
   *
   * @public
   */ blur: function() {
        this._input.blur();
        this.clearResults();
        if (this._input.value === '' && this._results.style.display !== 'none') {
            $8JYDX.DomUtil.addClass(this._reset, 'leaflet-pelias-hidden');
            if (!this.options.expanded) this.collapse();
        }
    },
    clearResults: function(force) {
        // Hide results from view
        this._results.style.display = 'none';
        // Destroy contents if input has also cleared
        // OR if force is true
        if (this._input.value === '' || force === true) this._results.innerHTML = '';
        // Turn on scrollWheelZoom, if disabled. (`mouseout` does not fire on
        // the results list when it's closed in this way.)
        this._enableMapScrollWheelZoom();
    },
    expand: function() {
        $8JYDX.DomUtil.addClass(this._container, 'leaflet-pelias-expanded');
        this.setFullWidth();
        this.fire('expand');
    },
    collapse: function() {
        // 'expanded' options check happens outside of this function now
        // So it's now possible for a script to force-collapse a geocoder
        // that otherwise defaults to the always-expanded state
        $8JYDX.DomUtil.removeClass(this._container, 'leaflet-pelias-expanded');
        this._input.blur();
        this.clearFullWidth();
        this.clearResults();
        this.fire('collapse');
    },
    // Set full width of expanded input, if enabled
    setFullWidth: function() {
        if (this.options.fullWidth) {
            // If fullWidth setting is a number, only expand if map container
            // is smaller than that breakpoint. Otherwise, clear width
            // Always ask map to invalidate and recalculate size first
            this._map.invalidateSize();
            var mapWidth = this._map.getSize().x;
            var touchAdjustment = $8JYDX.Browser.touch ? $922a5df305ab5ff0$var$FULL_WIDTH_TOUCH_ADJUSTED_MARGIN : 0;
            var width = mapWidth - $922a5df305ab5ff0$var$FULL_WIDTH_MARGIN - touchAdjustment;
            if (typeof this.options.fullWidth === 'number' && mapWidth >= window.parseInt(this.options.fullWidth, 10)) {
                this.clearFullWidth();
                return;
            }
            this._container.style.width = width.toString() + 'px';
        }
    },
    clearFullWidth: function() {
        // Clear set width, if any
        if (this.options.fullWidth) this._container.style.width = '';
    },
    onAdd: function(map) {
        var container = $8JYDX.DomUtil.create('div', 'leaflet-pelias-control leaflet-bar leaflet-control');
        this._body = document.body || document.getElementsByTagName('body')[0];
        this._container = container;
        this._input = $8JYDX.DomUtil.create('input', 'leaflet-pelias-input', this._container);
        this._input.spellcheck = false;
        // Forwards focus and blur events from input to geocoder
        $8JYDX.DomEvent.addListener(this._input, 'focus', function(e) {
            this.fire('focus', {
                originalEvent: e
            });
        }, this);
        $8JYDX.DomEvent.addListener(this._input, 'blur', function(e) {
            this.fire('blur', {
                originalEvent: e
            });
        }, this);
        // Only set if title option is not null or falsy
        if (this.options.textStrings['INPUT_TITLE_ATTRIBUTE']) this._input.title = this.options.textStrings['INPUT_TITLE_ATTRIBUTE'];
        // Only set if placeholder option is not null or falsy
        if (this.options.textStrings['INPUT_PLACEHOLDER']) this._input.placeholder = this.options.textStrings['INPUT_PLACEHOLDER'];
        this._search = $8JYDX.DomUtil.create('a', 'leaflet-pelias-search-icon', this._container);
        this._reset = $8JYDX.DomUtil.create('div', 'leaflet-pelias-close leaflet-pelias-hidden', this._container);
        this._reset.innerHTML = "\xd7";
        this._reset.title = this.options.textStrings['RESET_TITLE_ATTRIBUTE'];
        this._results = $8JYDX.DomUtil.create('div', 'leaflet-pelias-results leaflet-bar', this._container);
        if (this.options.expanded) this.expand();
        $8JYDX.DomEvent.on(this._container, 'click', function(e) {
            // Child elements with 'click' listeners should call
            // stopPropagation() to prevent that event from bubbling to
            // the container & causing it to fire too greedily
            this._input.focus();
        }, this).on(this._input, 'focus', function(e) {
            if (this._input.value && this._results.children.length) this._results.style.display = 'block';
        }, this).on(this._map, 'click', function(e) {
            // Does what you might expect a _input.blur() listener might do,
            // but since that would fire for any reason (e.g. clicking a result)
            // what you really want is to blur from the control by listening to clicks on the map
            this.blur();
        }, this).on(this._search, 'click', function(e) {
            $8JYDX.DomEvent.stopPropagation(e);
            // Toggles expanded state of container on click of search icon
            if ($8JYDX.DomUtil.hasClass(this._container, 'leaflet-pelias-expanded')) {
                // If expanded option is true, just focus the input
                if (this.options.expanded === true) this._input.focus();
                else {
                    // Otherwise, toggle to hidden state
                    $8JYDX.DomUtil.addClass(this._reset, 'leaflet-pelias-hidden');
                    this.collapse();
                }
            } else {
                // If not currently expanded, clicking here always expands it
                if (this._input.value.length > 0) $8JYDX.DomUtil.removeClass(this._reset, 'leaflet-pelias-hidden');
                this.expand();
                this._input.focus();
            }
        }, this).on(this._reset, 'click', function(e) {
            this.reset();
            this._input.focus();
            $8JYDX.DomEvent.stopPropagation(e);
        }, this).on(this._input, 'keydown', function(e) {
            var list = this._results.querySelectorAll('.leaflet-pelias-result');
            var selected = this._results.querySelectorAll('.leaflet-pelias-selected')[0];
            var selectedPosition;
            var self = this;
            var panToPoint = function(selected, options) {
                if (selected && options.panToPoint) {
                    var layer = selected.feature.properties.layer;
                    // "point" layers (venue and address in Pelias) must always display markers
                    if (layer !== 'venue' && layer !== 'address' && selected.feature.bbox && !options.overrideBbox) {
                        self.removeMarkers();
                        self.fitBoundingBox(selected.feature.bbox);
                    } else {
                        self.removeMarkers();
                        self.showMarker(selected.innerHTML, $8JYDX.GeoJSON.coordsToLatLng(selected.feature.geometry.coordinates));
                    }
                }
            };
            var scrollSelectedResultIntoView = function(selected) {
                var selectedRect = selected.getBoundingClientRect();
                var resultsRect = self._results.getBoundingClientRect();
                // Is the selected element not visible?
                if (selectedRect.bottom > resultsRect.bottom) self._results.scrollTop = selected.offsetTop + selected.offsetHeight - self._results.offsetHeight;
                else if (selectedRect.top < resultsRect.top) self._results.scrollTop = selected.offsetTop;
            };
            for(var i = 0; i < list.length; i++)if (list[i] === selected) {
                selectedPosition = i;
                break;
            }
            // TODO cleanup
            switch(e.keyCode){
                // 13 = enter
                case 13:
                    if (selected) this.setSelectedResult(selected, e);
                    else {
                        // perform a full text search on enter
                        var text = (e.target || e.srcElement).value;
                        this.search(text);
                    }
                    $8JYDX.DomEvent.preventDefault(e);
                    break;
                // 38 = up arrow
                case 38:
                    // Ignore key if there are no results or if list is not visible
                    if (list.length === 0 || this._results.style.display === 'none') return;
                    if (selected) $8JYDX.DomUtil.removeClass(selected, 'leaflet-pelias-selected');
                    var previousItem = list[selectedPosition - 1];
                    var highlighted = selected && previousItem ? previousItem : list[list.length - 1]; // eslint-disable-line no-redeclare
                    $8JYDX.DomUtil.addClass(highlighted, 'leaflet-pelias-selected');
                    scrollSelectedResultIntoView(highlighted);
                    panToPoint(highlighted, this.options);
                    this._input.value = highlighted.textContent || highlighted.innerText;
                    this.fire('highlight', {
                        originalEvent: e,
                        latlng: $8JYDX.GeoJSON.coordsToLatLng(highlighted.feature.geometry.coordinates),
                        feature: highlighted.feature
                    });
                    $8JYDX.DomEvent.preventDefault(e);
                    break;
                // 40 = down arrow
                case 40:
                    // Ignore key if there are no results or if list is not visible
                    if (list.length === 0 || this._results.style.display === 'none') return;
                    if (selected) $8JYDX.DomUtil.removeClass(selected, 'leaflet-pelias-selected');
                    var nextItem = list[selectedPosition + 1];
                    var highlighted = selected && nextItem ? nextItem : list[0]; // eslint-disable-line no-redeclare
                    $8JYDX.DomUtil.addClass(highlighted, 'leaflet-pelias-selected');
                    scrollSelectedResultIntoView(highlighted);
                    panToPoint(highlighted, this.options);
                    this._input.value = highlighted.textContent || highlighted.innerText;
                    this.fire('highlight', {
                        originalEvent: e,
                        latlng: $8JYDX.GeoJSON.coordsToLatLng(highlighted.feature.geometry.coordinates),
                        feature: highlighted.feature
                    });
                    $8JYDX.DomEvent.preventDefault(e);
                    break;
                // all other keys
                default:
                    break;
            }
        }, this).on(this._input, 'keyup', function(e) {
            var key = e.which || e.keyCode;
            var text = (e.target || e.srcElement).value;
            if (text.length > 0) $8JYDX.DomUtil.removeClass(this._reset, 'leaflet-pelias-hidden');
            else $8JYDX.DomUtil.addClass(this._reset, 'leaflet-pelias-hidden');
            // Ignore all further action if the keycode matches an arrow
            // key (handled via keydown event)
            if (key === 13 || key === 38 || key === 40) return;
            // keyCode 27 = esc key (esc should clear results)
            if (key === 27) {
                // If input is blank or results have already been cleared
                // (perhaps due to a previous 'esc') then pressing esc at
                // this point will blur from input as well.
                if (text.length === 0 || this._results.style.display === 'none') {
                    this._input.blur();
                    if (!this.options.expanded && $8JYDX.DomUtil.hasClass(this._container, 'leaflet-pelias-expanded')) this.collapse();
                }
                // Clears results
                this.clearResults(true);
                $8JYDX.DomUtil.removeClass(this._search, 'leaflet-pelias-loading');
                return;
            }
            if (text !== this._lastValue) {
                this._lastValue = text;
                if (text.length >= $922a5df305ab5ff0$var$MINIMUM_INPUT_LENGTH_FOR_AUTOCOMPLETE && this.options.autocomplete === true) this.autocomplete(text);
                else this.clearResults(true);
            }
        }, this).on(this._results, 'click', function(e) {
            $8JYDX.DomEvent.preventDefault(e);
            $8JYDX.DomEvent.stopPropagation(e);
            var _selected = this._results.querySelectorAll('.leaflet-pelias-selected')[0];
            if (_selected) $8JYDX.DomUtil.removeClass(_selected, 'leaflet-pelias-selected');
            var selected = e.target || e.srcElement; /* IE8 */ 
            var findParent = function() {
                if (!$8JYDX.DomUtil.hasClass(selected, 'leaflet-pelias-result')) {
                    selected = selected.parentElement;
                    if (selected) findParent();
                }
                return selected;
            };
            // click event can be registered on the child nodes
            // that does not have the required coords prop
            // so its important to find the parent.
            findParent();
            // If nothing is selected, (e.g. it's a message, not a result),
            // do nothing.
            if (selected) {
                $8JYDX.DomUtil.addClass(selected, 'leaflet-pelias-selected');
                this.setSelectedResult(selected, e);
            }
        }, this);
        // Recalculate width of the input bar when window resizes
        if (this.options.fullWidth) $8JYDX.DomEvent.on(window, 'resize', function(e) {
            if ($8JYDX.DomUtil.hasClass(this._container, 'leaflet-pelias-expanded')) this.setFullWidth();
        }, this);
        $8JYDX.DomEvent.on(this._results, 'mouseover', this._disableMapScrollWheelZoom, this);
        $8JYDX.DomEvent.on(this._results, 'mouseout', this._enableMapScrollWheelZoom, this);
        $8JYDX.DomEvent.on(this._map, 'mousedown', this._onMapInteraction, this);
        $8JYDX.DomEvent.on(this._map, 'touchstart', this._onMapInteraction, this);
        $8JYDX.DomEvent.disableClickPropagation(this._container);
        if (map.attributionControl) map.attributionControl.addAttribution(this.options.attribution);
        return container;
    },
    _onMapInteraction: function(event) {
        this.blur();
        // Only collapse if the input is clear, and is currently expanded.
        // Disabled if expanded is set to true
        if (!this.options.expanded) {
            if (!this._input.value && $8JYDX.DomUtil.hasClass(this._container, 'leaflet-pelias-expanded')) this.collapse();
        }
    },
    _disableMapScrollWheelZoom: function(event) {
        // Prevent scrolling over results list from zooming the map, if enabled
        this._scrollWheelZoomEnabled = this._map.scrollWheelZoom.enabled();
        if (this._scrollWheelZoomEnabled) this._map.scrollWheelZoom.disable();
    },
    _enableMapScrollWheelZoom: function(event) {
        // Re-enable scroll wheel zoom (if previously enabled) after
        // leaving the results box
        if (this._scrollWheelZoomEnabled) this._map.scrollWheelZoom.enable();
    },
    onRemove: function(map) {
        if (map.attributionControl) map.attributionControl.removeAttribution(this.options.attribution);
    }
});
module.exports = $922a5df305ab5ff0$var$Geocoder;

});
parcelRegister("1iiOo", function(module, exports) {
// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function(global) {
    'use strict';
    if (!global.console) global.console = {};
    var con = global.console;
    var prop, method;
    var dummy = function() {};
    var properties = [
        'memory'
    ];
    var methods = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(',');
    while(prop = properties.pop())if (!con[prop]) con[prop] = {};
    while(method = methods.pop())if (typeof con[method] !== 'function') con[method] = dummy;
// Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? module.exports : window);

});

parcelRegister("4F5LR", function(module, exports) {
function $364f77bd5337836b$var$corslite(url, callback, cors) {
    var sent = false;
    if (typeof window.XMLHttpRequest === 'undefined') return callback(Error('Browser not supported'));
    if (typeof cors === 'undefined') {
        var m = url.match(/^\s*https?:\/\/[^\/]*/);
        cors = m && m[0] !== location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    }
    var x = new window.XMLHttpRequest();
    function isSuccessful(status) {
        return status >= 200 && status < 300 || status === 304;
    }
    if (cors && !('withCredentials' in x)) {
        // IE8-9
        x = new window.XDomainRequest();
        // Ensure callback is never called synchronously, i.e., before
        // x.send() returns (this has been observed in the wild).
        // See https://github.com/mapbox/mapbox.js/issues/472
        var original = callback;
        callback = function() {
            if (sent) original.apply(this, arguments);
            else {
                var that = this, args = arguments;
                setTimeout(function() {
                    original.apply(that, args);
                }, 0);
            }
        };
    }
    function loaded() {
        if (// XDomainRequest
        x.status === undefined || // modern browsers
        isSuccessful(x.status)) callback.call(x, null, x);
        else callback.call(x, x, null);
    }
    // Both `onreadystatechange` and `onload` can fire. `onreadystatechange`
    // has [been supported for longer](http://stackoverflow.com/a/9181508/229001).
    if ('onload' in x) x.onload = loaded;
    else x.onreadystatechange = function readystate() {
        if (x.readyState === 4) loaded();
    };
    // Call the callback with the XMLHttpRequest object as an error and prevent
    // it from ever being called again by reassigning it to `noop`
    x.onerror = function error(evt) {
        // XDomainRequest provides no evt parameter
        callback.call(this, evt || true, null);
        callback = function() {};
    };
    // IE9 must have onprogress be set to a unique function.
    x.onprogress = function() {};
    x.ontimeout = function(evt) {
        callback.call(this, evt, null);
        callback = function() {};
    };
    x.onabort = function(evt) {
        callback.call(this, evt, null);
        callback = function() {};
    };
    // GET is the only supported HTTP Verb by XDomainRequest and is the
    // only one supported here.
    x.open('GET', url, true);
    // Send the request. Sending data is not supported.
    x.send(null);
    sent = true;
    return x;
}
module.exports = $364f77bd5337836b$var$corslite;

});

parcelRegister("dlx9g", function(module, exports) {
/*
 * throttle Utility function (borrowed from underscore)
 */ function $9b76f3171eabc923$var$throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : new Date().getTime();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function() {
        var now = new Date().getTime();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
}
module.exports = $9b76f3171eabc923$var$throttle;

});

parcelRegister("3iXvL", function(module, exports) {
/*
 * escaping a string for regex Utility function
 * from https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
 */ function $2681373ceff7ae68$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
module.exports = $2681373ceff7ae68$var$escapeRegExp;

});



var $8JYDX = parcelRequire("8JYDX");
(function(window1) {
    var HAS_HASHCHANGE = function() {
        var doc_mode = window1.documentMode;
        return 'onhashchange' in window1 && (doc_mode === undefined || doc_mode > 7);
    }();
    L.Hash = function(map) {
        this.onHashChange = L.Util.bind(this.onHashChange, this);
        if (map) this.init(map);
    };
    L.Hash.parseHash = function(hash) {
        if (hash.indexOf('#') === 0) hash = hash.substr(1);
        var args = hash.split("/");
        if (args.length == 3) {
            var zoom = parseInt(args[0], 10), lat = parseFloat(args[1]), lon = parseFloat(args[2]);
            if (isNaN(zoom) || isNaN(lat) || isNaN(lon)) return false;
            else return {
                center: new L.LatLng(lat, lon),
                zoom: zoom
            };
        } else return false;
    };
    L.Hash.formatHash = function(map) {
        var center = map.getCenter(), zoom = map.getZoom(), precision = Math.max(0, Math.ceil(Math.log(zoom) / Math.LN2));
        return "#" + [
            zoom,
            center.lat.toFixed(precision),
            center.lng.toFixed(precision)
        ].join("/");
    }, L.Hash.prototype = {
        map: null,
        lastHash: null,
        parseHash: L.Hash.parseHash,
        formatHash: L.Hash.formatHash,
        init: function(map) {
            this.map = map;
            // reset the hash
            this.lastHash = null;
            this.onHashChange();
            if (!this.isListening) this.startListening();
        },
        removeFrom: function(map) {
            if (this.changeTimeout) clearTimeout(this.changeTimeout);
            if (this.isListening) this.stopListening();
            this.map = null;
        },
        onMapMove: function() {
            // bail if we're moving the map (updating from a hash),
            // or if the map is not yet loaded
            if (this.movingMap || !this.map._loaded) return false;
            var hash = this.formatHash(this.map);
            if (this.lastHash != hash) {
                location.replace(hash);
                this.lastHash = hash;
            }
        },
        movingMap: false,
        update: function() {
            var hash = location.hash;
            if (hash === this.lastHash) return;
            var parsed = this.parseHash(hash);
            if (parsed) {
                this.movingMap = true;
                this.map.setView(parsed.center, parsed.zoom);
                this.movingMap = false;
            } else this.onMapMove(this.map);
        },
        // defer hash change updates every 100ms
        changeDefer: 100,
        changeTimeout: null,
        onHashChange: function() {
            // throttle calls to update() so that they only happen every
            // `changeDefer` ms
            if (!this.changeTimeout) {
                var that = this;
                this.changeTimeout = setTimeout(function() {
                    that.update();
                    that.changeTimeout = null;
                }, this.changeDefer);
            }
        },
        isListening: false,
        hashChangeInterval: null,
        startListening: function() {
            this.map.on("moveend", this.onMapMove, this);
            if (HAS_HASHCHANGE) L.DomEvent.addListener(window1, "hashchange", this.onHashChange);
            else {
                clearInterval(this.hashChangeInterval);
                this.hashChangeInterval = setInterval(this.onHashChange, 50);
            }
            this.isListening = true;
        },
        stopListening: function() {
            this.map.off("moveend", this.onMapMove, this);
            if (HAS_HASHCHANGE) L.DomEvent.removeListener(window1, "hashchange", this.onHashChange);
            else clearInterval(this.hashChangeInterval);
            this.isListening = false;
        }
    };
    L.hash = function(map) {
        return new L.Hash(map);
    };
    L.Map.prototype.addHash = function() {
        this._hash = L.hash(this);
    };
    L.Map.prototype.removeHash = function() {
        this._hash.removeFrom();
    };
})(window);


var $f51cba76ff40739c$exports = {};
/*
 * leaflet-geocoder-mapzen
 * Leaflet plugin to search (geocode) using Mapzen Search or your
 * own hosted version of the Pelias Geocoder API.
 *
 * License: MIT
 * (c) Mapzen
 */ 

(function(root, factory) {
    var L;
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        'leaflet'
    ], factory);
    else if ($f51cba76ff40739c$exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        L = (parcelRequire("8JYDX"));
        $f51cba76ff40739c$exports = factory(L);
    } else {
        // Browser globals (root is window)
        if (typeof root.L === 'undefined') throw new Error('Leaflet must be loaded first');
        root.Geocoder = factory(root.L);
    }
})($f51cba76ff40739c$exports, function(L) {
    'use strict';
    var Geocoder = (parcelRequire("cy2cu"));
    // Automatically attach to Leaflet's `L` namespace.
    L.Control.Geocoder = Geocoder;
    L.control.geocoder = function(apiKey, options) {
        return new L.Control.Geocoder(apiKey, options);
    };
    // Return value defines this module's export value.
    return Geocoder;
});


var $c1d2be53a502beb1$exports = {};

$parcel$export($c1d2be53a502beb1$exports, "emojiAt", () => $c1d2be53a502beb1$export$f07be9581e1b8c77, (v) => $c1d2be53a502beb1$export$f07be9581e1b8c77 = v);
$parcel$export($c1d2be53a502beb1$exports, "coordAt", () => $c1d2be53a502beb1$export$1e0c8b36e9f738fe, (v) => $c1d2be53a502beb1$export$1e0c8b36e9f738fe = v);
$parcel$export($c1d2be53a502beb1$exports, "orderFrom", () => $c1d2be53a502beb1$export$ec3ed88cf774d6fe, (v) => $c1d2be53a502beb1$export$ec3ed88cf774d6fe = v);
$parcel$export($c1d2be53a502beb1$exports, "coordFromHash", () => $c1d2be53a502beb1$export$4f2cdddb4fcb27a2, (v) => $c1d2be53a502beb1$export$4f2cdddb4fcb27a2 = v);
$parcel$export($c1d2be53a502beb1$exports, "splitEmoji", () => $c1d2be53a502beb1$export$dbb1349ff049862e, (v) => $c1d2be53a502beb1$export$dbb1349ff049862e = v);
var $c1d2be53a502beb1$export$f07be9581e1b8c77;
var $c1d2be53a502beb1$export$1e0c8b36e9f738fe;
var $c1d2be53a502beb1$export$ec3ed88cf774d6fe;
var $c1d2be53a502beb1$export$4f2cdddb4fcb27a2;
var $c1d2be53a502beb1$export$dbb1349ff049862e;
function $c1d2be53a502beb1$var$emojiSize() {
    // height, width
    return {
        height: 30,
        width: 30
    };
}
function $c1d2be53a502beb1$var$emojiBlocks() {
    return {
        "Miscellaneous Symbols and Pictographs": {
            count: 766,
            start: 0x1F300,
            missing: [
                0x1F57A,
                0x1F5A4
            ]
        },
        "Emoticons": {
            count: 80,
            start: 0x1F600,
            missing: []
        },
        "Transport and Map Symbols": {
            count: 98,
            start: 0x1F680,
            missing: [
                0x1F6D1,
                0x1F6D2,
                0x1F6D3,
                0x1F6D4,
                0x1F6D5,
                0x1F6D6,
                0x1F6D7,
                0x1F6D8,
                0x1F6D9,
                0x1F6DA,
                0x1F6DB,
                0x1F6DC,
                0x1F6DD,
                0x1F6DE,
                0x1F6DF,
                0x1F6ED,
                0x1F6EE,
                0x1F6EF,
                0x1F6F4,
                0x1F6F5,
                0x1F6F6,
                0x1F6F7,
                0x1F6F8,
                0x1F6F9,
                0x1F6FA,
                0x1F6FB,
                0x1F6FC,
                0x1F6FD,
                0x1F6FE,
                0x1F6FF
            ]
        },
        "Supplemental Symbols and Pictographs": {
            count: 15,
            start: 0x1F910,
            missing: [
                0x1F919,
                0x1F91A,
                0x1F91B,
                0x1F91C,
                0x1F91D,
                0x1F91E,
                0x1F91F,
                0x1F920,
                0x1F921,
                0x1F922,
                0x1F923,
                0x1F924,
                0x1F925,
                0x1F926,
                0x1F927,
                0x1F928,
                0x1F929,
                0x1F92A,
                0x1F92B,
                0x1F92C,
                0x1F92D,
                0x1F92E,
                0x1F92F,
                0x1F930,
                0x1F931,
                0x1F932,
                0x1F933,
                0x1F934,
                0x1F935,
                0x1F936,
                0x1F937,
                0x1F938,
                0x1F939,
                0x1F93A,
                0x1F93B,
                0x1F93C,
                0x1F93D,
                0x1F93E,
                0x1F93F,
                0x1F940,
                0x1F941,
                0x1F942,
                0x1F943,
                0x1F944,
                0x1F945,
                0x1F946,
                0x1F947,
                0x1F948,
                0x1F949,
                0x1F94A,
                0x1F94B,
                0x1F94C,
                0x1F94D,
                0x1F94E,
                0x1F94F,
                0x1F950,
                0x1F951,
                0x1F952,
                0x1F953,
                0x1F954,
                0x1F955,
                0x1F956,
                0x1F957,
                0x1F958,
                0x1F959,
                0x1F95A,
                0x1F95B,
                0x1F95C,
                0x1F95D,
                0x1F95E,
                0x1F95F,
                0x1F960,
                0x1F961,
                0x1F962,
                0x1F963,
                0x1F964,
                0x1F965,
                0x1F966,
                0x1F967,
                0x1F968,
                0x1F969,
                0x1F96A,
                0x1F96B,
                0x1F96C,
                0x1F96D,
                0x1F96E,
                0x1F96F,
                0x1F970,
                0x1F971,
                0x1F972,
                0x1F973,
                0x1F974,
                0x1F975,
                0x1F976,
                0x1F977,
                0x1F978,
                0x1F979,
                0x1F97A,
                0x1F97B,
                0x1F97C,
                0x1F97D,
                0x1F97E,
                0x1F97F,
                0x1F985,
                0x1F986,
                0x1F987,
                0x1F988,
                0x1F989,
                0x1F98A,
                0x1F98B,
                0x1F98C,
                0x1F98D,
                0x1F98E,
                0x1F98F,
                0x1F990,
                0x1F991,
                0x1F992,
                0x1F993,
                0x1F994,
                0x1F995,
                0x1F996,
                0x1F997,
                0x1F998,
                0x1F999,
                0x1F99A,
                0x1F99B,
                0x1F99C,
                0x1F99D,
                0x1F99E,
                0x1F99F,
                0x1F9A0,
                0x1F9A1,
                0x1F9A2,
                0x1F9A3,
                0x1F9A4,
                0x1F9A5,
                0x1F9A6,
                0x1F9A7,
                0x1F9A8,
                0x1F9A9,
                0x1F9AA,
                0x1F9AB,
                0x1F9AC,
                0x1F9AD,
                0x1F9AE,
                0x1F9AF,
                0x1F9B0,
                0x1F9B1,
                0x1F9B2,
                0x1F9B3,
                0x1F9B4,
                0x1F9B5,
                0x1F9B6,
                0x1F9B7,
                0x1F9B8,
                0x1F9B9,
                0x1F9BA,
                0x1F9BB,
                0x1F9BC,
                0x1F9BD,
                0x1F9BE,
                0x1F9BF
            ]
        }
    };
}
function $c1d2be53a502beb1$var$emojiSubstitutes() {
    return {
        // love hotel replaced by walking person
        [String.fromCodePoint(127977)]: String.fromCodePoint(0x1F6B6),
        // pile of poo replaced by no-walking sign
        [String.fromCodePoint(128169)]: String.fromCodePoint(0x1F6B7)
    };
}
function $c1d2be53a502beb1$var$splitEmoji(hash) {
    // Regular expression that matches emojis and other grapheme clusters
    // Alternative is to use [...hash] to split the string into an array of characters, but I dunno compatibility
    var regex = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[^[\uD800-\uDBFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])]/g;
    return hash.match(regex) || [];
}
// reference emoji
var $c1d2be53a502beb1$var$emojiAt = function(order, block) {
    // emoji blocks, in order, with start, missing blocks, and symbol length
    var eBlocks = $c1d2be53a502beb1$var$emojiBlocks();
    if (!block || !eBlocks[block]) {
        // determine overall Unicode order
        var bs = Object.keys(eBlocks);
        for(var b = 0; b < bs.length; b++){
            if (order < eBlocks[bs[b]].count) return $c1d2be53a502beb1$var$emojiAt(order, bs[b]);
            else order -= eBlocks[bs[b]].count;
        }
    } else {
        // get nth valid character within block
        var nth = eBlocks[block].start + order;
        for(var m = 0; m < eBlocks[block].missing.length; m++){
            if (eBlocks[block].missing[m] <= nth) nth++;
            else break;
        }
        return String.fromCodePoint(nth);
    }
};
var $c1d2be53a502beb1$var$coordAt = function(lat, lng, precision) {
    var emojiHeight = $c1d2be53a502beb1$var$emojiSize().height;
    var emojiWidth = $c1d2be53a502beb1$var$emojiSize().width;
    var substitutes = $c1d2be53a502beb1$var$emojiSubstitutes();
    precision = precision || 3;
    var hash = "";
    var north = 90.0;
    var south = -90;
    var east = 180.0;
    var west = -180;
    for(var i = 0; i < precision; i++){
        var latRatio = (lat - south) / (north - south);
        var lngRatio = (lng - west) / (east - west);
        var latRow = Math.floor(latRatio * emojiHeight);
        var lngColumn = Math.floor(lngRatio * emojiWidth);
        // console.log("zoom " + (i+1) + ": at " + (latRow+1) + "th row, " + (lngColumn+1) + "th column");
        // add appropriate emoji to hash
        var newc = $c1d2be53a502beb1$var$emojiAt(emojiWidth * latRow + lngColumn);
        if (substitutes[newc]) newc = substitutes[newc];
        hash += newc;
        // calculate next box of the grid
        var gridHeight = (north - south) / emojiHeight;
        var gridWidth = (east - west) / emojiWidth;
        south += gridHeight * latRow;
        north = south + gridHeight;
        west += gridWidth * lngColumn;
        east = west + gridWidth;
    }
    return hash;
};
function $c1d2be53a502beb1$var$orderFrom(emoji) {
    var codePoint = emoji.codePointAt(0);
    var eBlocks = $c1d2be53a502beb1$var$emojiBlocks();
    var globalOffset = 0; // Track total emojis from preceding blocks
    for(var block in eBlocks){
        if (codePoint >= eBlocks[block].start && codePoint < eBlocks[block].start + eBlocks[block].count + eBlocks[block].missing.length) {
            var order = codePoint - eBlocks[block].start;
            // Adjust for any missing codepoints in this block
            for(var i = 0; i < eBlocks[block].missing.length && eBlocks[block].missing[i] <= codePoint; i++)order--;
            // Return the local order PLUS the count of all previous blocks
            return globalOffset + order;
        }
        // Add this block's count to the global offset for the next iteration
        globalOffset += eBlocks[block].count;
    }
    return null;
}
function $c1d2be53a502beb1$var$coordFromHash(hash) {
    // emoji grid reference
    var emojiHeight = $c1d2be53a502beb1$var$emojiSize().height;
    var emojiWidth = $c1d2be53a502beb1$var$emojiSize().width;
    var substitutes = $c1d2be53a502beb1$var$emojiSubstitutes();
    var hash_array = $c1d2be53a502beb1$var$splitEmoji(hash);
    var precision = hash_array.length;
    var north = 90.0;
    var south = -90;
    var east = 180.0;
    var west = -180;
    for(var i = 0; i < precision; i++){
        var emoji = hash_array[i];
        // reverse substitution
        emoji = Object.keys(substitutes).find((key)=>substitutes[key] === emoji) || emoji;
        var order = $c1d2be53a502beb1$var$orderFrom(emoji);
        var latRow = Math.floor(order / emojiWidth);
        var lngColumn = order % emojiWidth;
        // calculate box of the grid
        var gridHeight = (north - south) / emojiHeight;
        var gridWidth = (east - west) / emojiWidth;
        south = south + gridHeight * latRow;
        north = south + gridHeight;
        west = west + gridWidth * lngColumn;
        east = west + gridWidth;
    }
    // Return the central point of the final box as the estimated coordinate
    var lat = (south + north) / 2;
    var lng = (west + east) / 2;
    return [
        lat,
        lng,
        precision
    ];
}
var $c1d2be53a502beb1$var$lat, $c1d2be53a502beb1$var$lng, $c1d2be53a502beb1$var$hash, $c1d2be53a502beb1$var$hash_array;
$c1d2be53a502beb1$export$f07be9581e1b8c77 = $c1d2be53a502beb1$var$emojiAt;
$c1d2be53a502beb1$export$1e0c8b36e9f738fe = $c1d2be53a502beb1$var$coordAt;
$c1d2be53a502beb1$export$ec3ed88cf774d6fe = $c1d2be53a502beb1$var$orderFrom;
$c1d2be53a502beb1$export$4f2cdddb4fcb27a2 = $c1d2be53a502beb1$var$coordFromHash;
$c1d2be53a502beb1$export$dbb1349ff049862e = $c1d2be53a502beb1$var$splitEmoji;


var $26aceb2bff6f47cf$var$__create = Object.create;
var $26aceb2bff6f47cf$var$__defProp = Object.defineProperty;
var $26aceb2bff6f47cf$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $26aceb2bff6f47cf$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $26aceb2bff6f47cf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $26aceb2bff6f47cf$var$__getProtoOf = Object.getPrototypeOf;
var $26aceb2bff6f47cf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $26aceb2bff6f47cf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $26aceb2bff6f47cf$var$__pow = Math.pow;
var $26aceb2bff6f47cf$var$__defNormalProp = (obj, key, value)=>key in obj ? $26aceb2bff6f47cf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $26aceb2bff6f47cf$var$__spreadValues = (a2, b)=>{
    for(var prop in b || (b = {}))if ($26aceb2bff6f47cf$var$__hasOwnProp.call(b, prop)) $26aceb2bff6f47cf$var$__defNormalProp(a2, prop, b[prop]);
    if ($26aceb2bff6f47cf$var$__getOwnPropSymbols) {
        for (var prop of $26aceb2bff6f47cf$var$__getOwnPropSymbols(b))if ($26aceb2bff6f47cf$var$__propIsEnum.call(b, prop)) $26aceb2bff6f47cf$var$__defNormalProp(a2, prop, b[prop]);
    }
    return a2;
};
var $26aceb2bff6f47cf$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$26aceb2bff6f47cf$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $26aceb2bff6f47cf$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $26aceb2bff6f47cf$var$__getOwnPropNames(from))if (!$26aceb2bff6f47cf$var$__hasOwnProp.call(to, key) && key !== except) $26aceb2bff6f47cf$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $26aceb2bff6f47cf$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $26aceb2bff6f47cf$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $26aceb2bff6f47cf$var$__create($26aceb2bff6f47cf$var$__getProtoOf(mod)) : {}, $26aceb2bff6f47cf$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $26aceb2bff6f47cf$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $26aceb2bff6f47cf$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step2(generator.next(value));
            } catch (e2) {
                reject(e2);
            }
        };
        var rejected = (value)=>{
            try {
                step2(generator.throw(value));
            } catch (e2) {
                reject(e2);
            }
        };
        var step2 = (x2)=>x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
        step2((generator = generator.apply(__this, __arguments)).next());
    });
};
// node_modules/@mapbox/point-geometry/index.js
var $26aceb2bff6f47cf$var$require_point_geometry = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/@mapbox/point-geometry/index.js" (exports, module) {
        "use strict";
        module.exports = Point9;
        function Point9(x2, y) {
            this.x = x2;
            this.y = y;
        }
        Point9.prototype = {
            clone: function() {
                return new Point9(this.x, this.y);
            },
            add: function(p2) {
                return this.clone()._add(p2);
            },
            sub: function(p2) {
                return this.clone()._sub(p2);
            },
            multByPoint: function(p2) {
                return this.clone()._multByPoint(p2);
            },
            divByPoint: function(p2) {
                return this.clone()._divByPoint(p2);
            },
            mult: function(k) {
                return this.clone()._mult(k);
            },
            div: function(k) {
                return this.clone()._div(k);
            },
            rotate: function(a2) {
                return this.clone()._rotate(a2);
            },
            rotateAround: function(a2, p2) {
                return this.clone()._rotateAround(a2, p2);
            },
            matMult: function(m) {
                return this.clone()._matMult(m);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(other) {
                return this.x === other.x && this.y === other.y;
            },
            dist: function(p2) {
                return Math.sqrt(this.distSqr(p2));
            },
            distSqr: function(p2) {
                var dx = p2.x - this.x, dy = p2.y - this.y;
                return dx * dx + dy * dy;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(b) {
                return Math.atan2(this.y - b.y, this.x - b.x);
            },
            angleWith: function(b) {
                return this.angleWithSep(b.x, b.y);
            },
            angleWithSep: function(x2, y) {
                return Math.atan2(this.x * y - this.y * x2, this.x * x2 + this.y * y);
            },
            _matMult: function(m) {
                var x2 = m[0] * this.x + m[1] * this.y, y = m[2] * this.x + m[3] * this.y;
                this.x = x2;
                this.y = y;
                return this;
            },
            _add: function(p2) {
                this.x += p2.x;
                this.y += p2.y;
                return this;
            },
            _sub: function(p2) {
                this.x -= p2.x;
                this.y -= p2.y;
                return this;
            },
            _mult: function(k) {
                this.x *= k;
                this.y *= k;
                return this;
            },
            _div: function(k) {
                this.x /= k;
                this.y /= k;
                return this;
            },
            _multByPoint: function(p2) {
                this.x *= p2.x;
                this.y *= p2.y;
                return this;
            },
            _divByPoint: function(p2) {
                this.x /= p2.x;
                this.y /= p2.y;
                return this;
            },
            _unit: function() {
                this._div(this.mag());
                return this;
            },
            _perp: function() {
                var y = this.y;
                this.y = this.x;
                this.x = -y;
                return this;
            },
            _rotate: function(angle) {
                var cos = Math.cos(angle), sin = Math.sin(angle), x2 = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
                this.x = x2;
                this.y = y;
                return this;
            },
            _rotateAround: function(angle, p2) {
                var cos = Math.cos(angle), sin = Math.sin(angle), x2 = p2.x + cos * (this.x - p2.x) - sin * (this.y - p2.y), y = p2.y + sin * (this.x - p2.x) + cos * (this.y - p2.y);
                this.x = x2;
                this.y = y;
                return this;
            },
            _round: function() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                return this;
            }
        };
        Point9.convert = function(a2) {
            if (a2 instanceof Point9) return a2;
            if (Array.isArray(a2)) return new Point9(a2[0], a2[1]);
            return a2;
        };
    }
});
// node_modules/@mapbox/unitbezier/index.js
var $26aceb2bff6f47cf$var$require_unitbezier = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/@mapbox/unitbezier/index.js" (exports, module) {
        module.exports = UnitBezier2;
        function UnitBezier2(p1x, p1y, p2x, p2y) {
            this.cx = 3 * p1x;
            this.bx = 3 * (p2x - p1x) - this.cx;
            this.ax = 1 - this.cx - this.bx;
            this.cy = 3 * p1y;
            this.by = 3 * (p2y - p1y) - this.cy;
            this.ay = 1 - this.cy - this.by;
            this.p1x = p1x;
            this.p1y = p2y;
            this.p2x = p2x;
            this.p2y = p2y;
        }
        UnitBezier2.prototype.sampleCurveX = function(t2) {
            return ((this.ax * t2 + this.bx) * t2 + this.cx) * t2;
        };
        UnitBezier2.prototype.sampleCurveY = function(t2) {
            return ((this.ay * t2 + this.by) * t2 + this.cy) * t2;
        };
        UnitBezier2.prototype.sampleCurveDerivativeX = function(t2) {
            return (3 * this.ax * t2 + 2 * this.bx) * t2 + this.cx;
        };
        UnitBezier2.prototype.solveCurveX = function(x2, epsilon) {
            if (typeof epsilon === "undefined") epsilon = 1e-6;
            var t0, t1, t2, x22, i3;
            for(t2 = x2, i3 = 0; i3 < 8; i3++){
                x22 = this.sampleCurveX(t2) - x2;
                if (Math.abs(x22) < epsilon) return t2;
                var d2 = this.sampleCurveDerivativeX(t2);
                if (Math.abs(d2) < 1e-6) break;
                t2 = t2 - x22 / d2;
            }
            t0 = 0;
            t1 = 1;
            t2 = x2;
            if (t2 < t0) return t0;
            if (t2 > t1) return t1;
            while(t0 < t1){
                x22 = this.sampleCurveX(t2);
                if (Math.abs(x22 - x2) < epsilon) return t2;
                if (x2 > x22) t0 = t2;
                else t1 = t2;
                t2 = (t1 - t0) * 0.5 + t0;
            }
            return t2;
        };
        UnitBezier2.prototype.solve = function(x2, epsilon) {
            return this.sampleCurveY(this.solveCurveX(x2, epsilon));
        };
    }
});
// node_modules/tinyqueue/tinyqueue.js
var $26aceb2bff6f47cf$var$require_tinyqueue = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/tinyqueue/tinyqueue.js" (exports, module) {
        (function(global, factory) {
            typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global = global || self, global.TinyQueue = factory());
        })(exports, function() {
            "use strict";
            var TinyQueue = function TinyQueue2(data, compare2) {
                if (data === void 0) data = [];
                if (compare2 === void 0) compare2 = defaultCompare;
                this.data = data;
                this.length = this.data.length;
                this.compare = compare2;
                if (this.length > 0) for(var i3 = (this.length >> 1) - 1; i3 >= 0; i3--)this._down(i3);
            };
            TinyQueue.prototype.push = function push(item) {
                this.data.push(item);
                this.length++;
                this._up(this.length - 1);
            };
            TinyQueue.prototype.pop = function pop() {
                if (this.length === 0) return void 0;
                var top = this.data[0];
                var bottom = this.data.pop();
                this.length--;
                if (this.length > 0) {
                    this.data[0] = bottom;
                    this._down(0);
                }
                return top;
            };
            TinyQueue.prototype.peek = function peek() {
                return this.data[0];
            };
            TinyQueue.prototype._up = function _up(pos) {
                var ref = this;
                var data = ref.data;
                var compare2 = ref.compare;
                var item = data[pos];
                while(pos > 0){
                    var parent = pos - 1 >> 1;
                    var current = data[parent];
                    if (compare2(item, current) >= 0) break;
                    data[pos] = current;
                    pos = parent;
                }
                data[pos] = item;
            };
            TinyQueue.prototype._down = function _down(pos) {
                var ref = this;
                var data = ref.data;
                var compare2 = ref.compare;
                var halfLength = this.length >> 1;
                var item = data[pos];
                while(pos < halfLength){
                    var left = (pos << 1) + 1;
                    var best = data[left];
                    var right = left + 1;
                    if (right < this.length && compare2(data[right], best) < 0) {
                        left = right;
                        best = data[right];
                    }
                    if (compare2(best, item) >= 0) break;
                    data[pos] = best;
                    pos = left;
                }
                data[pos] = item;
            };
            function defaultCompare(a2, b) {
                return a2 < b ? -1 : a2 > b ? 1 : 0;
            }
            return TinyQueue;
        });
    }
});
// node_modules/polylabel/polylabel.js
var $26aceb2bff6f47cf$var$require_polylabel = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/polylabel/polylabel.js" (exports, module) {
        "use strict";
        var Queue = $26aceb2bff6f47cf$var$require_tinyqueue();
        if (Queue.default) Queue = Queue.default;
        module.exports = polylabel2;
        module.exports.default = polylabel2;
        function polylabel2(polygon, precision, debug) {
            precision = precision || 1;
            var minX, minY, maxX, maxY;
            for(var i3 = 0; i3 < polygon[0].length; i3++){
                var p2 = polygon[0][i3];
                if (!i3 || p2[0] < minX) minX = p2[0];
                if (!i3 || p2[1] < minY) minY = p2[1];
                if (!i3 || p2[0] > maxX) maxX = p2[0];
                if (!i3 || p2[1] > maxY) maxY = p2[1];
            }
            var width = maxX - minX;
            var height = maxY - minY;
            var cellSize = Math.min(width, height);
            var h = cellSize / 2;
            if (cellSize === 0) {
                var degeneratePoleOfInaccessibility = [
                    minX,
                    minY
                ];
                degeneratePoleOfInaccessibility.distance = 0;
                return degeneratePoleOfInaccessibility;
            }
            var cellQueue = new Queue(void 0, compareMax);
            for(var x2 = minX; x2 < maxX; x2 += cellSize)for(var y = minY; y < maxY; y += cellSize)cellQueue.push(new Cell(x2 + h, y + h, h, polygon));
            var bestCell = getCentroidCell(polygon);
            var bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
            if (bboxCell.d > bestCell.d) bestCell = bboxCell;
            var numProbes = cellQueue.length;
            while(cellQueue.length){
                var cell = cellQueue.pop();
                if (cell.d > bestCell.d) {
                    bestCell = cell;
                    if (debug) console.log("found best %d after %d probes", Math.round(1e4 * cell.d) / 1e4, numProbes);
                }
                if (cell.max - bestCell.d <= precision) continue;
                h = cell.h / 2;
                cellQueue.push(new Cell(cell.x - h, cell.y - h, h, polygon));
                cellQueue.push(new Cell(cell.x + h, cell.y - h, h, polygon));
                cellQueue.push(new Cell(cell.x - h, cell.y + h, h, polygon));
                cellQueue.push(new Cell(cell.x + h, cell.y + h, h, polygon));
                numProbes += 4;
            }
            if (debug) {
                console.log("num probes: " + numProbes);
                console.log("best distance: " + bestCell.d);
            }
            var poleOfInaccessibility = [
                bestCell.x,
                bestCell.y
            ];
            poleOfInaccessibility.distance = bestCell.d;
            return poleOfInaccessibility;
        }
        function compareMax(a2, b) {
            return b.max - a2.max;
        }
        function Cell(x2, y, h, polygon) {
            this.x = x2;
            this.y = y;
            this.h = h;
            this.d = pointToPolygonDist(x2, y, polygon);
            this.max = this.d + this.h * Math.SQRT2;
        }
        function pointToPolygonDist(x2, y, polygon) {
            var inside = false;
            var minDistSq = Infinity;
            for(var k = 0; k < polygon.length; k++){
                var ring = polygon[k];
                for(var i3 = 0, len = ring.length, j = len - 1; i3 < len; j = i3++){
                    var a2 = ring[i3];
                    var b = ring[j];
                    if (a2[1] > y !== b[1] > y && x2 < (b[0] - a2[0]) * (y - a2[1]) / (b[1] - a2[1]) + a2[0]) inside = !inside;
                    minDistSq = Math.min(minDistSq, getSegDistSq(x2, y, a2, b));
                }
            }
            return minDistSq === 0 ? 0 : (inside ? 1 : -1) * Math.sqrt(minDistSq);
        }
        function getCentroidCell(polygon) {
            var area = 0;
            var x2 = 0;
            var y = 0;
            var points = polygon[0];
            for(var i3 = 0, len = points.length, j = len - 1; i3 < len; j = i3++){
                var a2 = points[i3];
                var b = points[j];
                var f2 = a2[0] * b[1] - b[0] * a2[1];
                x2 += (a2[0] + b[0]) * f2;
                y += (a2[1] + b[1]) * f2;
                area += f2 * 3;
            }
            if (area === 0) return new Cell(points[0][0], points[0][1], 0, polygon);
            return new Cell(x2 / area, y / area, 0, polygon);
        }
        function getSegDistSq(px, py, a2, b) {
            var x2 = a2[0];
            var y = a2[1];
            var dx = b[0] - x2;
            var dy = b[1] - y;
            if (dx !== 0 || dy !== 0) {
                var t2 = ((px - x2) * dx + (py - y) * dy) / (dx * dx + dy * dy);
                if (t2 > 1) {
                    x2 = b[0];
                    y = b[1];
                } else if (t2 > 0) {
                    x2 += dx * t2;
                    y += dy * t2;
                }
            }
            dx = px - x2;
            dy = py - y;
            return dx * dx + dy * dy;
        }
    }
});
// node_modules/@mapbox/vector-tile/lib/vectortilefeature.js
var $26aceb2bff6f47cf$var$require_vectortilefeature = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/@mapbox/vector-tile/lib/vectortilefeature.js" (exports, module) {
        "use strict";
        var Point9 = $26aceb2bff6f47cf$var$require_point_geometry();
        module.exports = VectorTileFeature;
        function VectorTileFeature(pbf, end, extent, keys, values) {
            this.properties = {};
            this.extent = extent;
            this.type = 0;
            this._pbf = pbf;
            this._geometry = -1;
            this._keys = keys;
            this._values = values;
            pbf.readFields(readFeature, this, end);
        }
        function readFeature(tag, feature, pbf) {
            if (tag == 1) feature.id = pbf.readVarint();
            else if (tag == 2) readTag(pbf, feature);
            else if (tag == 3) feature.type = pbf.readVarint();
            else if (tag == 4) feature._geometry = pbf.pos;
        }
        function readTag(pbf, feature) {
            var end = pbf.readVarint() + pbf.pos;
            while(pbf.pos < end){
                var key = feature._keys[pbf.readVarint()], value = feature._values[pbf.readVarint()];
                feature.properties[key] = value;
            }
        }
        VectorTileFeature.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        VectorTileFeature.prototype.loadGeometry = function() {
            var pbf = this._pbf;
            pbf.pos = this._geometry;
            var end = pbf.readVarint() + pbf.pos, cmd = 1, length = 0, x2 = 0, y = 0, lines = [], line;
            while(pbf.pos < end){
                if (length <= 0) {
                    var cmdLen = pbf.readVarint();
                    cmd = cmdLen & 7;
                    length = cmdLen >> 3;
                }
                length--;
                if (cmd === 1 || cmd === 2) {
                    x2 += pbf.readSVarint();
                    y += pbf.readSVarint();
                    if (cmd === 1) {
                        if (line) lines.push(line);
                        line = [];
                    }
                    line.push(new Point9(x2, y));
                } else if (cmd === 7) {
                    if (line) line.push(line[0].clone());
                } else throw new Error("unknown command " + cmd);
            }
            if (line) lines.push(line);
            return lines;
        };
        VectorTileFeature.prototype.bbox = function() {
            var pbf = this._pbf;
            pbf.pos = this._geometry;
            var end = pbf.readVarint() + pbf.pos, cmd = 1, length = 0, x2 = 0, y = 0, x1 = Infinity, x22 = -Infinity, y1 = Infinity, y2 = -Infinity;
            while(pbf.pos < end){
                if (length <= 0) {
                    var cmdLen = pbf.readVarint();
                    cmd = cmdLen & 7;
                    length = cmdLen >> 3;
                }
                length--;
                if (cmd === 1 || cmd === 2) {
                    x2 += pbf.readSVarint();
                    y += pbf.readSVarint();
                    if (x2 < x1) x1 = x2;
                    if (x2 > x22) x22 = x2;
                    if (y < y1) y1 = y;
                    if (y > y2) y2 = y;
                } else if (cmd !== 7) throw new Error("unknown command " + cmd);
            }
            return [
                x1,
                y1,
                x22,
                y2
            ];
        };
        VectorTileFeature.prototype.toGeoJSON = function(x2, y, z2) {
            var size = this.extent * Math.pow(2, z2), x0 = this.extent * x2, y0 = this.extent * y, coords = this.loadGeometry(), type = VectorTileFeature.types[this.type], i3, j;
            function project3(line) {
                for(var j2 = 0; j2 < line.length; j2++){
                    var p2 = line[j2], y2 = 180 - (p2.y + y0) * 360 / size;
                    line[j2] = [
                        (p2.x + x0) * 360 / size - 180,
                        360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var points = [];
                    for(i3 = 0; i3 < coords.length; i3++)points[i3] = coords[i3][0];
                    coords = points;
                    project3(coords);
                    break;
                case 2:
                    for(i3 = 0; i3 < coords.length; i3++)project3(coords[i3]);
                    break;
                case 3:
                    coords = classifyRings(coords);
                    for(i3 = 0; i3 < coords.length; i3++)for(j = 0; j < coords[i3].length; j++)project3(coords[i3][j]);
                    break;
            }
            if (coords.length === 1) coords = coords[0];
            else type = "Multi" + type;
            var result = {
                type: "Feature",
                geometry: {
                    type: type,
                    coordinates: coords
                },
                properties: this.properties
            };
            if ("id" in this) result.id = this.id;
            return result;
        };
        function classifyRings(rings) {
            var len = rings.length;
            if (len <= 1) return [
                rings
            ];
            var polygons = [], polygon, ccw;
            for(var i3 = 0; i3 < len; i3++){
                var area = signedArea(rings[i3]);
                if (area === 0) continue;
                if (ccw === void 0) ccw = area < 0;
                if (ccw === area < 0) {
                    if (polygon) polygons.push(polygon);
                    polygon = [
                        rings[i3]
                    ];
                } else polygon.push(rings[i3]);
            }
            if (polygon) polygons.push(polygon);
            return polygons;
        }
        function signedArea(ring) {
            var sum = 0;
            for(var i3 = 0, len = ring.length, j = len - 1, p1, p2; i3 < len; j = i3++){
                p1 = ring[i3];
                p2 = ring[j];
                sum += (p2.x - p1.x) * (p1.y + p2.y);
            }
            return sum;
        }
    }
});
// node_modules/@mapbox/vector-tile/lib/vectortilelayer.js
var $26aceb2bff6f47cf$var$require_vectortilelayer = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/@mapbox/vector-tile/lib/vectortilelayer.js" (exports, module) {
        "use strict";
        var VectorTileFeature = $26aceb2bff6f47cf$var$require_vectortilefeature();
        module.exports = VectorTileLayer;
        function VectorTileLayer(pbf, end) {
            this.version = 1;
            this.name = null;
            this.extent = 4096;
            this.length = 0;
            this._pbf = pbf;
            this._keys = [];
            this._values = [];
            this._features = [];
            pbf.readFields(readLayer, this, end);
            this.length = this._features.length;
        }
        function readLayer(tag, layer, pbf) {
            if (tag === 15) layer.version = pbf.readVarint();
            else if (tag === 1) layer.name = pbf.readString();
            else if (tag === 5) layer.extent = pbf.readVarint();
            else if (tag === 2) layer._features.push(pbf.pos);
            else if (tag === 3) layer._keys.push(pbf.readString());
            else if (tag === 4) layer._values.push(readValueMessage(pbf));
        }
        function readValueMessage(pbf) {
            var value = null, end = pbf.readVarint() + pbf.pos;
            while(pbf.pos < end){
                var tag = pbf.readVarint() >> 3;
                value = tag === 1 ? pbf.readString() : tag === 2 ? pbf.readFloat() : tag === 3 ? pbf.readDouble() : tag === 4 ? pbf.readVarint64() : tag === 5 ? pbf.readVarint() : tag === 6 ? pbf.readSVarint() : tag === 7 ? pbf.readBoolean() : null;
            }
            return value;
        }
        VectorTileLayer.prototype.feature = function(i3) {
            if (i3 < 0 || i3 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[i3];
            var end = this._pbf.readVarint() + this._pbf.pos;
            return new VectorTileFeature(this._pbf, end, this.extent, this._keys, this._values);
        };
    }
});
// node_modules/@mapbox/vector-tile/lib/vectortile.js
var $26aceb2bff6f47cf$var$require_vectortile = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/@mapbox/vector-tile/lib/vectortile.js" (exports, module) {
        "use strict";
        var VectorTileLayer = $26aceb2bff6f47cf$var$require_vectortilelayer();
        module.exports = VectorTile2;
        function VectorTile2(pbf, end) {
            this.layers = pbf.readFields(readTile, {}, end);
        }
        function readTile(tag, layers, pbf) {
            if (tag === 3) {
                var layer = new VectorTileLayer(pbf, pbf.readVarint() + pbf.pos);
                if (layer.length) layers[layer.name] = layer;
            }
        }
    }
});
// node_modules/@mapbox/vector-tile/index.js
var $26aceb2bff6f47cf$var$require_vector_tile = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/@mapbox/vector-tile/index.js" (exports, module) {
        module.exports.VectorTile = $26aceb2bff6f47cf$var$require_vectortile();
        module.exports.VectorTileFeature = $26aceb2bff6f47cf$var$require_vectortilefeature();
        module.exports.VectorTileLayer = $26aceb2bff6f47cf$var$require_vectortilelayer();
    }
});
// node_modules/ieee754/index.js
var $26aceb2bff6f47cf$var$require_ieee754 = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/ieee754/index.js" (exports) {
        exports.read = function(buffer, offset, isLE, mLen, nBytes) {
            var e2, m;
            var eLen = nBytes * 8 - mLen - 1;
            var eMax = (1 << eLen) - 1;
            var eBias = eMax >> 1;
            var nBits = -7;
            var i3 = isLE ? nBytes - 1 : 0;
            var d = isLE ? -1 : 1;
            var s2 = buffer[offset + i3];
            i3 += d;
            e2 = s2 & (1 << -nBits) - 1;
            s2 >>= -nBits;
            nBits += eLen;
            for(; nBits > 0; e2 = e2 * 256 + buffer[offset + i3], i3 += d, nBits -= 8);
            m = e2 & (1 << -nBits) - 1;
            e2 >>= -nBits;
            nBits += mLen;
            for(; nBits > 0; m = m * 256 + buffer[offset + i3], i3 += d, nBits -= 8);
            if (e2 === 0) e2 = 1 - eBias;
            else if (e2 === eMax) return m ? NaN : (s2 ? -1 : 1) * Infinity;
            else {
                m = m + Math.pow(2, mLen);
                e2 = e2 - eBias;
            }
            return (s2 ? -1 : 1) * m * Math.pow(2, e2 - mLen);
        };
        exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
            var e2, m, c2;
            var eLen = nBytes * 8 - mLen - 1;
            var eMax = (1 << eLen) - 1;
            var eBias = eMax >> 1;
            var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
            var i3 = isLE ? 0 : nBytes - 1;
            var d = isLE ? 1 : -1;
            var s2 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
            value = Math.abs(value);
            if (isNaN(value) || value === Infinity) {
                m = isNaN(value) ? 1 : 0;
                e2 = eMax;
            } else {
                e2 = Math.floor(Math.log(value) / Math.LN2);
                if (value * (c2 = Math.pow(2, -e2)) < 1) {
                    e2--;
                    c2 *= 2;
                }
                if (e2 + eBias >= 1) value += rt / c2;
                else value += rt * Math.pow(2, 1 - eBias);
                if (value * c2 >= 2) {
                    e2++;
                    c2 /= 2;
                }
                if (e2 + eBias >= eMax) {
                    m = 0;
                    e2 = eMax;
                } else if (e2 + eBias >= 1) {
                    m = (value * c2 - 1) * Math.pow(2, mLen);
                    e2 = e2 + eBias;
                } else {
                    m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                    e2 = 0;
                }
            }
            for(; mLen >= 8; buffer[offset + i3] = m & 255, i3 += d, m /= 256, mLen -= 8);
            e2 = e2 << mLen | m;
            eLen += mLen;
            for(; eLen > 0; buffer[offset + i3] = e2 & 255, i3 += d, e2 /= 256, eLen -= 8);
            buffer[offset + i3 - d] |= s2 * 128;
        };
    }
});
// node_modules/pbf/index.js
var $26aceb2bff6f47cf$var$require_pbf = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/pbf/index.js" (exports, module) {
        "use strict";
        module.exports = Pbf;
        var ieee754 = $26aceb2bff6f47cf$var$require_ieee754();
        function Pbf(buf) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
            this.pos = 0;
            this.type = 0;
            this.length = this.buf.length;
        }
        Pbf.Varint = 0;
        Pbf.Fixed64 = 1;
        Pbf.Bytes = 2;
        Pbf.Fixed32 = 5;
        var SHIFT_LEFT_32 = 4294967296;
        var SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;
        var TEXT_DECODER_MIN_LENGTH = 12;
        var utf8TextDecoder = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf8");
        Pbf.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(readField, result, end) {
                end = end || this.length;
                while(this.pos < end){
                    var val = this.readVarint(), tag = val >> 3, startPos = this.pos;
                    this.type = val & 7;
                    readField(tag, result, this);
                    if (this.pos === startPos) this.skip(val);
                }
                return result;
            },
            readMessage: function(readField, result) {
                return this.readFields(readField, result, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var val = readUInt32(this.buf, this.pos);
                this.pos += 4;
                return val;
            },
            readSFixed32: function() {
                var val = readInt32(this.buf, this.pos);
                this.pos += 4;
                return val;
            },
            readFixed64: function() {
                var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
                this.pos += 8;
                return val;
            },
            readSFixed64: function() {
                var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
                this.pos += 8;
                return val;
            },
            readFloat: function() {
                var val = ieee754.read(this.buf, this.pos, true, 23, 4);
                this.pos += 4;
                return val;
            },
            readDouble: function() {
                var val = ieee754.read(this.buf, this.pos, true, 52, 8);
                this.pos += 8;
                return val;
            },
            readVarint: function(isSigned) {
                var buf = this.buf, val, b;
                b = buf[this.pos++];
                val = b & 127;
                if (b < 128) return val;
                b = buf[this.pos++];
                val |= (b & 127) << 7;
                if (b < 128) return val;
                b = buf[this.pos++];
                val |= (b & 127) << 14;
                if (b < 128) return val;
                b = buf[this.pos++];
                val |= (b & 127) << 21;
                if (b < 128) return val;
                b = buf[this.pos];
                val |= (b & 15) << 28;
                return readVarintRemainder2(val, isSigned, this);
            },
            readVarint64: function() {
                return this.readVarint(true);
            },
            readSVarint: function() {
                var num = this.readVarint();
                return num % 2 === 1 ? (num + 1) / -2 : num / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var end = this.readVarint() + this.pos;
                var pos = this.pos;
                this.pos = end;
                if (end - pos >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder) return readUtf8TextDecoder(this.buf, pos, end);
                return readUtf8(this.buf, pos, end);
            },
            readBytes: function() {
                var end = this.readVarint() + this.pos, buffer = this.buf.subarray(this.pos, end);
                this.pos = end;
                return buffer;
            },
            readPackedVarint: function(arr2, isSigned) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readVarint(isSigned));
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readVarint(isSigned));
                return arr2;
            },
            readPackedSVarint: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readSVarint());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readSVarint());
                return arr2;
            },
            readPackedBoolean: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readBoolean());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readBoolean());
                return arr2;
            },
            readPackedFloat: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readFloat());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readFloat());
                return arr2;
            },
            readPackedDouble: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readDouble());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readDouble());
                return arr2;
            },
            readPackedFixed32: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readFixed32());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readFixed32());
                return arr2;
            },
            readPackedSFixed32: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readSFixed32());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readSFixed32());
                return arr2;
            },
            readPackedFixed64: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readFixed64());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readFixed64());
                return arr2;
            },
            readPackedSFixed64: function(arr2) {
                if (this.type !== Pbf.Bytes) return arr2.push(this.readSFixed64());
                var end = readPackedEnd(this);
                arr2 = arr2 || [];
                while(this.pos < end)arr2.push(this.readSFixed64());
                return arr2;
            },
            skip: function(val) {
                var type = val & 7;
                if (type === Pbf.Varint) while(this.buf[this.pos++] > 127);
                else if (type === Pbf.Bytes) this.pos = this.readVarint() + this.pos;
                else if (type === Pbf.Fixed32) this.pos += 4;
                else if (type === Pbf.Fixed64) this.pos += 8;
                else throw new Error("Unimplemented type: " + type);
            },
            writeTag: function(tag, type) {
                this.writeVarint(tag << 3 | type);
            },
            realloc: function(min) {
                var length = this.length || 16;
                while(length < this.pos + min)length *= 2;
                if (length !== this.length) {
                    var buf = new Uint8Array(length);
                    buf.set(this.buf);
                    this.buf = buf;
                    this.length = length;
                }
            },
            finish: function() {
                this.length = this.pos;
                this.pos = 0;
                return this.buf.subarray(0, this.length);
            },
            writeFixed32: function(val) {
                this.realloc(4);
                writeInt32(this.buf, val, this.pos);
                this.pos += 4;
            },
            writeSFixed32: function(val) {
                this.realloc(4);
                writeInt32(this.buf, val, this.pos);
                this.pos += 4;
            },
            writeFixed64: function(val) {
                this.realloc(8);
                writeInt32(this.buf, val & -1, this.pos);
                writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
                this.pos += 8;
            },
            writeSFixed64: function(val) {
                this.realloc(8);
                writeInt32(this.buf, val & -1, this.pos);
                writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
                this.pos += 8;
            },
            writeVarint: function(val) {
                val = +val || 0;
                if (val > 268435455 || val < 0) {
                    writeBigVarint(val, this);
                    return;
                }
                this.realloc(4);
                this.buf[this.pos++] = val & 127 | (val > 127 ? 128 : 0);
                if (val <= 127) return;
                this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
                if (val <= 127) return;
                this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
                if (val <= 127) return;
                this.buf[this.pos++] = val >>> 7 & 127;
            },
            writeSVarint: function(val) {
                this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
            },
            writeBoolean: function(val) {
                this.writeVarint(Boolean(val));
            },
            writeString: function(str) {
                str = String(str);
                this.realloc(str.length * 4);
                this.pos++;
                var startPos = this.pos;
                this.pos = writeUtf8(this.buf, str, this.pos);
                var len = this.pos - startPos;
                if (len >= 128) makeRoomForExtraLength(startPos, len, this);
                this.pos = startPos - 1;
                this.writeVarint(len);
                this.pos += len;
            },
            writeFloat: function(val) {
                this.realloc(4);
                ieee754.write(this.buf, val, this.pos, true, 23, 4);
                this.pos += 4;
            },
            writeDouble: function(val) {
                this.realloc(8);
                ieee754.write(this.buf, val, this.pos, true, 52, 8);
                this.pos += 8;
            },
            writeBytes: function(buffer) {
                var len = buffer.length;
                this.writeVarint(len);
                this.realloc(len);
                for(var i3 = 0; i3 < len; i3++)this.buf[this.pos++] = buffer[i3];
            },
            writeRawMessage: function(fn, obj) {
                this.pos++;
                var startPos = this.pos;
                fn(obj, this);
                var len = this.pos - startPos;
                if (len >= 128) makeRoomForExtraLength(startPos, len, this);
                this.pos = startPos - 1;
                this.writeVarint(len);
                this.pos += len;
            },
            writeMessage: function(tag, fn, obj) {
                this.writeTag(tag, Pbf.Bytes);
                this.writeRawMessage(fn, obj);
            },
            writePackedVarint: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedVarint, arr2);
            },
            writePackedSVarint: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedSVarint, arr2);
            },
            writePackedBoolean: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedBoolean, arr2);
            },
            writePackedFloat: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedFloat, arr2);
            },
            writePackedDouble: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedDouble, arr2);
            },
            writePackedFixed32: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedFixed32, arr2);
            },
            writePackedSFixed32: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedSFixed32, arr2);
            },
            writePackedFixed64: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedFixed64, arr2);
            },
            writePackedSFixed64: function(tag, arr2) {
                if (arr2.length) this.writeMessage(tag, writePackedSFixed64, arr2);
            },
            writeBytesField: function(tag, buffer) {
                this.writeTag(tag, Pbf.Bytes);
                this.writeBytes(buffer);
            },
            writeFixed32Field: function(tag, val) {
                this.writeTag(tag, Pbf.Fixed32);
                this.writeFixed32(val);
            },
            writeSFixed32Field: function(tag, val) {
                this.writeTag(tag, Pbf.Fixed32);
                this.writeSFixed32(val);
            },
            writeFixed64Field: function(tag, val) {
                this.writeTag(tag, Pbf.Fixed64);
                this.writeFixed64(val);
            },
            writeSFixed64Field: function(tag, val) {
                this.writeTag(tag, Pbf.Fixed64);
                this.writeSFixed64(val);
            },
            writeVarintField: function(tag, val) {
                this.writeTag(tag, Pbf.Varint);
                this.writeVarint(val);
            },
            writeSVarintField: function(tag, val) {
                this.writeTag(tag, Pbf.Varint);
                this.writeSVarint(val);
            },
            writeStringField: function(tag, str) {
                this.writeTag(tag, Pbf.Bytes);
                this.writeString(str);
            },
            writeFloatField: function(tag, val) {
                this.writeTag(tag, Pbf.Fixed32);
                this.writeFloat(val);
            },
            writeDoubleField: function(tag, val) {
                this.writeTag(tag, Pbf.Fixed64);
                this.writeDouble(val);
            },
            writeBooleanField: function(tag, val) {
                this.writeVarintField(tag, Boolean(val));
            }
        };
        function readVarintRemainder2(l2, s2, p2) {
            var buf = p2.buf, h, b;
            b = buf[p2.pos++];
            h = (b & 112) >> 4;
            if (b < 128) return toNum2(l2, h, s2);
            b = buf[p2.pos++];
            h |= (b & 127) << 3;
            if (b < 128) return toNum2(l2, h, s2);
            b = buf[p2.pos++];
            h |= (b & 127) << 10;
            if (b < 128) return toNum2(l2, h, s2);
            b = buf[p2.pos++];
            h |= (b & 127) << 17;
            if (b < 128) return toNum2(l2, h, s2);
            b = buf[p2.pos++];
            h |= (b & 127) << 24;
            if (b < 128) return toNum2(l2, h, s2);
            b = buf[p2.pos++];
            h |= (b & 1) << 31;
            if (b < 128) return toNum2(l2, h, s2);
            throw new Error("Expected varint not more than 10 bytes");
        }
        function readPackedEnd(pbf) {
            return pbf.type === Pbf.Bytes ? pbf.readVarint() + pbf.pos : pbf.pos + 1;
        }
        function toNum2(low, high, isSigned) {
            if (isSigned) return high * 4294967296 + (low >>> 0);
            return (high >>> 0) * 4294967296 + (low >>> 0);
        }
        function writeBigVarint(val, pbf) {
            var low, high;
            if (val >= 0) {
                low = val % 4294967296 | 0;
                high = val / 4294967296 | 0;
            } else {
                low = ~(-val % 4294967296);
                high = ~(-val / 4294967296);
                if (low ^ 4294967295) low = low + 1 | 0;
                else {
                    low = 0;
                    high = high + 1 | 0;
                }
            }
            if (val >= 18446744073709552e3 || val < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
            pbf.realloc(10);
            writeBigVarintLow(low, high, pbf);
            writeBigVarintHigh(high, pbf);
        }
        function writeBigVarintLow(low, high, pbf) {
            pbf.buf[pbf.pos++] = low & 127 | 128;
            low >>>= 7;
            pbf.buf[pbf.pos++] = low & 127 | 128;
            low >>>= 7;
            pbf.buf[pbf.pos++] = low & 127 | 128;
            low >>>= 7;
            pbf.buf[pbf.pos++] = low & 127 | 128;
            low >>>= 7;
            pbf.buf[pbf.pos] = low & 127;
        }
        function writeBigVarintHigh(high, pbf) {
            var lsb = (high & 7) << 4;
            pbf.buf[pbf.pos++] |= lsb | ((high >>>= 3) ? 128 : 0);
            if (!high) return;
            pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
            if (!high) return;
            pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
            if (!high) return;
            pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
            if (!high) return;
            pbf.buf[pbf.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
            if (!high) return;
            pbf.buf[pbf.pos++] = high & 127;
        }
        function makeRoomForExtraLength(startPos, len, pbf) {
            var extraLen = len <= 16383 ? 1 : len <= 2097151 ? 2 : len <= 268435455 ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));
            pbf.realloc(extraLen);
            for(var i3 = pbf.pos - 1; i3 >= startPos; i3--)pbf.buf[i3 + extraLen] = pbf.buf[i3];
        }
        function writePackedVarint(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeVarint(arr2[i3]);
        }
        function writePackedSVarint(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeSVarint(arr2[i3]);
        }
        function writePackedFloat(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeFloat(arr2[i3]);
        }
        function writePackedDouble(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeDouble(arr2[i3]);
        }
        function writePackedBoolean(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeBoolean(arr2[i3]);
        }
        function writePackedFixed32(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeFixed32(arr2[i3]);
        }
        function writePackedSFixed32(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeSFixed32(arr2[i3]);
        }
        function writePackedFixed64(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeFixed64(arr2[i3]);
        }
        function writePackedSFixed64(arr2, pbf) {
            for(var i3 = 0; i3 < arr2.length; i3++)pbf.writeSFixed64(arr2[i3]);
        }
        function readUInt32(buf, pos) {
            return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + buf[pos + 3] * 16777216;
        }
        function writeInt32(buf, val, pos) {
            buf[pos] = val;
            buf[pos + 1] = val >>> 8;
            buf[pos + 2] = val >>> 16;
            buf[pos + 3] = val >>> 24;
        }
        function readInt32(buf, pos) {
            return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + (buf[pos + 3] << 24);
        }
        function readUtf8(buf, pos, end) {
            var str = "";
            var i3 = pos;
            while(i3 < end){
                var b0 = buf[i3];
                var c2 = null;
                var bytesPerSequence = b0 > 239 ? 4 : b0 > 223 ? 3 : b0 > 191 ? 2 : 1;
                if (i3 + bytesPerSequence > end) break;
                var b1, b2, b3;
                if (bytesPerSequence === 1) {
                    if (b0 < 128) c2 = b0;
                } else if (bytesPerSequence === 2) {
                    b1 = buf[i3 + 1];
                    if ((b1 & 192) === 128) {
                        c2 = (b0 & 31) << 6 | b1 & 63;
                        if (c2 <= 127) c2 = null;
                    }
                } else if (bytesPerSequence === 3) {
                    b1 = buf[i3 + 1];
                    b2 = buf[i3 + 2];
                    if ((b1 & 192) === 128 && (b2 & 192) === 128) {
                        c2 = (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
                        if (c2 <= 2047 || c2 >= 55296 && c2 <= 57343) c2 = null;
                    }
                } else if (bytesPerSequence === 4) {
                    b1 = buf[i3 + 1];
                    b2 = buf[i3 + 2];
                    b3 = buf[i3 + 3];
                    if ((b1 & 192) === 128 && (b2 & 192) === 128 && (b3 & 192) === 128) {
                        c2 = (b0 & 15) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
                        if (c2 <= 65535 || c2 >= 1114112) c2 = null;
                    }
                }
                if (c2 === null) {
                    c2 = 65533;
                    bytesPerSequence = 1;
                } else if (c2 > 65535) {
                    c2 -= 65536;
                    str += String.fromCharCode(c2 >>> 10 & 1023 | 55296);
                    c2 = 56320 | c2 & 1023;
                }
                str += String.fromCharCode(c2);
                i3 += bytesPerSequence;
            }
            return str;
        }
        function readUtf8TextDecoder(buf, pos, end) {
            return utf8TextDecoder.decode(buf.subarray(pos, end));
        }
        function writeUtf8(buf, str, pos) {
            for(var i3 = 0, c2, lead; i3 < str.length; i3++){
                c2 = str.charCodeAt(i3);
                if (c2 > 55295 && c2 < 57344) {
                    if (lead) {
                        if (c2 < 56320) {
                            buf[pos++] = 239;
                            buf[pos++] = 191;
                            buf[pos++] = 189;
                            lead = c2;
                            continue;
                        } else {
                            c2 = lead - 55296 << 10 | c2 - 56320 | 65536;
                            lead = null;
                        }
                    } else {
                        if (c2 > 56319 || i3 + 1 === str.length) {
                            buf[pos++] = 239;
                            buf[pos++] = 191;
                            buf[pos++] = 189;
                        } else lead = c2;
                        continue;
                    }
                } else if (lead) {
                    buf[pos++] = 239;
                    buf[pos++] = 191;
                    buf[pos++] = 189;
                    lead = null;
                }
                if (c2 < 128) buf[pos++] = c2;
                else {
                    if (c2 < 2048) buf[pos++] = c2 >> 6 | 192;
                    else {
                        if (c2 < 65536) buf[pos++] = c2 >> 12 | 224;
                        else {
                            buf[pos++] = c2 >> 18 | 240;
                            buf[pos++] = c2 >> 12 & 63 | 128;
                        }
                        buf[pos++] = c2 >> 6 & 63 | 128;
                    }
                    buf[pos++] = c2 & 63 | 128;
                }
            }
            return pos;
        }
    }
});
// node_modules/rbush/rbush.min.js
var $26aceb2bff6f47cf$var$require_rbush_min = $26aceb2bff6f47cf$var$__commonJS({
    "node_modules/rbush/rbush.min.js" (exports, module) {
        !function(t2, i3) {
            "object" == typeof exports && "undefined" != typeof module ? module.exports = i3() : "function" == typeof define && define.amd ? define(i3) : (t2 = t2 || self).RBush = i3();
        }(exports, function() {
            "use strict";
            function t2(t3, r3, e3, a3, h2) {
                !function t4(n3, r4, e4, a4, h3) {
                    for(; a4 > e4;){
                        if (a4 - e4 > 600) {
                            var o3 = a4 - e4 + 1, s3 = r4 - e4 + 1, l3 = Math.log(o3), f3 = 0.5 * Math.exp(2 * l3 / 3), u3 = 0.5 * Math.sqrt(l3 * f3 * (o3 - f3) / o3) * (s3 - o3 / 2 < 0 ? -1 : 1), m2 = Math.max(e4, Math.floor(r4 - s3 * f3 / o3 + u3)), c3 = Math.min(a4, Math.floor(r4 + (o3 - s3) * f3 / o3 + u3));
                            t4(n3, r4, m2, c3, h3);
                        }
                        var p3 = n3[r4], d2 = e4, x2 = a4;
                        for(i3(n3, e4, r4), h3(n3[a4], p3) > 0 && i3(n3, e4, a4); d2 < x2;){
                            for(i3(n3, d2, x2), d2++, x2--; h3(n3[d2], p3) < 0;)d2++;
                            for(; h3(n3[x2], p3) > 0;)x2--;
                        }
                        0 === h3(n3[e4], p3) ? i3(n3, e4, x2) : i3(n3, ++x2, a4), x2 <= r4 && (e4 = x2 + 1), r4 <= x2 && (a4 = x2 - 1);
                    }
                }(t3, r3, e3 || 0, a3 || t3.length - 1, h2 || n2);
            }
            function i3(t3, i4, n3) {
                var r3 = t3[i4];
                t3[i4] = t3[n3], t3[n3] = r3;
            }
            function n2(t3, i4) {
                return t3 < i4 ? -1 : t3 > i4 ? 1 : 0;
            }
            var r2 = function(t3) {
                void 0 === t3 && (t3 = 9), this._maxEntries = Math.max(4, t3), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
            };
            function e2(t3, i4, n3) {
                if (!n3) return i4.indexOf(t3);
                for(var r3 = 0; r3 < i4.length; r3++)if (n3(t3, i4[r3])) return r3;
                return -1;
            }
            function a2(t3, i4) {
                h(t3, 0, t3.children.length, i4, t3);
            }
            function h(t3, i4, n3, r3, e3) {
                e3 || (e3 = p2(null)), e3.minX = 1 / 0, e3.minY = 1 / 0, e3.maxX = -1 / 0, e3.maxY = -1 / 0;
                for(var a3 = i4; a3 < n3; a3++){
                    var h2 = t3.children[a3];
                    o2(e3, t3.leaf ? r3(h2) : h2);
                }
                return e3;
            }
            function o2(t3, i4) {
                return t3.minX = Math.min(t3.minX, i4.minX), t3.minY = Math.min(t3.minY, i4.minY), t3.maxX = Math.max(t3.maxX, i4.maxX), t3.maxY = Math.max(t3.maxY, i4.maxY), t3;
            }
            function s2(t3, i4) {
                return t3.minX - i4.minX;
            }
            function l2(t3, i4) {
                return t3.minY - i4.minY;
            }
            function f2(t3) {
                return (t3.maxX - t3.minX) * (t3.maxY - t3.minY);
            }
            function u2(t3) {
                return t3.maxX - t3.minX + (t3.maxY - t3.minY);
            }
            function m(t3, i4) {
                return t3.minX <= i4.minX && t3.minY <= i4.minY && i4.maxX <= t3.maxX && i4.maxY <= t3.maxY;
            }
            function c2(t3, i4) {
                return i4.minX <= t3.maxX && i4.minY <= t3.maxY && i4.maxX >= t3.minX && i4.maxY >= t3.minY;
            }
            function p2(t3) {
                return {
                    children: t3,
                    height: 1,
                    leaf: true,
                    minX: 1 / 0,
                    minY: 1 / 0,
                    maxX: -1 / 0,
                    maxY: -1 / 0
                };
            }
            function d(i4, n3, r3, e3, a3) {
                for(var h2 = [
                    n3,
                    r3
                ]; h2.length;)if (!((r3 = h2.pop()) - (n3 = h2.pop()) <= e3)) {
                    var o3 = n3 + Math.ceil((r3 - n3) / e3 / 2) * e3;
                    t2(i4, o3, n3, r3, a3), h2.push(n3, o3, o3, r3);
                }
            }
            return r2.prototype.all = function() {
                return this._all(this.data, []);
            }, r2.prototype.search = function(t3) {
                var i4 = this.data, n3 = [];
                if (!c2(t3, i4)) return n3;
                for(var r3 = this.toBBox, e3 = []; i4;){
                    for(var a3 = 0; a3 < i4.children.length; a3++){
                        var h2 = i4.children[a3], o3 = i4.leaf ? r3(h2) : h2;
                        c2(t3, o3) && (i4.leaf ? n3.push(h2) : m(t3, o3) ? this._all(h2, n3) : e3.push(h2));
                    }
                    i4 = e3.pop();
                }
                return n3;
            }, r2.prototype.collides = function(t3) {
                var i4 = this.data;
                if (!c2(t3, i4)) return false;
                for(var n3 = []; i4;){
                    for(var r3 = 0; r3 < i4.children.length; r3++){
                        var e3 = i4.children[r3], a3 = i4.leaf ? this.toBBox(e3) : e3;
                        if (c2(t3, a3)) {
                            if (i4.leaf || m(t3, a3)) return true;
                            n3.push(e3);
                        }
                    }
                    i4 = n3.pop();
                }
                return false;
            }, r2.prototype.load = function(t3) {
                if (!t3 || !t3.length) return this;
                if (t3.length < this._minEntries) {
                    for(var i4 = 0; i4 < t3.length; i4++)this.insert(t3[i4]);
                    return this;
                }
                var n3 = this._build(t3.slice(), 0, t3.length - 1, 0);
                if (this.data.children.length) {
                    if (this.data.height === n3.height) this._splitRoot(this.data, n3);
                    else {
                        if (this.data.height < n3.height) {
                            var r3 = this.data;
                            this.data = n3, n3 = r3;
                        }
                        this._insert(n3, this.data.height - n3.height - 1, true);
                    }
                } else this.data = n3;
                return this;
            }, r2.prototype.insert = function(t3) {
                return t3 && this._insert(t3, this.data.height - 1), this;
            }, r2.prototype.clear = function() {
                return this.data = p2([]), this;
            }, r2.prototype.remove = function(t3, i4) {
                if (!t3) return this;
                for(var n3, r3, a3, h2 = this.data, o3 = this.toBBox(t3), s3 = [], l3 = []; h2 || s3.length;){
                    if (h2 || (h2 = s3.pop(), r3 = s3[s3.length - 1], n3 = l3.pop(), a3 = true), h2.leaf) {
                        var f3 = e2(t3, h2.children, i4);
                        if (-1 !== f3) return h2.children.splice(f3, 1), s3.push(h2), this._condense(s3), this;
                    }
                    a3 || h2.leaf || !m(h2, o3) ? r3 ? (n3++, h2 = r3.children[n3], a3 = false) : h2 = null : (s3.push(h2), l3.push(n3), n3 = 0, r3 = h2, h2 = h2.children[0]);
                }
                return this;
            }, r2.prototype.toBBox = function(t3) {
                return t3;
            }, r2.prototype.compareMinX = function(t3, i4) {
                return t3.minX - i4.minX;
            }, r2.prototype.compareMinY = function(t3, i4) {
                return t3.minY - i4.minY;
            }, r2.prototype.toJSON = function() {
                return this.data;
            }, r2.prototype.fromJSON = function(t3) {
                return this.data = t3, this;
            }, r2.prototype._all = function(t3, i4) {
                for(var n3 = []; t3;)t3.leaf ? i4.push.apply(i4, t3.children) : n3.push.apply(n3, t3.children), t3 = n3.pop();
                return i4;
            }, r2.prototype._build = function(t3, i4, n3, r3) {
                var e3, h2 = n3 - i4 + 1, o3 = this._maxEntries;
                if (h2 <= o3) return a2(e3 = p2(t3.slice(i4, n3 + 1)), this.toBBox), e3;
                r3 || (r3 = Math.ceil(Math.log(h2) / Math.log(o3)), o3 = Math.ceil(h2 / Math.pow(o3, r3 - 1))), (e3 = p2([])).leaf = false, e3.height = r3;
                var s3 = Math.ceil(h2 / o3), l3 = s3 * Math.ceil(Math.sqrt(o3));
                d(t3, i4, n3, l3, this.compareMinX);
                for(var f3 = i4; f3 <= n3; f3 += l3){
                    var u3 = Math.min(f3 + l3 - 1, n3);
                    d(t3, f3, u3, s3, this.compareMinY);
                    for(var m2 = f3; m2 <= u3; m2 += s3){
                        var c3 = Math.min(m2 + s3 - 1, u3);
                        e3.children.push(this._build(t3, m2, c3, r3 - 1));
                    }
                }
                return a2(e3, this.toBBox), e3;
            }, r2.prototype._chooseSubtree = function(t3, i4, n3, r3) {
                for(; r3.push(i4), !i4.leaf && r3.length - 1 !== n3;){
                    for(var e3 = 1 / 0, a3 = 1 / 0, h2 = void 0, o3 = 0; o3 < i4.children.length; o3++){
                        var s3 = i4.children[o3], l3 = f2(s3), u3 = (m2 = t3, c3 = s3, (Math.max(c3.maxX, m2.maxX) - Math.min(c3.minX, m2.minX)) * (Math.max(c3.maxY, m2.maxY) - Math.min(c3.minY, m2.minY)) - l3);
                        u3 < a3 ? (a3 = u3, e3 = l3 < e3 ? l3 : e3, h2 = s3) : u3 === a3 && l3 < e3 && (e3 = l3, h2 = s3);
                    }
                    i4 = h2 || i4.children[0];
                }
                var m2, c3;
                return i4;
            }, r2.prototype._insert = function(t3, i4, n3) {
                var r3 = n3 ? t3 : this.toBBox(t3), e3 = [], a3 = this._chooseSubtree(r3, this.data, i4, e3);
                for(a3.children.push(t3), o2(a3, r3); i4 >= 0 && e3[i4].children.length > this._maxEntries;)this._split(e3, i4), i4--;
                this._adjustParentBBoxes(r3, e3, i4);
            }, r2.prototype._split = function(t3, i4) {
                var n3 = t3[i4], r3 = n3.children.length, e3 = this._minEntries;
                this._chooseSplitAxis(n3, e3, r3);
                var h2 = this._chooseSplitIndex(n3, e3, r3), o3 = p2(n3.children.splice(h2, n3.children.length - h2));
                o3.height = n3.height, o3.leaf = n3.leaf, a2(n3, this.toBBox), a2(o3, this.toBBox), i4 ? t3[i4 - 1].children.push(o3) : this._splitRoot(n3, o3);
            }, r2.prototype._splitRoot = function(t3, i4) {
                this.data = p2([
                    t3,
                    i4
                ]), this.data.height = t3.height + 1, this.data.leaf = false, a2(this.data, this.toBBox);
            }, r2.prototype._chooseSplitIndex = function(t3, i4, n3) {
                for(var r3, e3, a3, o3, s3, l3, u3, m2 = 1 / 0, c3 = 1 / 0, p3 = i4; p3 <= n3 - i4; p3++){
                    var d2 = h(t3, 0, p3, this.toBBox), x2 = h(t3, p3, n3, this.toBBox), v = (e3 = d2, a3 = x2, o3 = void 0, s3 = void 0, l3 = void 0, u3 = void 0, o3 = Math.max(e3.minX, a3.minX), s3 = Math.max(e3.minY, a3.minY), l3 = Math.min(e3.maxX, a3.maxX), u3 = Math.min(e3.maxY, a3.maxY), Math.max(0, l3 - o3) * Math.max(0, u3 - s3)), M = f2(d2) + f2(x2);
                    v < m2 ? (m2 = v, r3 = p3, c3 = M < c3 ? M : c3) : v === m2 && M < c3 && (c3 = M, r3 = p3);
                }
                return r3 || n3 - i4;
            }, r2.prototype._chooseSplitAxis = function(t3, i4, n3) {
                var r3 = t3.leaf ? this.compareMinX : s2, e3 = t3.leaf ? this.compareMinY : l2;
                this._allDistMargin(t3, i4, n3, r3) < this._allDistMargin(t3, i4, n3, e3) && t3.children.sort(r3);
            }, r2.prototype._allDistMargin = function(t3, i4, n3, r3) {
                t3.children.sort(r3);
                for(var e3 = this.toBBox, a3 = h(t3, 0, i4, e3), s3 = h(t3, n3 - i4, n3, e3), l3 = u2(a3) + u2(s3), f3 = i4; f3 < n3 - i4; f3++){
                    var m2 = t3.children[f3];
                    o2(a3, t3.leaf ? e3(m2) : m2), l3 += u2(a3);
                }
                for(var c3 = n3 - i4 - 1; c3 >= i4; c3--){
                    var p3 = t3.children[c3];
                    o2(s3, t3.leaf ? e3(p3) : p3), l3 += u2(s3);
                }
                return l3;
            }, r2.prototype._adjustParentBBoxes = function(t3, i4, n3) {
                for(var r3 = n3; r3 >= 0; r3--)o2(i4[r3], t3);
            }, r2.prototype._condense = function(t3) {
                for(var i4 = t3.length - 1, n3 = void 0; i4 >= 0; i4--)0 === t3[i4].children.length ? i4 > 0 ? (n3 = t3[i4 - 1].children).splice(n3.indexOf(t3[i4]), 1) : this.clear() : a2(t3[i4], this.toBBox);
            }, r2;
        });
    }
});
// src/frontends/static.ts
var $26aceb2bff6f47cf$var$import_point_geometry7 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
// src/default_style/dark.ts
var $26aceb2bff6f47cf$export$55ce6f3a06c59543 = {
    earth: "#151515",
    glacier: "#1c1c1c",
    residential: "#252B2F",
    hospital: "#3E2C2C",
    cemetery: "#36483D",
    school: "#2C3440",
    industrial: "#33312C",
    wood: "#3A3E38",
    grass: "#4E604D",
    park: "#2C4034",
    water: "#4D5B73",
    sand: "#777777",
    buildings: "#464545",
    highwayCasing: "#000000",
    majorRoadCasing: "#1C1B1B",
    mediumRoadCasing: "#3E3E3E",
    minorRoadCasing: "#000000",
    highway: "#5B5B5B",
    majorRoad: "#595959",
    mediumRoad: "#4F4F4F",
    minorRoad: "#393939",
    boundaries: "#666666",
    mask: "#dddddd",
    countryLabel: "#ffffff",
    cityLabel: "#FFFFFF",
    stateLabel: "#ffffff",
    neighbourhoodLabel: "#FDFDFD",
    landuseLabel: "#DDDDDD",
    waterLabel: "#707E95",
    naturalLabel: "#4c4c4c",
    roadsLabel: "#C4C4C4",
    poisLabel: "#959393"
};
// src/default_style/light.ts
var $26aceb2bff6f47cf$export$a43af521ac8c3202 = {
    earth: "#FFFBF6",
    glacier: "#ffffff",
    residential: "#F4F4F8",
    hospital: "#FFF6F6",
    cemetery: "#EFF2EE",
    school: "#F7F6FF",
    industrial: "#FFF9EF",
    wood: "#F4F9EF",
    grass: "#EBF9E3",
    park: "#E5F9D5",
    water: "#B7DFF2",
    sand: "#ebebeb",
    buildings: "#F2EDE8",
    highwayCasing: "#FFC3C3",
    majorRoadCasing: "#FFB9B9",
    mediumRoadCasing: "#FFCE8E",
    minorRoadCasing: "#cccccc",
    highway: "#FFCEBB",
    majorRoad: "#FFE4B3",
    mediumRoad: "#FFF2C8",
    minorRoad: "#ffffff",
    boundaries: "#9e9e9e",
    mask: "#dddddd",
    countryLabel: "#aaaaaa",
    cityLabel: "#6C6C6C",
    stateLabel: "#999999",
    neighbourhoodLabel: "#888888",
    landuseLabel: "#898989",
    waterLabel: "#41ABDC",
    naturalLabel: "#4B8F14",
    roadsLabel: "#888888",
    poisLabel: "#606060"
};
// node_modules/color2k/dist/index.module.js
function $26aceb2bff6f47cf$var$t(t2, n2, r2) {
    return Math.min(Math.max(t2, r2), n2);
}
var $26aceb2bff6f47cf$var$n = class extends Error {
    constructor(t2){
        super(`Failed to parse color: "${t2}"`);
    }
};
function $26aceb2bff6f47cf$var$r(r2) {
    if ("string" != typeof r2) throw new $26aceb2bff6f47cf$var$n(r2);
    if ("transparent" === r2.trim().toLowerCase()) return [
        0,
        0,
        0,
        0
    ];
    let e2 = r2.trim();
    e2 = $26aceb2bff6f47cf$var$u.test(r2) ? function(t2) {
        const r3 = t2.toLowerCase().trim(), e3 = $26aceb2bff6f47cf$var$o[function(t3) {
            let n2 = 5381, r4 = t3.length;
            for(; r4;)n2 = 33 * n2 ^ t3.charCodeAt(--r4);
            return (n2 >>> 0) % 2341;
        }(r3)];
        if (!e3) throw new $26aceb2bff6f47cf$var$n(t2);
        return `#${e3}`;
    }(r2) : r2;
    const f2 = $26aceb2bff6f47cf$var$s.exec(e2);
    if (f2) {
        const t2 = Array.from(f2).slice(1);
        return [
            ...t2.slice(0, 3).map((t3)=>parseInt($26aceb2bff6f47cf$var$_(t3, 2), 16)),
            parseInt($26aceb2bff6f47cf$var$_(t2[3] || "f", 2), 16) / 255
        ];
    }
    const p2 = $26aceb2bff6f47cf$var$i.exec(e2);
    if (p2) {
        const t2 = Array.from(p2).slice(1);
        return [
            ...t2.slice(0, 3).map((t3)=>parseInt(t3, 16)),
            parseInt(t2[3] || "ff", 16) / 255
        ];
    }
    const z2 = $26aceb2bff6f47cf$var$a.exec(e2);
    if (z2) {
        const t2 = Array.from(z2).slice(1);
        return [
            ...t2.slice(0, 3).map((t3)=>parseInt(t3, 10)),
            parseFloat(t2[3] || "1")
        ];
    }
    const h = $26aceb2bff6f47cf$var$c.exec(e2);
    if (h) {
        const [e3, o2, _2, s2] = Array.from(h).slice(1).map(parseFloat);
        if ($26aceb2bff6f47cf$var$t(0, 100, o2) !== o2) throw new $26aceb2bff6f47cf$var$n(r2);
        if ($26aceb2bff6f47cf$var$t(0, 100, _2) !== _2) throw new $26aceb2bff6f47cf$var$n(r2);
        return [
            ...$26aceb2bff6f47cf$var$l(e3, o2, _2),
            s2 || 1
        ];
    }
    throw new $26aceb2bff6f47cf$var$n(r2);
}
var $26aceb2bff6f47cf$var$e = (t2)=>parseInt(t2.replace(/_/g, ""), 36);
var $26aceb2bff6f47cf$var$o = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((t2, n2)=>{
    const r2 = $26aceb2bff6f47cf$var$e(n2.substring(0, 3)), o2 = $26aceb2bff6f47cf$var$e(n2.substring(3)).toString(16);
    let _2 = "";
    for(let t3 = 0; t3 < 6 - o2.length; t3++)_2 += "0";
    return t2[r2] = `${_2}${o2}`, t2;
}, {});
var $26aceb2bff6f47cf$var$_ = (t2, n2)=>Array.from(Array(n2)).map(()=>t2).join("");
var $26aceb2bff6f47cf$var$s = new RegExp(`^#${$26aceb2bff6f47cf$var$_("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
var $26aceb2bff6f47cf$var$i = new RegExp(`^#${$26aceb2bff6f47cf$var$_("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
var $26aceb2bff6f47cf$var$a = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$26aceb2bff6f47cf$var$_(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
var $26aceb2bff6f47cf$var$c = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
var $26aceb2bff6f47cf$var$u = /^[a-z]+$/i;
var $26aceb2bff6f47cf$var$f = (t2)=>Math.round(255 * t2);
var $26aceb2bff6f47cf$var$l = (t2, n2, r2)=>{
    let e2 = r2 / 100;
    if (0 === n2) return [
        e2,
        e2,
        e2
    ].map($26aceb2bff6f47cf$var$f);
    const o2 = (t2 % 360 + 360) % 360 / 60, _2 = (1 - Math.abs(2 * e2 - 1)) * (n2 / 100), s2 = _2 * (1 - Math.abs(o2 % 2 - 1));
    let i3 = 0, a2 = 0, c2 = 0;
    o2 >= 0 && o2 < 1 ? (i3 = _2, a2 = s2) : o2 >= 1 && o2 < 2 ? (i3 = s2, a2 = _2) : o2 >= 2 && o2 < 3 ? (a2 = _2, c2 = s2) : o2 >= 3 && o2 < 4 ? (a2 = s2, c2 = _2) : o2 >= 4 && o2 < 5 ? (i3 = s2, c2 = _2) : o2 >= 5 && o2 < 6 && (i3 = _2, c2 = s2);
    const u2 = e2 - _2 / 2;
    return [
        i3 + u2,
        a2 + u2,
        c2 + u2
    ].map($26aceb2bff6f47cf$var$f);
};
function $26aceb2bff6f47cf$var$p(t2) {
    const [n2, e2, o2, _2] = $26aceb2bff6f47cf$var$r(t2).map((t3, n3)=>3 === n3 ? t3 : t3 / 255), s2 = Math.max(n2, e2, o2), i3 = Math.min(n2, e2, o2), a2 = (s2 + i3) / 2;
    if (s2 === i3) return [
        0,
        0,
        a2,
        _2
    ];
    const c2 = s2 - i3;
    return [
        60 * (n2 === s2 ? (e2 - o2) / c2 + (e2 < o2 ? 6 : 0) : e2 === s2 ? (o2 - n2) / c2 + 2 : (n2 - e2) / c2 + 4),
        a2 > 0.5 ? c2 / (2 - s2 - i3) : c2 / (s2 + i3),
        a2,
        _2
    ];
}
function $26aceb2bff6f47cf$var$z(n2, r2, e2, o2) {
    return `hsla(${(n2 % 360).toFixed()}, ${$26aceb2bff6f47cf$var$t(0, 100, 100 * r2).toFixed()}%, ${$26aceb2bff6f47cf$var$t(0, 100, 100 * e2).toFixed()}%, ${parseFloat($26aceb2bff6f47cf$var$t(0, 1, o2).toFixed(3))})`;
}
// src/symbolizer.ts
var $26aceb2bff6f47cf$var$import_point_geometry3 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
var $26aceb2bff6f47cf$var$import_unitbezier = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_unitbezier());
var $26aceb2bff6f47cf$var$import_polylabel = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_polylabel());
// src/attribute.ts
var $26aceb2bff6f47cf$var$StringAttr = class {
    constructor(c2, defaultValue){
        this.str = c2 != null ? c2 : defaultValue;
        this.per_feature = typeof this.str === "function" && this.str.length === 2;
    }
    get(z2, f2) {
        if (typeof this.str === "function") return this.str(z2, f2);
        return this.str;
    }
};
var $26aceb2bff6f47cf$var$NumberAttr = class {
    constructor(c2, defaultValue = 1){
        this.value = c2 != null ? c2 : defaultValue;
        this.per_feature = typeof this.value === "function" && this.value.length === 2;
    }
    get(z2, f2) {
        if (typeof this.value === "function") return this.value(z2, f2);
        return this.value;
    }
};
var $26aceb2bff6f47cf$var$TextAttr = class {
    constructor(options){
        var _a2;
        this.label_props = (_a2 = options == null ? void 0 : options.label_props) != null ? _a2 : [
            "name"
        ];
        this.textTransform = options == null ? void 0 : options.textTransform;
    }
    get(z2, f2) {
        let retval;
        let label_props;
        if (typeof this.label_props === "function") label_props = this.label_props(z2, f2);
        else label_props = this.label_props;
        for (const property of label_props)if (f2.props.hasOwnProperty(property) && typeof f2.props[property] === "string") {
            retval = f2.props[property];
            break;
        }
        let transform;
        if (typeof this.textTransform === "function") transform = this.textTransform(z2, f2);
        else transform = this.textTransform;
        if (retval && transform === "uppercase") retval = retval.toUpperCase();
        else if (retval && transform === "lowercase") retval = retval.toLowerCase();
        else if (retval && transform === "capitalize") {
            const wordsArray = retval.toLowerCase().split(" ");
            const capsArray = wordsArray.map((word)=>{
                return word[0].toUpperCase() + word.slice(1);
            });
            retval = capsArray.join(" ");
        }
        return retval;
    }
};
var $26aceb2bff6f47cf$var$FontAttr = class {
    constructor(options){
        var _a2, _b2;
        if (options == null ? void 0 : options.font) this.font = options.font;
        else {
            this.family = (_a2 = options == null ? void 0 : options.fontFamily) != null ? _a2 : "sans-serif";
            this.size = (_b2 = options == null ? void 0 : options.fontSize) != null ? _b2 : 12;
            this.weight = options == null ? void 0 : options.fontWeight;
            this.style = options == null ? void 0 : options.fontStyle;
        }
    }
    get(z2, f2) {
        if (this.font) {
            if (typeof this.font === "function") return this.font(z2, f2);
            return this.font;
        }
        let style = "";
        if (this.style) {
            if (typeof this.style === "function") style = `${this.style(z2, f2)} `;
            else style = `${this.style} `;
        }
        let weight = "";
        if (this.weight) {
            if (typeof this.weight === "function") weight = `${this.weight(z2, f2)} `;
            else weight = `${this.weight} `;
        }
        let size;
        if (typeof this.size === "function") size = this.size(z2, f2);
        else size = this.size;
        let family;
        if (typeof this.family === "function") family = this.family(z2, f2);
        else family = this.family;
        return `${style}${weight}${size}px ${family}`;
    }
};
var $26aceb2bff6f47cf$var$ArrayAttr = class {
    constructor(c2, defaultValue = []){
        this.value = c2 != null ? c2 : defaultValue;
        this.per_feature = typeof this.value === "function" && this.value.length === 2;
    }
    get(z2, f2) {
        if (typeof this.value === "function") return this.value(z2, f2);
        return this.value;
    }
};
// src/line.ts
var $26aceb2bff6f47cf$var$import_point_geometry = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
var $26aceb2bff6f47cf$var$linelabel = (pts, max_angle_delta, targetLen)=>{
    const chunks = [];
    let a2;
    let b;
    let c2;
    let i3 = 0;
    let n2 = 0;
    let d = 0;
    let abmag = 0;
    let bcmag = 0;
    let abx = 0;
    let aby = 0;
    let bcx = 0;
    let bcy = 0;
    let dt = 0;
    let i_start = 0;
    let d_start = 0;
    if (pts.length < 2) return [];
    if (pts.length === 2) {
        d = Math.sqrt($26aceb2bff6f47cf$var$__pow(pts[1].x - pts[0].x, 2) + $26aceb2bff6f47cf$var$__pow(pts[1].y - pts[0].y, 2));
        return [
            {
                length: d,
                beginIndex: 0,
                beginDistance: 0,
                endIndex: 2,
                endDistance: d
            }
        ];
    }
    abmag = Math.sqrt($26aceb2bff6f47cf$var$__pow(pts[1].x - pts[0].x, 2) + $26aceb2bff6f47cf$var$__pow(pts[1].y - pts[0].y, 2));
    for(i3 = 1, n2 = pts.length - 1; i3 < n2; i3++){
        a2 = pts[i3 - 1];
        b = pts[i3];
        c2 = pts[i3 + 1];
        abx = b.x - a2.x;
        aby = b.y - a2.y;
        bcx = c2.x - b.x;
        bcy = c2.y - b.y;
        bcmag = Math.sqrt(bcx * bcx + bcy * bcy);
        d += abmag;
        dt = Math.acos((abx * bcx + aby * bcy) / (abmag * bcmag));
        if (dt > max_angle_delta || d - d_start > targetLen) {
            chunks.push({
                length: d - d_start,
                beginDistance: d_start,
                beginIndex: i_start,
                endIndex: i3 + 1,
                endDistance: d
            });
            i_start = i3;
            d_start = d;
        }
        abmag = bcmag;
    }
    if (i3 - i_start > 0) chunks.push({
        length: d - d_start + bcmag,
        beginIndex: i_start,
        beginDistance: d_start,
        endIndex: i3 + 1,
        endDistance: d + bcmag
    });
    return chunks;
};
function $26aceb2bff6f47cf$var$simpleLabel(mls, minimum, repeatDistance, cellSize) {
    const longestLength = 0;
    const candidates = [];
    const lastLabeledDistance = -Infinity;
    for (const ls of mls){
        const segments = $26aceb2bff6f47cf$var$linelabel(ls, Math.PI / 45, minimum);
        for (const segment of segments)if (segment.length >= minimum + cellSize) {
            const start = new $26aceb2bff6f47cf$var$import_point_geometry.default(ls[segment.beginIndex].x, ls[segment.beginIndex].y);
            const end = ls[segment.endIndex - 1];
            const normalized = new $26aceb2bff6f47cf$var$import_point_geometry.default((end.x - start.x) / segment.length, (end.y - start.y) / segment.length);
            for(let i3 = cellSize; i3 < segment.length - minimum; i3 += repeatDistance)candidates.push({
                start: start.add(normalized.mult(i3)),
                end: start.add(normalized.mult(i3 + minimum))
            });
        }
    }
    return candidates;
}
function $26aceb2bff6f47cf$var$lineCells(a2, b, length, spacing) {
    const dx = b.x - a2.x;
    const dy = b.y - a2.y;
    const dist = Math.sqrt($26aceb2bff6f47cf$var$__pow(b.x - a2.x, 2) + $26aceb2bff6f47cf$var$__pow(b.y - a2.y, 2));
    const retval = [];
    for(let i3 = 0; i3 < length + spacing; i3 += 2 * spacing){
        const factor = i3 * 1 / dist;
        retval.push({
            x: a2.x + factor * dx,
            y: a2.y + factor * dy
        });
    }
    return retval;
}
// src/text.ts
function $26aceb2bff6f47cf$var$linebreak(str, maxUnits) {
    if (str.length <= maxUnits) return [
        str
    ];
    const endIndex = maxUnits - 1;
    const space_before = str.lastIndexOf(" ", endIndex);
    const space_after = str.indexOf(" ", endIndex);
    if (space_before === -1 && space_after === -1) return [
        str
    ];
    let first;
    let after;
    if (space_after === -1 || space_before >= 0 && endIndex - space_before < space_after - endIndex) {
        first = str.substring(0, space_before);
        after = str.substring(space_before + 1, str.length);
    } else {
        first = str.substring(0, space_after);
        after = str.substring(space_after + 1, str.length);
    }
    return [
        first,
        ...$26aceb2bff6f47cf$var$linebreak(after, maxUnits)
    ];
}
var $26aceb2bff6f47cf$var$CJK_CHARS = "\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DB5\u4E00-\u9FEA\uF900-\uFA6D\uFA70-\uFAD9\u2000";
var $26aceb2bff6f47cf$var$cjk_test = new RegExp(`^[${$26aceb2bff6f47cf$var$CJK_CHARS}]+$`);
// src/tilecache.ts
var $26aceb2bff6f47cf$var$import_point_geometry2 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
var $26aceb2bff6f47cf$var$import_vector_tile = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_vector_tile());
var $26aceb2bff6f47cf$var$import_pbf = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_pbf());
// node_modules/pmtiles/dist/index.mjs
var $26aceb2bff6f47cf$var$__async2 = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step2(generator.next(value));
            } catch (e2) {
                reject(e2);
            }
        };
        var rejected = (value)=>{
            try {
                step2(generator.throw(value));
            } catch (e2) {
                reject(e2);
            }
        };
        var step2 = (x2)=>x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
        step2((generator = generator.apply(__this, __arguments)).next());
    });
};
var $26aceb2bff6f47cf$var$u8 = Uint8Array;
var $26aceb2bff6f47cf$var$u16 = Uint16Array;
var $26aceb2bff6f47cf$var$u32 = Uint32Array;
var $26aceb2bff6f47cf$var$fleb = new $26aceb2bff6f47cf$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]);
var $26aceb2bff6f47cf$var$fdeb = new $26aceb2bff6f47cf$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]);
var $26aceb2bff6f47cf$var$clim = new $26aceb2bff6f47cf$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
var $26aceb2bff6f47cf$var$freb = function(eb, start) {
    var b = new $26aceb2bff6f47cf$var$u16(31);
    for(var i3 = 0; i3 < 31; ++i3)b[i3] = start += 1 << eb[i3 - 1];
    var r2 = new $26aceb2bff6f47cf$var$u32(b[30]);
    for(var i3 = 1; i3 < 30; ++i3)for(var j = b[i3]; j < b[i3 + 1]; ++j)r2[j] = j - b[i3] << 5 | i3;
    return [
        b,
        r2
    ];
};
var $26aceb2bff6f47cf$var$_a = $26aceb2bff6f47cf$var$freb($26aceb2bff6f47cf$var$fleb, 2);
var $26aceb2bff6f47cf$var$fl = $26aceb2bff6f47cf$var$_a[0];
var $26aceb2bff6f47cf$var$revfl = $26aceb2bff6f47cf$var$_a[1];
$26aceb2bff6f47cf$var$fl[28] = 258, $26aceb2bff6f47cf$var$revfl[258] = 28;
var $26aceb2bff6f47cf$var$_b = $26aceb2bff6f47cf$var$freb($26aceb2bff6f47cf$var$fdeb, 0);
var $26aceb2bff6f47cf$var$fd = $26aceb2bff6f47cf$var$_b[0];
var $26aceb2bff6f47cf$var$revfd = $26aceb2bff6f47cf$var$_b[1];
var $26aceb2bff6f47cf$var$rev = new $26aceb2bff6f47cf$var$u16(32768);
for($26aceb2bff6f47cf$var$i2 = 0; $26aceb2bff6f47cf$var$i2 < 32768; ++$26aceb2bff6f47cf$var$i2){
    $26aceb2bff6f47cf$var$x = ($26aceb2bff6f47cf$var$i2 & 43690) >>> 1 | ($26aceb2bff6f47cf$var$i2 & 21845) << 1;
    $26aceb2bff6f47cf$var$x = ($26aceb2bff6f47cf$var$x & 52428) >>> 2 | ($26aceb2bff6f47cf$var$x & 13107) << 2;
    $26aceb2bff6f47cf$var$x = ($26aceb2bff6f47cf$var$x & 61680) >>> 4 | ($26aceb2bff6f47cf$var$x & 3855) << 4;
    $26aceb2bff6f47cf$var$rev[$26aceb2bff6f47cf$var$i2] = (($26aceb2bff6f47cf$var$x & 65280) >>> 8 | ($26aceb2bff6f47cf$var$x & 255) << 8) >>> 1;
}
var $26aceb2bff6f47cf$var$x;
var $26aceb2bff6f47cf$var$i2;
var $26aceb2bff6f47cf$var$hMap = function(cd, mb, r2) {
    var s2 = cd.length;
    var i3 = 0;
    var l2 = new $26aceb2bff6f47cf$var$u16(mb);
    for(; i3 < s2; ++i3)if (cd[i3]) ++l2[cd[i3] - 1];
    var le = new $26aceb2bff6f47cf$var$u16(mb);
    for(i3 = 0; i3 < mb; ++i3)le[i3] = le[i3 - 1] + l2[i3 - 1] << 1;
    var co;
    if (r2) {
        co = new $26aceb2bff6f47cf$var$u16(1 << mb);
        var rvb = 15 - mb;
        for(i3 = 0; i3 < s2; ++i3)if (cd[i3]) {
            var sv = i3 << 4 | cd[i3];
            var r_1 = mb - cd[i3];
            var v = le[cd[i3] - 1]++ << r_1;
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)co[$26aceb2bff6f47cf$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $26aceb2bff6f47cf$var$u16(s2);
        for(i3 = 0; i3 < s2; ++i3)if (cd[i3]) co[i3] = $26aceb2bff6f47cf$var$rev[le[cd[i3] - 1]++] >>> 15 - cd[i3];
    }
    return co;
};
var $26aceb2bff6f47cf$var$flt = new $26aceb2bff6f47cf$var$u8(288);
for($26aceb2bff6f47cf$var$i2 = 0; $26aceb2bff6f47cf$var$i2 < 144; ++$26aceb2bff6f47cf$var$i2)$26aceb2bff6f47cf$var$flt[$26aceb2bff6f47cf$var$i2] = 8;
var $26aceb2bff6f47cf$var$i2;
for($26aceb2bff6f47cf$var$i2 = 144; $26aceb2bff6f47cf$var$i2 < 256; ++$26aceb2bff6f47cf$var$i2)$26aceb2bff6f47cf$var$flt[$26aceb2bff6f47cf$var$i2] = 9;
var $26aceb2bff6f47cf$var$i2;
for($26aceb2bff6f47cf$var$i2 = 256; $26aceb2bff6f47cf$var$i2 < 280; ++$26aceb2bff6f47cf$var$i2)$26aceb2bff6f47cf$var$flt[$26aceb2bff6f47cf$var$i2] = 7;
var $26aceb2bff6f47cf$var$i2;
for($26aceb2bff6f47cf$var$i2 = 280; $26aceb2bff6f47cf$var$i2 < 288; ++$26aceb2bff6f47cf$var$i2)$26aceb2bff6f47cf$var$flt[$26aceb2bff6f47cf$var$i2] = 8;
var $26aceb2bff6f47cf$var$i2;
var $26aceb2bff6f47cf$var$fdt = new $26aceb2bff6f47cf$var$u8(32);
for($26aceb2bff6f47cf$var$i2 = 0; $26aceb2bff6f47cf$var$i2 < 32; ++$26aceb2bff6f47cf$var$i2)$26aceb2bff6f47cf$var$fdt[$26aceb2bff6f47cf$var$i2] = 5;
var $26aceb2bff6f47cf$var$i2;
var $26aceb2bff6f47cf$var$flrm = /* @__PURE__ */ $26aceb2bff6f47cf$var$hMap($26aceb2bff6f47cf$var$flt, 9, 1);
var $26aceb2bff6f47cf$var$fdrm = /* @__PURE__ */ $26aceb2bff6f47cf$var$hMap($26aceb2bff6f47cf$var$fdt, 5, 1);
var $26aceb2bff6f47cf$var$max = function(a2) {
    var m = a2[0];
    for(var i3 = 1; i3 < a2.length; ++i3)if (a2[i3] > m) m = a2[i3];
    return m;
};
var $26aceb2bff6f47cf$var$bits = function(d, p2, m) {
    var o2 = p2 / 8 | 0;
    return (d[o2] | d[o2 + 1] << 8) >> (p2 & 7) & m;
};
var $26aceb2bff6f47cf$var$bits16 = function(d, p2) {
    var o2 = p2 / 8 | 0;
    return (d[o2] | d[o2 + 1] << 8 | d[o2 + 2] << 16) >> (p2 & 7);
};
var $26aceb2bff6f47cf$var$shft = function(p2) {
    return (p2 + 7) / 8 | 0;
};
var $26aceb2bff6f47cf$var$slc = function(v, s2, e2) {
    if (s2 == null || s2 < 0) s2 = 0;
    if (e2 == null || e2 > v.length) e2 = v.length;
    var n2 = new (v.BYTES_PER_ELEMENT == 2 ? $26aceb2bff6f47cf$var$u16 : v.BYTES_PER_ELEMENT == 4 ? $26aceb2bff6f47cf$var$u32 : $26aceb2bff6f47cf$var$u8)(e2 - s2);
    n2.set(v.subarray(s2, e2));
    return n2;
};
var $26aceb2bff6f47cf$var$ec = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
];
var $26aceb2bff6f47cf$var$err = function(ind, msg, nt) {
    var e2 = new Error(msg || $26aceb2bff6f47cf$var$ec[ind]);
    e2.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e2, $26aceb2bff6f47cf$var$err);
    if (!nt) throw e2;
    return e2;
};
var $26aceb2bff6f47cf$var$inflt = function(dat, buf, st) {
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new $26aceb2bff6f47cf$var$u8(0);
    var noBuf = !buf || st;
    var noSt = !st || st.i;
    if (!st) st = {};
    if (!buf) buf = new $26aceb2bff6f47cf$var$u8(sl * 3);
    var cbuf = function(l22) {
        var bl = buf.length;
        if (l22 > bl) {
            var nbuf = new $26aceb2bff6f47cf$var$u8(Math.max(bl * 2, l22));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    var tbts = sl * 8;
    do {
        if (!lm) {
            final = $26aceb2bff6f47cf$var$bits(dat, pos, 1);
            var type = $26aceb2bff6f47cf$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                var s2 = $26aceb2bff6f47cf$var$shft(pos) + 4, l2 = dat[s2 - 4] | dat[s2 - 3] << 8, t2 = s2 + l2;
                if (t2 > sl) {
                    if (noSt) $26aceb2bff6f47cf$var$err(0);
                    break;
                }
                if (noBuf) cbuf(bt + l2);
                buf.set(dat.subarray(s2, t2), bt);
                st.b = bt += l2, st.p = pos = t2 * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $26aceb2bff6f47cf$var$flrm, dm = $26aceb2bff6f47cf$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                var hLit = $26aceb2bff6f47cf$var$bits(dat, pos, 31) + 257, hcLen = $26aceb2bff6f47cf$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $26aceb2bff6f47cf$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                var ldt = new $26aceb2bff6f47cf$var$u8(tl);
                var clt = new $26aceb2bff6f47cf$var$u8(19);
                for(var i3 = 0; i3 < hcLen; ++i3)clt[$26aceb2bff6f47cf$var$clim[i3]] = $26aceb2bff6f47cf$var$bits(dat, pos + i3 * 3, 7);
                pos += hcLen * 3;
                var clb = $26aceb2bff6f47cf$var$max(clt), clbmsk = (1 << clb) - 1;
                var clm = $26aceb2bff6f47cf$var$hMap(clt, clb, 1);
                for(var i3 = 0; i3 < tl;){
                    var r2 = clm[$26aceb2bff6f47cf$var$bits(dat, pos, clbmsk)];
                    pos += r2 & 15;
                    var s2 = r2 >>> 4;
                    if (s2 < 16) ldt[i3++] = s2;
                    else {
                        var c2 = 0, n2 = 0;
                        if (s2 == 16) n2 = 3 + $26aceb2bff6f47cf$var$bits(dat, pos, 3), pos += 2, c2 = ldt[i3 - 1];
                        else if (s2 == 17) n2 = 3 + $26aceb2bff6f47cf$var$bits(dat, pos, 7), pos += 3;
                        else if (s2 == 18) n2 = 11 + $26aceb2bff6f47cf$var$bits(dat, pos, 127), pos += 7;
                        while(n2--)ldt[i3++] = c2;
                    }
                }
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                lbt = $26aceb2bff6f47cf$var$max(lt);
                dbt = $26aceb2bff6f47cf$var$max(dt);
                lm = $26aceb2bff6f47cf$var$hMap(lt, lbt, 1);
                dm = $26aceb2bff6f47cf$var$hMap(dt, dbt, 1);
            } else $26aceb2bff6f47cf$var$err(1);
            if (pos > tbts) {
                if (noSt) $26aceb2bff6f47cf$var$err(0);
                break;
            }
        }
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            var c2 = lm[$26aceb2bff6f47cf$var$bits16(dat, pos) & lms], sym = c2 >>> 4;
            pos += c2 & 15;
            if (pos > tbts) {
                if (noSt) $26aceb2bff6f47cf$var$err(0);
                break;
            }
            if (!c2) $26aceb2bff6f47cf$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                if (sym > 264) {
                    var i3 = sym - 257, b = $26aceb2bff6f47cf$var$fleb[i3];
                    add = $26aceb2bff6f47cf$var$bits(dat, pos, (1 << b) - 1) + $26aceb2bff6f47cf$var$fl[i3];
                    pos += b;
                }
                var d = dm[$26aceb2bff6f47cf$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) $26aceb2bff6f47cf$var$err(3);
                pos += d & 15;
                var dt = $26aceb2bff6f47cf$var$fd[dsym];
                if (dsym > 3) {
                    var b = $26aceb2bff6f47cf$var$fdeb[dsym];
                    dt += $26aceb2bff6f47cf$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $26aceb2bff6f47cf$var$err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $26aceb2bff6f47cf$var$slc(buf, 0, bt);
};
var $26aceb2bff6f47cf$var$et = /* @__PURE__ */ new $26aceb2bff6f47cf$var$u8(0);
var $26aceb2bff6f47cf$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $26aceb2bff6f47cf$var$err(6, "invalid gzip data");
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
var $26aceb2bff6f47cf$var$gzl = function(d) {
    var l2 = d.length;
    return (d[l2 - 4] | d[l2 - 3] << 8 | d[l2 - 2] << 16 | d[l2 - 1] << 24) >>> 0;
};
var $26aceb2bff6f47cf$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) $26aceb2bff6f47cf$var$err(6, "invalid zlib data");
    if (d[1] & 32) $26aceb2bff6f47cf$var$err(6, "invalid zlib data: preset dictionaries not supported");
};
function $26aceb2bff6f47cf$var$inflateSync(data, out) {
    return $26aceb2bff6f47cf$var$inflt(data, out);
}
function $26aceb2bff6f47cf$var$gunzipSync(data, out) {
    return $26aceb2bff6f47cf$var$inflt(data.subarray($26aceb2bff6f47cf$var$gzs(data), -8), out || new $26aceb2bff6f47cf$var$u8($26aceb2bff6f47cf$var$gzl(data)));
}
function $26aceb2bff6f47cf$var$unzlibSync(data, out) {
    return $26aceb2bff6f47cf$var$inflt(($26aceb2bff6f47cf$var$zlv(data), data.subarray(2, -4)), out);
}
function $26aceb2bff6f47cf$var$decompressSync(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $26aceb2bff6f47cf$var$gunzipSync(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $26aceb2bff6f47cf$var$inflateSync(data, out) : $26aceb2bff6f47cf$var$unzlibSync(data, out);
}
var $26aceb2bff6f47cf$var$td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
var $26aceb2bff6f47cf$var$tds = 0;
try {
    $26aceb2bff6f47cf$var$td.decode($26aceb2bff6f47cf$var$et, {
        stream: true
    });
    $26aceb2bff6f47cf$var$tds = 1;
} catch (e2) {}
var $26aceb2bff6f47cf$var$shift = (n2, shift2)=>{
    return n2 * Math.pow(2, shift2);
};
var $26aceb2bff6f47cf$var$unshift = (n2, shift2)=>{
    return Math.floor(n2 / Math.pow(2, shift2));
};
var $26aceb2bff6f47cf$var$getUint24 = (view, pos)=>{
    return $26aceb2bff6f47cf$var$shift(view.getUint16(pos + 1, true), 8) + view.getUint8(pos);
};
var $26aceb2bff6f47cf$var$getUint48 = (view, pos)=>{
    return $26aceb2bff6f47cf$var$shift(view.getUint32(pos + 2, true), 16) + view.getUint16(pos, true);
};
var $26aceb2bff6f47cf$var$compare = (tz, tx, ty, view, i3)=>{
    if (tz != view.getUint8(i3)) return tz - view.getUint8(i3);
    const x2 = $26aceb2bff6f47cf$var$getUint24(view, i3 + 1);
    if (tx != x2) return tx - x2;
    const y = $26aceb2bff6f47cf$var$getUint24(view, i3 + 4);
    if (ty != y) return ty - y;
    return 0;
};
var $26aceb2bff6f47cf$var$queryLeafdir = (view, z2, x2, y)=>{
    const offset_len = $26aceb2bff6f47cf$var$queryView(view, z2 | 128, x2, y);
    if (offset_len) return {
        z: z2,
        x: x2,
        y: y,
        offset: offset_len[0],
        length: offset_len[1],
        is_dir: true
    };
    return null;
};
var $26aceb2bff6f47cf$var$queryTile = (view, z2, x2, y)=>{
    const offset_len = $26aceb2bff6f47cf$var$queryView(view, z2, x2, y);
    if (offset_len) return {
        z: z2,
        x: x2,
        y: y,
        offset: offset_len[0],
        length: offset_len[1],
        is_dir: false
    };
    return null;
};
var $26aceb2bff6f47cf$var$queryView = (view, z2, x2, y)=>{
    let m = 0;
    let n2 = view.byteLength / 17 - 1;
    while(m <= n2){
        const k = n2 + m >> 1;
        const cmp = $26aceb2bff6f47cf$var$compare(z2, x2, y, view, k * 17);
        if (cmp > 0) m = k + 1;
        else if (cmp < 0) n2 = k - 1;
        else return [
            $26aceb2bff6f47cf$var$getUint48(view, k * 17 + 7),
            view.getUint32(k * 17 + 13, true)
        ];
    }
    return null;
};
var $26aceb2bff6f47cf$var$entrySort = (a2, b)=>{
    if (a2.is_dir && !b.is_dir) return 1;
    if (!a2.is_dir && b.is_dir) return -1;
    if (a2.z !== b.z) return a2.z - b.z;
    if (a2.x !== b.x) return a2.x - b.x;
    return a2.y - b.y;
};
var $26aceb2bff6f47cf$var$parseEntry = (dataview, i3)=>{
    const z_raw = dataview.getUint8(i3 * 17);
    const z2 = z_raw & 127;
    return {
        z: z2,
        x: $26aceb2bff6f47cf$var$getUint24(dataview, i3 * 17 + 1),
        y: $26aceb2bff6f47cf$var$getUint24(dataview, i3 * 17 + 4),
        offset: $26aceb2bff6f47cf$var$getUint48(dataview, i3 * 17 + 7),
        length: dataview.getUint32(i3 * 17 + 13, true),
        is_dir: z_raw >> 7 === 1
    };
};
var $26aceb2bff6f47cf$var$sortDir = (a2)=>{
    const entries = [];
    const view = new DataView(a2);
    for(let i3 = 0; i3 < view.byteLength / 17; i3++)entries.push($26aceb2bff6f47cf$var$parseEntry(view, i3));
    return $26aceb2bff6f47cf$var$createDirectory(entries);
};
var $26aceb2bff6f47cf$var$createDirectory = (entries)=>{
    entries.sort($26aceb2bff6f47cf$var$entrySort);
    const buffer = new ArrayBuffer(17 * entries.length);
    const arr2 = new Uint8Array(buffer);
    for(let i3 = 0; i3 < entries.length; i3++){
        const entry = entries[i3];
        let z2 = entry.z;
        if (entry.is_dir) z2 = z2 | 128;
        arr2[i3 * 17] = z2;
        arr2[i3 * 17 + 1] = entry.x & 255;
        arr2[i3 * 17 + 2] = entry.x >> 8 & 255;
        arr2[i3 * 17 + 3] = entry.x >> 16 & 255;
        arr2[i3 * 17 + 4] = entry.y & 255;
        arr2[i3 * 17 + 5] = entry.y >> 8 & 255;
        arr2[i3 * 17 + 6] = entry.y >> 16 & 255;
        arr2[i3 * 17 + 7] = entry.offset & 255;
        arr2[i3 * 17 + 8] = $26aceb2bff6f47cf$var$unshift(entry.offset, 8) & 255;
        arr2[i3 * 17 + 9] = $26aceb2bff6f47cf$var$unshift(entry.offset, 16) & 255;
        arr2[i3 * 17 + 10] = $26aceb2bff6f47cf$var$unshift(entry.offset, 24) & 255;
        arr2[i3 * 17 + 11] = $26aceb2bff6f47cf$var$unshift(entry.offset, 32) & 255;
        arr2[i3 * 17 + 12] = $26aceb2bff6f47cf$var$unshift(entry.offset, 48) & 255;
        arr2[i3 * 17 + 13] = entry.length & 255;
        arr2[i3 * 17 + 14] = entry.length >> 8 & 255;
        arr2[i3 * 17 + 15] = entry.length >> 16 & 255;
        arr2[i3 * 17 + 16] = entry.length >> 24 & 255;
    }
    return buffer;
};
var $26aceb2bff6f47cf$var$deriveLeaf = (view, tile)=>{
    if (view.byteLength < 17) return null;
    const numEntries = view.byteLength / 17;
    const entry = $26aceb2bff6f47cf$var$parseEntry(view, numEntries - 1);
    if (entry.is_dir) {
        const leaf_level = entry.z;
        const level_diff = tile.z - leaf_level;
        const leaf_x = Math.trunc(tile.x / (1 << level_diff));
        const leaf_y = Math.trunc(tile.y / (1 << level_diff));
        return {
            z: leaf_level,
            x: leaf_x,
            y: leaf_y
        };
    }
    return null;
};
function $26aceb2bff6f47cf$var$getHeader(source) {
    return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
        const resp = yield source.getBytes(0, 512e3);
        const dataview = new DataView(resp.data);
        const json_size = dataview.getUint32(4, true);
        const root_entries = dataview.getUint16(8, true);
        const dec = new TextDecoder("utf-8");
        const json_metadata = JSON.parse(dec.decode(new DataView(resp.data, 10, json_size)));
        let tile_compression = 0;
        if (json_metadata.compression === "gzip") tile_compression = 2;
        let minzoom = 0;
        if ("minzoom" in json_metadata) minzoom = +json_metadata.minzoom;
        let maxzoom = 0;
        if ("maxzoom" in json_metadata) maxzoom = +json_metadata.maxzoom;
        let center_lon = 0;
        let center_lat = 0;
        let center_zoom = 0;
        let min_lon = -180;
        let min_lat = -85;
        let max_lon = 180;
        let max_lat = 85;
        if (json_metadata.bounds) {
            const split = json_metadata.bounds.split(",");
            min_lon = +split[0];
            min_lat = +split[1];
            max_lon = +split[2];
            max_lat = +split[3];
        }
        if (json_metadata.center) {
            const split = json_metadata.center.split(",");
            center_lon = +split[0];
            center_lat = +split[1];
            center_zoom = +split[2];
        }
        const header = {
            specVersion: dataview.getUint16(2, true),
            rootDirectoryOffset: 10 + json_size,
            rootDirectoryLength: root_entries * 17,
            jsonMetadataOffset: 10,
            jsonMetadataLength: json_size,
            leafDirectoryOffset: 0,
            leafDirectoryLength: void 0,
            tileDataOffset: 0,
            tileDataLength: void 0,
            numAddressedTiles: 0,
            numTileEntries: 0,
            numTileContents: 0,
            clustered: false,
            internalCompression: 1,
            tileCompression: tile_compression,
            tileType: 1,
            minZoom: minzoom,
            maxZoom: maxzoom,
            minLon: min_lon,
            minLat: min_lat,
            maxLon: max_lon,
            maxLat: max_lat,
            centerZoom: center_zoom,
            centerLon: center_lon,
            centerLat: center_lat,
            etag: resp.etag
        };
        return header;
    });
}
function $26aceb2bff6f47cf$var$getZxy(header, source, cache, z2, x2, y, signal) {
    return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
        let root_dir = yield cache.getArrayBuffer(source, header.rootDirectoryOffset, header.rootDirectoryLength, header);
        if (header.specVersion === 1) root_dir = $26aceb2bff6f47cf$var$sortDir(root_dir);
        const entry = $26aceb2bff6f47cf$var$queryTile(new DataView(root_dir), z2, x2, y);
        if (entry) {
            const resp = yield source.getBytes(entry.offset, entry.length, signal);
            let tile_data = resp.data;
            const view = new DataView(tile_data);
            if (view.getUint8(0) == 31 && view.getUint8(1) == 139) tile_data = $26aceb2bff6f47cf$var$decompressSync(new Uint8Array(tile_data));
            return {
                data: tile_data
            };
        }
        const leafcoords = $26aceb2bff6f47cf$var$deriveLeaf(new DataView(root_dir), {
            z: z2,
            x: x2,
            y: y
        });
        if (leafcoords) {
            const leafdir_entry = $26aceb2bff6f47cf$var$queryLeafdir(new DataView(root_dir), leafcoords.z, leafcoords.x, leafcoords.y);
            if (leafdir_entry) {
                let leaf_dir = yield cache.getArrayBuffer(source, leafdir_entry.offset, leafdir_entry.length, header);
                if (header.specVersion === 1) leaf_dir = $26aceb2bff6f47cf$var$sortDir(leaf_dir);
                const tile_entry = $26aceb2bff6f47cf$var$queryTile(new DataView(leaf_dir), z2, x2, y);
                if (tile_entry) {
                    const resp = yield source.getBytes(tile_entry.offset, tile_entry.length, signal);
                    let tile_data = resp.data;
                    const view = new DataView(tile_data);
                    if (view.getUint8(0) == 31 && view.getUint8(1) == 139) tile_data = $26aceb2bff6f47cf$var$decompressSync(new Uint8Array(tile_data));
                    return {
                        data: tile_data
                    };
                }
            }
        }
        return void 0;
    });
}
var $26aceb2bff6f47cf$var$v2_default = {
    getHeader: $26aceb2bff6f47cf$var$getHeader,
    getZxy: $26aceb2bff6f47cf$var$getZxy
};
function $26aceb2bff6f47cf$var$toNum(low, high) {
    return (high >>> 0) * 4294967296 + (low >>> 0);
}
function $26aceb2bff6f47cf$var$readVarintRemainder(l2, p2) {
    const buf = p2.buf;
    let h, b;
    b = buf[p2.pos++];
    h = (b & 112) >> 4;
    if (b < 128) return $26aceb2bff6f47cf$var$toNum(l2, h);
    b = buf[p2.pos++];
    h |= (b & 127) << 3;
    if (b < 128) return $26aceb2bff6f47cf$var$toNum(l2, h);
    b = buf[p2.pos++];
    h |= (b & 127) << 10;
    if (b < 128) return $26aceb2bff6f47cf$var$toNum(l2, h);
    b = buf[p2.pos++];
    h |= (b & 127) << 17;
    if (b < 128) return $26aceb2bff6f47cf$var$toNum(l2, h);
    b = buf[p2.pos++];
    h |= (b & 127) << 24;
    if (b < 128) return $26aceb2bff6f47cf$var$toNum(l2, h);
    b = buf[p2.pos++];
    h |= (b & 1) << 31;
    if (b < 128) return $26aceb2bff6f47cf$var$toNum(l2, h);
    throw new Error("Expected varint not more than 10 bytes");
}
function $26aceb2bff6f47cf$var$readVarint(p2) {
    const buf = p2.buf;
    let val, b;
    b = buf[p2.pos++];
    val = b & 127;
    if (b < 128) return val;
    b = buf[p2.pos++];
    val |= (b & 127) << 7;
    if (b < 128) return val;
    b = buf[p2.pos++];
    val |= (b & 127) << 14;
    if (b < 128) return val;
    b = buf[p2.pos++];
    val |= (b & 127) << 21;
    if (b < 128) return val;
    b = buf[p2.pos];
    val |= (b & 15) << 28;
    return $26aceb2bff6f47cf$var$readVarintRemainder(val, p2);
}
function $26aceb2bff6f47cf$var$rotate(n2, xy, rx, ry) {
    if (ry == 0) {
        if (rx == 1) {
            xy[0] = n2 - 1 - xy[0];
            xy[1] = n2 - 1 - xy[1];
        }
        const t2 = xy[0];
        xy[0] = xy[1];
        xy[1] = t2;
    }
}
function $26aceb2bff6f47cf$var$zxyToTileId(z2, x2, y) {
    if (z2 > 26) throw Error("Tile zoom level exceeds max safe number limit (26)");
    if (x2 > Math.pow(2, z2) - 1 || y > Math.pow(2, z2) - 1) throw Error("tile x/y outside zoom level bounds");
    let acc = 0;
    let tz = 0;
    while(tz < z2){
        acc += Math.pow(2, tz) * Math.pow(2, tz);
        tz++;
    }
    const n2 = Math.pow(2, z2);
    let rx = 0;
    let ry = 0;
    let d = 0;
    const xy = [
        x2,
        y
    ];
    let s2 = n2 / 2;
    while(s2 > 0){
        rx = (xy[0] & s2) > 0 ? 1 : 0;
        ry = (xy[1] & s2) > 0 ? 1 : 0;
        d += s2 * s2 * (3 * rx ^ ry);
        $26aceb2bff6f47cf$var$rotate(s2, xy, rx, ry);
        s2 = s2 / 2;
    }
    return acc + d;
}
function $26aceb2bff6f47cf$var$fflateDecompress(buf, compression) {
    return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
        if (compression === 1 || compression === 0) return buf;
        else if (compression === 2) return $26aceb2bff6f47cf$var$decompressSync(new Uint8Array(buf));
        else throw Error("Compression method not supported");
    });
}
var $26aceb2bff6f47cf$var$HEADER_SIZE_BYTES = 127;
function $26aceb2bff6f47cf$var$findTile(entries, tileId) {
    let m = 0;
    let n2 = entries.length - 1;
    while(m <= n2){
        const k = n2 + m >> 1;
        const cmp = tileId - entries[k].tileId;
        if (cmp > 0) m = k + 1;
        else if (cmp < 0) n2 = k - 1;
        else return entries[k];
    }
    if (n2 >= 0) {
        if (entries[n2].runLength === 0) return entries[n2];
        if (tileId - entries[n2].tileId < entries[n2].runLength) return entries[n2];
    }
    return null;
}
var $26aceb2bff6f47cf$var$FetchSource = class {
    constructor(url){
        this.url = url;
    }
    getKey() {
        return this.url;
    }
    getBytes(offset, length, signal) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            let controller;
            if (!signal) {
                controller = new AbortController();
                signal = controller.signal;
            }
            let resp = yield fetch(this.url, {
                signal: signal,
                headers: {
                    Range: "bytes=" + offset + "-" + (offset + length - 1)
                }
            });
            if (resp.status === 416 && offset === 0) {
                const content_range = resp.headers.get("Content-Range");
                if (!content_range || !content_range.startsWith("bytes */")) throw Error("Missing content-length on 416 response");
                const actual_length = +content_range.substr(8);
                resp = yield fetch(this.url, {
                    signal: signal,
                    headers: {
                        Range: "bytes=0-" + (actual_length - 1)
                    }
                });
            }
            if (resp.status >= 300) throw Error("Bad response code: " + resp.status);
            const content_length = resp.headers.get("Content-Length");
            if (resp.status === 200 && (!content_length || +content_length > length)) {
                if (controller) controller.abort();
                throw Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
            }
            const a2 = yield resp.arrayBuffer();
            return {
                data: a2,
                etag: resp.headers.get("ETag") || void 0,
                cacheControl: resp.headers.get("Cache-Control") || void 0,
                expires: resp.headers.get("Expires") || void 0
            };
        });
    }
};
function $26aceb2bff6f47cf$var$getUint64(v, offset) {
    const wh = v.getUint32(offset + 4, true);
    const wl = v.getUint32(offset + 0, true);
    return wh * Math.pow(2, 32) + wl;
}
function $26aceb2bff6f47cf$var$bytesToHeader(bytes, etag) {
    const v = new DataView(bytes);
    const spec_version = v.getUint8(7);
    if (spec_version > 3) throw Error(`Archive is spec version ${spec_version} but this library supports up to spec version 3`);
    return {
        specVersion: spec_version,
        rootDirectoryOffset: $26aceb2bff6f47cf$var$getUint64(v, 8),
        rootDirectoryLength: $26aceb2bff6f47cf$var$getUint64(v, 16),
        jsonMetadataOffset: $26aceb2bff6f47cf$var$getUint64(v, 24),
        jsonMetadataLength: $26aceb2bff6f47cf$var$getUint64(v, 32),
        leafDirectoryOffset: $26aceb2bff6f47cf$var$getUint64(v, 40),
        leafDirectoryLength: $26aceb2bff6f47cf$var$getUint64(v, 48),
        tileDataOffset: $26aceb2bff6f47cf$var$getUint64(v, 56),
        tileDataLength: $26aceb2bff6f47cf$var$getUint64(v, 64),
        numAddressedTiles: $26aceb2bff6f47cf$var$getUint64(v, 72),
        numTileEntries: $26aceb2bff6f47cf$var$getUint64(v, 80),
        numTileContents: $26aceb2bff6f47cf$var$getUint64(v, 88),
        clustered: v.getUint8(96) === 1,
        internalCompression: v.getUint8(97),
        tileCompression: v.getUint8(98),
        tileType: v.getUint8(99),
        minZoom: v.getUint8(100),
        maxZoom: v.getUint8(101),
        minLon: v.getInt32(102, true) / 1e7,
        minLat: v.getInt32(106, true) / 1e7,
        maxLon: v.getInt32(110, true) / 1e7,
        maxLat: v.getInt32(114, true) / 1e7,
        centerZoom: v.getUint8(118),
        centerLon: v.getInt32(119, true) / 1e7,
        centerLat: v.getInt32(123, true) / 1e7,
        etag: etag
    };
}
function $26aceb2bff6f47cf$var$deserializeIndex(buffer) {
    const p2 = {
        buf: new Uint8Array(buffer),
        pos: 0
    };
    const numEntries = $26aceb2bff6f47cf$var$readVarint(p2);
    const entries = [];
    let lastId = 0;
    for(let i3 = 0; i3 < numEntries; i3++){
        const v = $26aceb2bff6f47cf$var$readVarint(p2);
        entries.push({
            tileId: lastId + v,
            offset: 0,
            length: 0,
            runLength: 1
        });
        lastId += v;
    }
    for(let i3 = 0; i3 < numEntries; i3++)entries[i3].runLength = $26aceb2bff6f47cf$var$readVarint(p2);
    for(let i3 = 0; i3 < numEntries; i3++)entries[i3].length = $26aceb2bff6f47cf$var$readVarint(p2);
    for(let i3 = 0; i3 < numEntries; i3++){
        const v = $26aceb2bff6f47cf$var$readVarint(p2);
        if (v === 0 && i3 > 0) entries[i3].offset = entries[i3 - 1].offset + entries[i3 - 1].length;
        else entries[i3].offset = v - 1;
    }
    return entries;
}
function $26aceb2bff6f47cf$var$detectVersion(a2) {
    const v = new DataView(a2);
    if (v.getUint16(2, true) === 2) {
        console.warn("PMTiles spec version 2 has been deprecated; please see github.com/protomaps/PMTiles for tools to upgrade");
        return 2;
    } else if (v.getUint16(2, true) === 1) {
        console.warn("PMTiles spec version 1 has been deprecated; please see github.com/protomaps/PMTiles for tools to upgrade");
        return 1;
    }
    return 3;
}
var $26aceb2bff6f47cf$var$EtagMismatch = class extends Error {
};
function $26aceb2bff6f47cf$var$getHeaderAndRoot(source, decompress, prefetch, current_etag) {
    return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
        const resp = yield source.getBytes(0, 16384);
        const v = new DataView(resp.data);
        if (v.getUint16(0, true) !== 19792) throw new Error("Wrong magic number for PMTiles archive");
        if ($26aceb2bff6f47cf$var$detectVersion(resp.data) < 3) return [
            (yield $26aceb2bff6f47cf$var$v2_default.getHeader(source))
        ];
        const headerData = resp.data.slice(0, $26aceb2bff6f47cf$var$HEADER_SIZE_BYTES);
        let resp_etag = resp.etag;
        if (current_etag && resp.etag != current_etag) {
            console.warn("ETag conflict detected; your HTTP server might not support content-based ETag headers. ETags disabled for " + source.getKey());
            resp_etag = void 0;
        }
        const header = $26aceb2bff6f47cf$var$bytesToHeader(headerData, resp_etag);
        if (prefetch) {
            const rootDirData = resp.data.slice(header.rootDirectoryOffset, header.rootDirectoryOffset + header.rootDirectoryLength);
            const dirKey = source.getKey() + "|" + (header.etag || "") + "|" + header.rootDirectoryOffset + "|" + header.rootDirectoryLength;
            const rootDir = $26aceb2bff6f47cf$var$deserializeIndex((yield decompress(rootDirData, header.internalCompression)));
            return [
                header,
                [
                    dirKey,
                    rootDir.length,
                    rootDir
                ]
            ];
        }
        return [
            header,
            void 0
        ];
    });
}
function $26aceb2bff6f47cf$var$getDirectory(source, decompress, offset, length, header) {
    return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
        const resp = yield source.getBytes(offset, length);
        if (header.etag && header.etag !== resp.etag) throw new $26aceb2bff6f47cf$var$EtagMismatch(resp.etag);
        const data = yield decompress(resp.data, header.internalCompression);
        const directory = $26aceb2bff6f47cf$var$deserializeIndex(data);
        if (directory.length === 0) throw new Error("Empty directory is invalid");
        return directory;
    });
}
var $26aceb2bff6f47cf$var$SharedPromiseCache = class {
    constructor(maxCacheEntries = 100, prefetch = true, decompress = $26aceb2bff6f47cf$var$fflateDecompress){
        this.cache = /* @__PURE__ */ new Map();
        this.maxCacheEntries = maxCacheEntries;
        this.counter = 1;
        this.prefetch = prefetch;
        this.decompress = decompress;
    }
    getHeader(source, current_etag) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            const cacheKey = source.getKey();
            if (this.cache.has(cacheKey)) {
                this.cache.get(cacheKey).lastUsed = this.counter++;
                const data = yield this.cache.get(cacheKey).data;
                return data;
            }
            const p2 = new Promise((resolve, reject)=>{
                $26aceb2bff6f47cf$var$getHeaderAndRoot(source, this.decompress, this.prefetch, current_etag).then((res)=>{
                    if (res[1]) this.cache.set(res[1][0], {
                        lastUsed: this.counter++,
                        data: Promise.resolve(res[1][2])
                    });
                    resolve(res[0]);
                    this.prune();
                }).catch((e2)=>{
                    reject(e2);
                });
            });
            this.cache.set(cacheKey, {
                lastUsed: this.counter++,
                data: p2
            });
            return p2;
        });
    }
    getDirectory(source, offset, length, header) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            const cacheKey = source.getKey() + "|" + (header.etag || "") + "|" + offset + "|" + length;
            if (this.cache.has(cacheKey)) {
                this.cache.get(cacheKey).lastUsed = this.counter++;
                const data = yield this.cache.get(cacheKey).data;
                return data;
            }
            const p2 = new Promise((resolve, reject)=>{
                $26aceb2bff6f47cf$var$getDirectory(source, this.decompress, offset, length, header).then((directory)=>{
                    resolve(directory);
                    this.prune();
                }).catch((e2)=>{
                    reject(e2);
                });
            });
            this.cache.set(cacheKey, {
                lastUsed: this.counter++,
                data: p2
            });
            return p2;
        });
    }
    getArrayBuffer(source, offset, length, header) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            const cacheKey = source.getKey() + "|" + (header.etag || "") + "|" + offset + "|" + length;
            if (this.cache.has(cacheKey)) {
                this.cache.get(cacheKey).lastUsed = this.counter++;
                const data = yield this.cache.get(cacheKey).data;
                return data;
            }
            const p2 = new Promise((resolve, reject)=>{
                source.getBytes(offset, length).then((resp)=>{
                    if (header.etag && header.etag !== resp.etag) throw new $26aceb2bff6f47cf$var$EtagMismatch(resp.etag);
                    resolve(resp.data);
                    this.cache.has(cacheKey);
                    this.prune();
                }).catch((e2)=>{
                    reject(e2);
                });
            });
            this.cache.set(cacheKey, {
                lastUsed: this.counter++,
                data: p2
            });
            return p2;
        });
    }
    prune() {
        if (this.cache.size >= this.maxCacheEntries) {
            let minUsed = Infinity;
            let minKey = void 0;
            this.cache.forEach((cache_value, key)=>{
                if (cache_value.lastUsed < minUsed) {
                    minUsed = cache_value.lastUsed;
                    minKey = key;
                }
            });
            if (minKey) this.cache.delete(minKey);
        }
    }
    invalidate(source, current_etag) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            this.cache.delete(source.getKey());
            yield this.getHeader(source, current_etag);
        });
    }
};
var $26aceb2bff6f47cf$export$f5df01c0ebe55344 = class {
    constructor(source, cache, decompress){
        if (typeof source === "string") this.source = new $26aceb2bff6f47cf$var$FetchSource(source);
        else this.source = source;
        if (decompress) this.decompress = decompress;
        else this.decompress = $26aceb2bff6f47cf$var$fflateDecompress;
        if (cache) this.cache = cache;
        else this.cache = new $26aceb2bff6f47cf$var$SharedPromiseCache();
    }
    getHeader() {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            return yield this.cache.getHeader(this.source);
        });
    }
    getZxyAttempt(z2, x2, y, signal) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            const tile_id = $26aceb2bff6f47cf$var$zxyToTileId(z2, x2, y);
            const header = yield this.cache.getHeader(this.source);
            if (header.specVersion < 3) return $26aceb2bff6f47cf$var$v2_default.getZxy(header, this.source, this.cache, z2, x2, y, signal);
            if (z2 < header.minZoom || z2 > header.maxZoom) return void 0;
            let d_o = header.rootDirectoryOffset;
            let d_l = header.rootDirectoryLength;
            for(let depth = 0; depth <= 3; depth++){
                const directory = yield this.cache.getDirectory(this.source, d_o, d_l, header);
                const entry = $26aceb2bff6f47cf$var$findTile(directory, tile_id);
                if (entry) {
                    if (entry.runLength > 0) {
                        const resp = yield this.source.getBytes(header.tileDataOffset + entry.offset, entry.length, signal);
                        if (header.etag && header.etag !== resp.etag) throw new $26aceb2bff6f47cf$var$EtagMismatch(resp.etag);
                        return {
                            data: yield this.decompress(resp.data, header.tileCompression),
                            cacheControl: resp.cacheControl,
                            expires: resp.expires
                        };
                    } else {
                        d_o = header.leafDirectoryOffset + entry.offset;
                        d_l = entry.length;
                    }
                } else return void 0;
            }
            throw Error("Maximum directory depth exceeded");
        });
    }
    getZxy(z2, x2, y, signal) {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            try {
                return yield this.getZxyAttempt(z2, x2, y, signal);
            } catch (e2) {
                if (e2 instanceof $26aceb2bff6f47cf$var$EtagMismatch) {
                    this.cache.invalidate(this.source, e2.message);
                    return yield this.getZxyAttempt(z2, x2, y, signal);
                } else throw e2;
            }
        });
    }
    getMetadataAttempt() {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            const header = yield this.cache.getHeader(this.source);
            const resp = yield this.source.getBytes(header.jsonMetadataOffset, header.jsonMetadataLength);
            if (header.etag && header.etag !== resp.etag) throw new $26aceb2bff6f47cf$var$EtagMismatch(resp.etag);
            const decompressed = yield this.decompress(resp.data, header.internalCompression);
            const dec = new TextDecoder("utf-8");
            return JSON.parse(dec.decode(decompressed));
        });
    }
    getMetadata() {
        return $26aceb2bff6f47cf$var$__async2(this, null, function*() {
            try {
                return yield this.getMetadataAttempt();
            } catch (e2) {
                if (e2 instanceof $26aceb2bff6f47cf$var$EtagMismatch) {
                    this.cache.invalidate(this.source, e2.message);
                    return yield this.getMetadataAttempt();
                } else throw e2;
            }
        });
    }
};
// src/tilecache.ts
var $26aceb2bff6f47cf$export$57e3574f86658eb8 = /* @__PURE__ */ ((GeomType2)=>{
    GeomType2[GeomType2["Point"] = 1] = "Point";
    GeomType2[GeomType2["Line"] = 2] = "Line";
    GeomType2[GeomType2["Polygon"] = 3] = "Polygon";
    return GeomType2;
})($26aceb2bff6f47cf$export$57e3574f86658eb8 || {});
function $26aceb2bff6f47cf$export$94be71509d558c0f(c2) {
    return `${c2.x}:${c2.y}:${c2.z}`;
}
var $26aceb2bff6f47cf$var$loadGeomAndBbox = (pbf, geometry, scale)=>{
    pbf.pos = geometry;
    const end = pbf.readVarint() + pbf.pos;
    let cmd = 1;
    let length = 0;
    let x2 = 0;
    let y = 0;
    let x1 = Infinity;
    let x22 = -Infinity;
    let y1 = Infinity;
    let y2 = -Infinity;
    const lines = [];
    let line = [];
    while(pbf.pos < end){
        if (length <= 0) {
            const cmdLen = pbf.readVarint();
            cmd = cmdLen & 7;
            length = cmdLen >> 3;
        }
        length--;
        if (cmd === 1 || cmd === 2) {
            x2 += pbf.readSVarint() * scale;
            y += pbf.readSVarint() * scale;
            if (x2 < x1) x1 = x2;
            if (x2 > x22) x22 = x2;
            if (y < y1) y1 = y;
            if (y > y2) y2 = y;
            if (cmd === 1) {
                if (line.length > 0) lines.push(line);
                line = [];
            }
            line.push(new $26aceb2bff6f47cf$var$import_point_geometry2.default(x2, y));
        } else if (cmd === 7) {
            if (line) line.push(line[0].clone());
        } else throw new Error(`unknown command ${cmd}`);
    }
    if (line) lines.push(line);
    return {
        geom: lines,
        bbox: {
            minX: x1,
            minY: y1,
            maxX: x22,
            maxY: y2
        }
    };
};
function $26aceb2bff6f47cf$var$parseTile(buffer, tileSize) {
    const v = new $26aceb2bff6f47cf$var$import_vector_tile.VectorTile(new $26aceb2bff6f47cf$var$import_pbf.default(buffer));
    const result = /* @__PURE__ */ new Map();
    for (const [key, value] of Object.entries(v.layers)){
        const features = [];
        const layer = value;
        for(let i3 = 0; i3 < layer.length; i3++){
            const loaded = $26aceb2bff6f47cf$var$loadGeomAndBbox(layer.feature(i3)._pbf, layer.feature(i3)._geometry, tileSize / layer.extent);
            let numVertices = 0;
            for (const part of loaded.geom)numVertices += part.length;
            features.push({
                id: layer.feature(i3).id,
                geomType: layer.feature(i3).type,
                geom: loaded.geom,
                numVertices: numVertices,
                bbox: loaded.bbox,
                props: layer.feature(i3).properties
            });
        }
        result.set(key, features);
    }
    return result;
}
var $26aceb2bff6f47cf$export$e9f49e1da310a6d = class {
    constructor(url, shouldCancelZooms){
        if (typeof url === "string") this.p = new $26aceb2bff6f47cf$export$f5df01c0ebe55344(url);
        else this.p = url;
        this.zoomaborts = [];
        this.shouldCancelZooms = shouldCancelZooms;
    }
    get(c2, tileSize) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            if (this.shouldCancelZooms) this.zoomaborts = this.zoomaborts.filter((za)=>{
                if (za.z !== c2.z) {
                    za.controller.abort();
                    return false;
                }
                return true;
            });
            const controller = new AbortController();
            this.zoomaborts.push({
                z: c2.z,
                controller: controller
            });
            const signal = controller.signal;
            const result = yield this.p.getZxy(c2.z, c2.x, c2.y, signal);
            if (result) return $26aceb2bff6f47cf$var$parseTile(result.data, tileSize);
            return /* @__PURE__ */ new Map();
        });
    }
};
var $26aceb2bff6f47cf$export$426e0ee1ebcb1498 = class {
    constructor(url, shouldCancelZooms){
        this.url = url;
        this.zoomaborts = [];
        this.shouldCancelZooms = shouldCancelZooms;
    }
    get(c2, tileSize) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            if (this.shouldCancelZooms) this.zoomaborts = this.zoomaborts.filter((za)=>{
                if (za.z !== c2.z) {
                    za.controller.abort();
                    return false;
                }
                return true;
            });
            const url = this.url.replace("{z}", c2.z.toString()).replace("{x}", c2.x.toString()).replace("{y}", c2.y.toString());
            const controller = new AbortController();
            this.zoomaborts.push({
                z: c2.z,
                controller: controller
            });
            const signal = controller.signal;
            return new Promise((resolve, reject)=>{
                fetch(url, {
                    signal: signal
                }).then((resp)=>{
                    return resp.arrayBuffer();
                }).then((buffer)=>{
                    const result = $26aceb2bff6f47cf$var$parseTile(buffer, tileSize);
                    resolve(result);
                }).catch((e2)=>{
                    reject(e2);
                });
            });
        });
    }
};
var $26aceb2bff6f47cf$var$R = 6378137;
var $26aceb2bff6f47cf$var$MAX_LATITUDE = 85.0511287798;
var $26aceb2bff6f47cf$var$MAXCOORD = $26aceb2bff6f47cf$var$R * Math.PI;
var $26aceb2bff6f47cf$var$project = (latlng)=>{
    const d = Math.PI / 180;
    const constrained_lat = Math.max(Math.min($26aceb2bff6f47cf$var$MAX_LATITUDE, latlng[0]), -$26aceb2bff6f47cf$var$MAX_LATITUDE);
    const sin = Math.sin(constrained_lat * d);
    return new $26aceb2bff6f47cf$var$import_point_geometry2.default($26aceb2bff6f47cf$var$R * latlng[1] * d, $26aceb2bff6f47cf$var$R * Math.log((1 + sin) / (1 - sin)) / 2);
};
function $26aceb2bff6f47cf$var$sqr(x2) {
    return x2 * x2;
}
function $26aceb2bff6f47cf$var$dist2(v, w) {
    return $26aceb2bff6f47cf$var$sqr(v.x - w.x) + $26aceb2bff6f47cf$var$sqr(v.y - w.y);
}
function $26aceb2bff6f47cf$var$distToSegmentSquared(p2, v, w) {
    const l2 = $26aceb2bff6f47cf$var$dist2(v, w);
    if (l2 === 0) return $26aceb2bff6f47cf$var$dist2(p2, v);
    let t2 = ((p2.x - v.x) * (w.x - v.x) + (p2.y - v.y) * (w.y - v.y)) / l2;
    t2 = Math.max(0, Math.min(1, t2));
    return $26aceb2bff6f47cf$var$dist2(p2, new $26aceb2bff6f47cf$var$import_point_geometry2.default(v.x + t2 * (w.x - v.x), v.y + t2 * (w.y - v.y)));
}
function $26aceb2bff6f47cf$export$2305b77293ea9828(point, ring) {
    let inside = false;
    for(let i3 = 0, j = ring.length - 1; i3 < ring.length; j = i3++){
        const xi = ring[i3].x;
        const yi = ring[i3].y;
        const xj = ring[j].x;
        const yj = ring[j].y;
        const intersect = yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $26aceb2bff6f47cf$export$d9385b944d276332(ring) {
    let area = 0;
    for(let i3 = 0; i3 < ring.length; i3++){
        const j = (i3 + 1) % ring.length;
        area += ring[i3].x * ring[j].y;
        area -= ring[j].x * ring[i3].y;
    }
    return area < 0;
}
function $26aceb2bff6f47cf$export$7f6bc8d3d7d61b11(point, geom) {
    let isInCurrentExterior = false;
    for (const ring of geom){
        if ($26aceb2bff6f47cf$export$d9385b944d276332(ring)) {
            if ($26aceb2bff6f47cf$export$2305b77293ea9828(point, ring)) isInCurrentExterior = false;
        } else {
            if (isInCurrentExterior) return true;
            if ($26aceb2bff6f47cf$export$2305b77293ea9828(point, ring)) isInCurrentExterior = true;
        }
    }
    return isInCurrentExterior;
}
function $26aceb2bff6f47cf$export$3bc3df506688cacc(point, geom) {
    let min = Infinity;
    for (const l2 of geom){
        const dist = Math.sqrt($26aceb2bff6f47cf$var$dist2(point, l2[0]));
        if (dist < min) min = dist;
    }
    return min;
}
function $26aceb2bff6f47cf$export$c47ca6f1b28f7b95(point, geom) {
    let min = Infinity;
    for (const l2 of geom)for(let i3 = 0; i3 < l2.length - 1; i3++){
        const dist = Math.sqrt($26aceb2bff6f47cf$var$distToSegmentSquared(point, l2[i3], l2[i3 + 1]));
        if (dist < min) min = dist;
    }
    return min;
}
var $26aceb2bff6f47cf$export$68a5b7ba031e74ec = class {
    constructor(source, tileSize){
        this.source = source;
        this.cache = /* @__PURE__ */ new Map();
        this.inflight = /* @__PURE__ */ new Map();
        this.tileSize = tileSize;
    }
    queryFeatures(lng, lat, zoom, brushSize) {
        const projected = $26aceb2bff6f47cf$var$project([
            lat,
            lng
        ]);
        const normalized = new $26aceb2bff6f47cf$var$import_point_geometry2.default((projected.x + $26aceb2bff6f47cf$var$MAXCOORD) / ($26aceb2bff6f47cf$var$MAXCOORD * 2), 1 - (projected.y + $26aceb2bff6f47cf$var$MAXCOORD) / ($26aceb2bff6f47cf$var$MAXCOORD * 2));
        if (normalized.x > 1) normalized.x = normalized.x - Math.floor(normalized.x);
        const on_zoom = normalized.mult(1 << zoom);
        const tile_x = Math.floor(on_zoom.x);
        const tile_y = Math.floor(on_zoom.y);
        const idx = $26aceb2bff6f47cf$export$94be71509d558c0f({
            z: zoom,
            x: tile_x,
            y: tile_y
        });
        const retval = [];
        const entry = this.cache.get(idx);
        if (entry) {
            const center = new $26aceb2bff6f47cf$var$import_point_geometry2.default((on_zoom.x - tile_x) * this.tileSize, (on_zoom.y - tile_y) * this.tileSize);
            for (const [layer_name, layer_arr] of entry.data.entries())for (const feature of layer_arr){
                if (feature.geomType === 1 /* Point */ ) {
                    if ($26aceb2bff6f47cf$export$3bc3df506688cacc(center, feature.geom) < brushSize) retval.push({
                        feature: feature,
                        layerName: layer_name
                    });
                } else if (feature.geomType === 2 /* Line */ ) {
                    if ($26aceb2bff6f47cf$export$c47ca6f1b28f7b95(center, feature.geom) < brushSize) retval.push({
                        feature: feature,
                        layerName: layer_name
                    });
                } else if ($26aceb2bff6f47cf$export$7f6bc8d3d7d61b11(center, feature.geom)) retval.push({
                    feature: feature,
                    layerName: layer_name
                });
            }
        }
        return retval;
    }
    get(c2) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            const idx = $26aceb2bff6f47cf$export$94be71509d558c0f(c2);
            return new Promise((resolve, reject)=>{
                const entry = this.cache.get(idx);
                if (entry) {
                    entry.used = performance.now();
                    resolve(entry.data);
                } else {
                    const ifentry = this.inflight.get(idx);
                    if (ifentry) ifentry.push([
                        resolve,
                        reject
                    ]);
                    else {
                        this.inflight.set(idx, []);
                        this.source.get(c2, this.tileSize).then((tile)=>{
                            this.cache.set(idx, {
                                used: performance.now(),
                                data: tile
                            });
                            const ifentry2 = this.inflight.get(idx);
                            if (ifentry2) for (const f2 of ifentry2)f2[0](tile);
                            this.inflight.delete(idx);
                            resolve(tile);
                            if (this.cache.size >= 64) {
                                let min_used = Infinity;
                                let min_key = void 0;
                                this.cache.forEach((value, key)=>{
                                    if (value.used < min_used) {
                                        min_used = value.used;
                                        min_key = key;
                                    }
                                });
                                if (min_key) this.cache.delete(min_key);
                            }
                        }).catch((e2)=>{
                            const ifentry2 = this.inflight.get(idx);
                            if (ifentry2) for (const f2 of ifentry2)f2[1](e2);
                            this.inflight.delete(idx);
                            reject(e2);
                        });
                    }
                }
            });
        });
    }
};
// src/symbolizer.ts
var $26aceb2bff6f47cf$var$MAX_VERTICES_PER_DRAW_CALL = 5400;
var $26aceb2bff6f47cf$export$925ae870dba77a30 = /* @__PURE__ */ ((Justify2)=>{
    Justify2[Justify2["Left"] = 1] = "Left";
    Justify2[Justify2["Center"] = 2] = "Center";
    Justify2[Justify2["Right"] = 3] = "Right";
    return Justify2;
})($26aceb2bff6f47cf$export$925ae870dba77a30 || {});
var $26aceb2bff6f47cf$export$12f67a479be25c4c = /* @__PURE__ */ ((TextPlacements2)=>{
    TextPlacements2[TextPlacements2["N"] = 1] = "N";
    TextPlacements2[TextPlacements2["NE"] = 2] = "NE";
    TextPlacements2[TextPlacements2["E"] = 3] = "E";
    TextPlacements2[TextPlacements2["SE"] = 4] = "SE";
    TextPlacements2[TextPlacements2["S"] = 5] = "S";
    TextPlacements2[TextPlacements2["SW"] = 6] = "SW";
    TextPlacements2[TextPlacements2["W"] = 7] = "W";
    TextPlacements2[TextPlacements2["NW"] = 8] = "NW";
    return TextPlacements2;
})($26aceb2bff6f47cf$export$12f67a479be25c4c || {});
var $26aceb2bff6f47cf$export$77b453ec516f35c5 = (width, height, fn)=>{
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    if (ctx !== null) fn(canvas, ctx);
    return canvas;
};
var $26aceb2bff6f47cf$export$b225ea0cbaf5a20 = class {
    constructor(options){
        var _a2;
        this.pattern = options.pattern;
        this.fill = new $26aceb2bff6f47cf$var$StringAttr(options.fill, "black");
        this.opacity = new $26aceb2bff6f47cf$var$NumberAttr(options.opacity, 1);
        this.stroke = new $26aceb2bff6f47cf$var$StringAttr(options.stroke, "black");
        this.width = new $26aceb2bff6f47cf$var$NumberAttr(options.width, 0);
        this.per_feature = (_a2 = this.fill.per_feature || this.opacity.per_feature || this.stroke.per_feature || this.width.per_feature || options.per_feature) != null ? _a2 : false;
        this.do_stroke = false;
    }
    before(ctx, z2) {
        if (!this.per_feature) {
            ctx.globalAlpha = this.opacity.get(z2);
            ctx.fillStyle = this.fill.get(z2);
            ctx.strokeStyle = this.stroke.get(z2);
            const width = this.width.get(z2);
            if (width > 0) this.do_stroke = true;
            ctx.lineWidth = width;
        }
        if (this.pattern) {
            const patten = ctx.createPattern(this.pattern, "repeat");
            if (patten) ctx.fillStyle = patten;
        }
    }
    draw(ctx, geom, z2, f2) {
        let do_stroke = false;
        if (this.per_feature) {
            ctx.globalAlpha = this.opacity.get(z2, f2);
            ctx.fillStyle = this.fill.get(z2, f2);
            const width = this.width.get(z2, f2);
            if (width) {
                do_stroke = true;
                ctx.strokeStyle = this.stroke.get(z2, f2);
                ctx.lineWidth = width;
            }
        }
        const drawPath = ()=>{
            ctx.fill();
            if (do_stroke || this.do_stroke) ctx.stroke();
        };
        let vertices_in_path = 0;
        ctx.beginPath();
        for (const poly of geom){
            if (vertices_in_path + poly.length > $26aceb2bff6f47cf$var$MAX_VERTICES_PER_DRAW_CALL) {
                drawPath();
                vertices_in_path = 0;
                ctx.beginPath();
            }
            for(let p2 = 0; p2 < poly.length; p2++){
                const pt = poly[p2];
                if (p2 === 0) ctx.moveTo(pt.x, pt.y);
                else ctx.lineTo(pt.x, pt.y);
            }
            vertices_in_path += poly.length;
        }
        if (vertices_in_path > 0) drawPath();
    }
};
function $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(base, a2) {
    return (z2)=>{
        const b = z2 - base;
        if (b >= 0 && b < a2.length) return a2[b];
        return 0;
    };
}
function $26aceb2bff6f47cf$var$getStopIndex(input, stops) {
    let idx = 0;
    while(stops[idx + 1][0] < input)idx++;
    return idx;
}
function $26aceb2bff6f47cf$var$interpolate(factor, start, end) {
    return factor * (end - start) + start;
}
function $26aceb2bff6f47cf$var$computeInterpolationFactor(z2, idx, base, stops) {
    const difference = stops[idx + 1][0] - stops[idx][0];
    const progress = z2 - stops[idx][0];
    if (difference === 0) return 0;
    if (base === 1) return progress / difference;
    return ($26aceb2bff6f47cf$var$__pow(base, progress) - 1) / ($26aceb2bff6f47cf$var$__pow(base, difference) - 1);
}
function $26aceb2bff6f47cf$export$b310ec824aaee37f(base, stops) {
    return (z2)=>{
        if (stops.length < 1) return 0;
        if (z2 <= stops[0][0]) return stops[0][1];
        if (z2 >= stops[stops.length - 1][0]) return stops[stops.length - 1][1];
        const idx = $26aceb2bff6f47cf$var$getStopIndex(z2, stops);
        const factor = $26aceb2bff6f47cf$var$computeInterpolationFactor(z2, idx, base, stops);
        return $26aceb2bff6f47cf$var$interpolate(factor, stops[idx][1], stops[idx + 1][1]);
    };
}
function $26aceb2bff6f47cf$export$35d34bc0ed591a92(output0, stops) {
    return (z2)=>{
        if (stops.length < 1) return 0;
        let retval = output0;
        for(let i3 = 0; i3 < stops.length; i3++)if (z2 >= stops[i3][0]) retval = stops[i3][1];
        return retval;
    };
}
function $26aceb2bff6f47cf$export$45db2fc2f15997e7(stops) {
    return $26aceb2bff6f47cf$export$b310ec824aaee37f(1, stops);
}
function $26aceb2bff6f47cf$export$2c575fa1d20488bd(x1, y1, x2, y2, stops) {
    return (z2)=>{
        if (stops.length < 1) return 0;
        const bezier = new $26aceb2bff6f47cf$var$import_unitbezier.default(x1, y1, x2, y2);
        const idx = $26aceb2bff6f47cf$var$getStopIndex(z2, stops);
        const factor = bezier.solve($26aceb2bff6f47cf$var$computeInterpolationFactor(z2, idx, 1, stops));
        return $26aceb2bff6f47cf$var$interpolate(factor, stops[idx][1], stops[idx + 1][1]);
    };
}
var $26aceb2bff6f47cf$export$95549896bf56cede = class {
    constructor(options){
        var _a2;
        this.color = new $26aceb2bff6f47cf$var$StringAttr(options.color, "black");
        this.width = new $26aceb2bff6f47cf$var$NumberAttr(options.width);
        this.opacity = new $26aceb2bff6f47cf$var$NumberAttr(options.opacity);
        this.dash = options.dash ? new $26aceb2bff6f47cf$var$ArrayAttr(options.dash) : null;
        this.dashColor = new $26aceb2bff6f47cf$var$StringAttr(options.dashColor, "black");
        this.dashWidth = new $26aceb2bff6f47cf$var$NumberAttr(options.dashWidth, 1);
        this.lineCap = new $26aceb2bff6f47cf$var$StringAttr(options.lineCap, "butt");
        this.lineJoin = new $26aceb2bff6f47cf$var$StringAttr(options.lineJoin, "miter");
        this.skip = false;
        this.per_feature = !!(((_a2 = this.dash) == null ? void 0 : _a2.per_feature) || this.color.per_feature || this.opacity.per_feature || this.width.per_feature || this.lineCap.per_feature || this.lineJoin.per_feature || options.per_feature);
    }
    before(ctx, z2) {
        if (!this.per_feature) {
            ctx.strokeStyle = this.color.get(z2);
            ctx.lineWidth = this.width.get(z2);
            ctx.globalAlpha = this.opacity.get(z2);
            ctx.lineCap = this.lineCap.get(z2);
            ctx.lineJoin = this.lineJoin.get(z2);
        }
    }
    draw(ctx, geom, z2, f2) {
        if (this.skip) return;
        const strokePath = ()=>{
            if (this.per_feature) {
                ctx.globalAlpha = this.opacity.get(z2, f2);
                ctx.lineCap = this.lineCap.get(z2, f2);
                ctx.lineJoin = this.lineJoin.get(z2, f2);
            }
            if (this.dash) {
                ctx.save();
                if (this.per_feature) {
                    ctx.lineWidth = this.dashWidth.get(z2, f2);
                    ctx.strokeStyle = this.dashColor.get(z2, f2);
                    ctx.setLineDash(this.dash.get(z2, f2));
                } else ctx.setLineDash(this.dash.get(z2));
                ctx.stroke();
                ctx.restore();
            } else {
                ctx.save();
                if (this.per_feature) {
                    ctx.lineWidth = this.width.get(z2, f2);
                    ctx.strokeStyle = this.color.get(z2, f2);
                }
                ctx.stroke();
                ctx.restore();
            }
        };
        let vertices_in_path = 0;
        ctx.beginPath();
        for (const ls of geom){
            if (vertices_in_path + ls.length > $26aceb2bff6f47cf$var$MAX_VERTICES_PER_DRAW_CALL) {
                strokePath();
                vertices_in_path = 0;
                ctx.beginPath();
            }
            for(let p2 = 0; p2 < ls.length; p2++){
                const pt = ls[p2];
                if (p2 === 0) ctx.moveTo(pt.x, pt.y);
                else ctx.lineTo(pt.x, pt.y);
            }
            vertices_in_path += ls.length;
        }
        if (vertices_in_path > 0) strokePath();
    }
};
var $26aceb2bff6f47cf$export$cb174afabe57b9d5 = class {
    constructor(options){
        this.name = options.name;
        this.sheet = options.sheet;
        this.dpr = window.devicePixelRatio;
    }
    place(layout, geom, feature) {
        const pt = geom[0];
        const a2 = new $26aceb2bff6f47cf$var$import_point_geometry3.default(geom[0][0].x, geom[0][0].y);
        const loc = this.sheet.get(this.name);
        const width = loc.w / this.dpr;
        const height = loc.h / this.dpr;
        const bbox = {
            minX: a2.x - width / 2,
            minY: a2.y - height / 2,
            maxX: a2.x + width / 2,
            maxY: a2.y + height / 2
        };
        const draw = (ctx)=>{
            ctx.globalAlpha = 1;
            ctx.drawImage(this.sheet.canvas, loc.x, loc.y, loc.w, loc.h, -loc.w / 2 / this.dpr, -loc.h / 2 / this.dpr, loc.w / 2, loc.h / 2);
        };
        return [
            {
                anchor: a2,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$export$8bf8f73f069748a0 = class {
    constructor(options){
        this.radius = new $26aceb2bff6f47cf$var$NumberAttr(options.radius, 3);
        this.fill = new $26aceb2bff6f47cf$var$StringAttr(options.fill, "black");
        this.stroke = new $26aceb2bff6f47cf$var$StringAttr(options.stroke, "white");
        this.width = new $26aceb2bff6f47cf$var$NumberAttr(options.width, 0);
        this.opacity = new $26aceb2bff6f47cf$var$NumberAttr(options.opacity);
    }
    draw(ctx, geom, z2, f2) {
        ctx.globalAlpha = this.opacity.get(z2, f2);
        const radius = this.radius.get(z2, f2);
        const width = this.width.get(z2, f2);
        if (width > 0) {
            ctx.strokeStyle = this.stroke.get(z2, f2);
            ctx.lineWidth = width;
            ctx.beginPath();
            ctx.arc(geom[0][0].x, geom[0][0].y, radius + width / 2, 0, 2 * Math.PI);
            ctx.stroke();
        }
        ctx.fillStyle = this.fill.get(z2, f2);
        ctx.beginPath();
        ctx.arc(geom[0][0].x, geom[0][0].y, radius, 0, 2 * Math.PI);
        ctx.fill();
    }
    place(layout, geom, feature) {
        const pt = geom[0];
        const a2 = new $26aceb2bff6f47cf$var$import_point_geometry3.default(geom[0][0].x, geom[0][0].y);
        const radius = this.radius.get(layout.zoom, feature);
        const bbox = {
            minX: a2.x - radius,
            minY: a2.y - radius,
            maxX: a2.x + radius,
            maxY: a2.y + radius
        };
        const draw = (ctx)=>{
            this.draw(ctx, [
                [
                    new $26aceb2bff6f47cf$var$import_point_geometry3.default(0, 0)
                ]
            ], layout.zoom, feature);
        };
        return [
            {
                anchor: a2,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$export$a05ef6d6d469b5a7 = class {
    constructor(options){
        this.font = new $26aceb2bff6f47cf$var$FontAttr(options);
        this.text = new $26aceb2bff6f47cf$var$TextAttr(options);
        this.fill = new $26aceb2bff6f47cf$var$StringAttr(options.fill, "black");
        this.background = new $26aceb2bff6f47cf$var$StringAttr(options.background, "white");
        this.padding = new $26aceb2bff6f47cf$var$NumberAttr(options.padding, 0);
    }
    place(layout, geom, f2) {
        const property = this.text.get(layout.zoom, f2);
        if (!property) return void 0;
        const font = this.font.get(layout.zoom, f2);
        layout.scratch.font = font;
        const metrics = layout.scratch.measureText(property);
        const width = metrics.width;
        const ascent = metrics.actualBoundingBoxAscent;
        const descent = metrics.actualBoundingBoxDescent;
        const pt = geom[0];
        const a2 = new $26aceb2bff6f47cf$var$import_point_geometry3.default(geom[0][0].x, geom[0][0].y);
        const p2 = this.padding.get(layout.zoom, f2);
        const bbox = {
            minX: a2.x - width / 2 - p2,
            minY: a2.y - ascent - p2,
            maxX: a2.x + width / 2 + p2,
            maxY: a2.y + descent + p2
        };
        const draw = (ctx)=>{
            ctx.globalAlpha = 1;
            ctx.fillStyle = this.background.get(layout.zoom, f2);
            ctx.fillRect(-width / 2 - p2, -ascent - p2, width + 2 * p2, ascent + descent + 2 * p2);
            ctx.fillStyle = this.fill.get(layout.zoom, f2);
            ctx.font = font;
            ctx.fillText(property, -width / 2, 0);
        };
        return [
            {
                anchor: a2,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$export$32dabc0dbd81f023 = class {
    constructor(list){
        this.list = list;
    }
    place(layout, geom, feature) {
        let labels = this.list[0].place(layout, geom, feature);
        if (!labels) return void 0;
        let label = labels[0];
        const anchor = label.anchor;
        let bbox = label.bboxes[0];
        const height = bbox.maxY - bbox.minY;
        const draws = [
            {
                draw: label.draw,
                translate: {
                    x: 0,
                    y: 0
                }
            }
        ];
        const newGeom = [
            [
                new $26aceb2bff6f47cf$var$import_point_geometry3.default(geom[0][0].x, geom[0][0].y + height)
            ]
        ];
        for(let i3 = 1; i3 < this.list.length; i3++){
            labels = this.list[i3].place(layout, newGeom, feature);
            if (labels) {
                label = labels[0];
                bbox = $26aceb2bff6f47cf$var$mergeBbox(bbox, label.bboxes[0]);
                draws.push({
                    draw: label.draw,
                    translate: {
                        x: 0,
                        y: height
                    }
                });
            }
        }
        const draw = (ctx)=>{
            for (const sub of draws){
                ctx.save();
                ctx.translate(sub.translate.x, sub.translate.y);
                sub.draw(ctx);
                ctx.restore();
            }
        };
        return [
            {
                anchor: anchor,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$var$mergeBbox = (b1, b2)=>{
    return {
        minX: Math.min(b1.minX, b2.minX),
        minY: Math.min(b1.minY, b2.minY),
        maxX: Math.max(b1.maxX, b2.maxX),
        maxY: Math.max(b1.maxY, b2.maxY)
    };
};
var $26aceb2bff6f47cf$export$ad70caf87077791a = class {
    constructor(list){
        this.list = list;
    }
    place(layout, geom, feature) {
        const first = this.list[0];
        if (!first) return void 0;
        let labels = first.place(layout, geom, feature);
        if (!labels) return void 0;
        let label = labels[0];
        const anchor = label.anchor;
        let bbox = label.bboxes[0];
        const draws = [
            label.draw
        ];
        for(let i3 = 1; i3 < this.list.length; i3++){
            labels = this.list[i3].place(layout, geom, feature);
            if (!labels) return void 0;
            label = labels[0];
            bbox = $26aceb2bff6f47cf$var$mergeBbox(bbox, label.bboxes[0]);
            draws.push(label.draw);
        }
        const draw = (ctx)=>{
            for (const d of draws)d(ctx);
        };
        return [
            {
                anchor: anchor,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$export$92f1ccb38dbc689a = class {
    constructor(symbolizer){
        this.symbolizer = symbolizer;
    }
    place(layout, geom, feature) {
        const a2 = geom[0][0];
        const placed = this.symbolizer.place(layout, [
            [
                new $26aceb2bff6f47cf$var$import_point_geometry3.default(0, 0)
            ]
        ], feature);
        if (!placed || placed.length === 0) return void 0;
        const first_label = placed[0];
        const bbox = first_label.bboxes[0];
        const width = bbox.maxX - bbox.minX;
        const height = bbox.maxY - bbox.minY;
        const centered = {
            minX: a2.x - width / 2,
            maxX: a2.x + width / 2,
            minY: a2.y - height / 2,
            maxY: a2.y + height / 2
        };
        const draw = (ctx)=>{
            ctx.translate(-width / 2, height / 2 - bbox.maxY);
            first_label.draw(ctx, {
                justify: 2 /* Center */ 
            });
        };
        return [
            {
                anchor: a2,
                bboxes: [
                    centered
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$export$8ee6ea94b5aedb49 = class {
    constructor(padding, symbolizer){
        this.padding = new $26aceb2bff6f47cf$var$NumberAttr(padding, 0);
        this.symbolizer = symbolizer;
    }
    place(layout, geom, feature) {
        const placed = this.symbolizer.place(layout, geom, feature);
        if (!placed || placed.length === 0) return void 0;
        const padding = this.padding.get(layout.zoom, feature);
        for (const label of placed)for (const bbox of label.bboxes){
            bbox.minX -= padding;
            bbox.minY -= padding;
            bbox.maxX += padding;
            bbox.maxY += padding;
        }
        return placed;
    }
};
var $26aceb2bff6f47cf$export$5de04707afe90f07 = class {
    constructor(options){
        this.font = new $26aceb2bff6f47cf$var$FontAttr(options);
        this.text = new $26aceb2bff6f47cf$var$TextAttr(options);
        this.fill = new $26aceb2bff6f47cf$var$StringAttr(options.fill, "black");
        this.stroke = new $26aceb2bff6f47cf$var$StringAttr(options.stroke, "black");
        this.width = new $26aceb2bff6f47cf$var$NumberAttr(options.width, 0);
        this.lineHeight = new $26aceb2bff6f47cf$var$NumberAttr(options.lineHeight, 1);
        this.letterSpacing = new $26aceb2bff6f47cf$var$NumberAttr(options.letterSpacing, 0);
        this.maxLineCodeUnits = new $26aceb2bff6f47cf$var$NumberAttr(options.maxLineChars, 15);
        this.justify = options.justify;
    }
    place(layout, geom, feature) {
        const property = this.text.get(layout.zoom, feature);
        if (!property) return void 0;
        const font = this.font.get(layout.zoom, feature);
        layout.scratch.font = font;
        const letterSpacing = this.letterSpacing.get(layout.zoom, feature);
        const lines = $26aceb2bff6f47cf$var$linebreak(property, this.maxLineCodeUnits.get(layout.zoom, feature));
        let longestLine = "";
        let longestLineLen = 0;
        for (const line of lines)if (line.length > longestLineLen) {
            longestLineLen = line.length;
            longestLine = line;
        }
        const metrics = layout.scratch.measureText(longestLine);
        const width = metrics.width + letterSpacing * (longestLineLen - 1);
        const ascent = metrics.actualBoundingBoxAscent;
        const descent = metrics.actualBoundingBoxDescent;
        const lineHeight = (ascent + descent) * this.lineHeight.get(layout.zoom, feature);
        const a2 = new $26aceb2bff6f47cf$var$import_point_geometry3.default(geom[0][0].x, geom[0][0].y);
        const bbox = {
            minX: a2.x,
            minY: a2.y - ascent,
            maxX: a2.x + width,
            maxY: a2.y + descent + (lines.length - 1) * lineHeight
        };
        const draw = (ctx, extra)=>{
            ctx.globalAlpha = 1;
            ctx.font = font;
            ctx.fillStyle = this.fill.get(layout.zoom, feature);
            const textStrokeWidth = this.width.get(layout.zoom, feature);
            let y = 0;
            for (const line of lines){
                let startX = 0;
                if (this.justify === 2 /* Center */  || extra && extra.justify === 2 /* Center */ ) startX = (width - ctx.measureText(line).width) / 2;
                else if (this.justify === 3 /* Right */  || extra && extra.justify === 3 /* Right */ ) startX = width - ctx.measureText(line).width;
                if (textStrokeWidth) {
                    ctx.lineWidth = textStrokeWidth * 2;
                    ctx.strokeStyle = this.stroke.get(layout.zoom, feature);
                    if (letterSpacing > 0) {
                        let xPos = startX;
                        for (const letter of line){
                            ctx.strokeText(letter, xPos, y);
                            xPos += ctx.measureText(letter).width + letterSpacing;
                        }
                    } else ctx.strokeText(line, startX, y);
                }
                if (letterSpacing > 0) {
                    let xPos = startX;
                    for (const letter of line){
                        ctx.fillText(letter, xPos, y);
                        xPos += ctx.measureText(letter).width + letterSpacing;
                    }
                } else ctx.fillText(line, startX, y);
                y += lineHeight;
            }
        };
        return [
            {
                anchor: a2,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
var $26aceb2bff6f47cf$export$53d5ad1ff34f479a = class {
    constructor(options){
        this.centered = new $26aceb2bff6f47cf$export$92f1ccb38dbc689a(new $26aceb2bff6f47cf$export$5de04707afe90f07(options));
    }
    place(layout, geom, feature) {
        return this.centered.place(layout, geom, feature);
    }
};
var $26aceb2bff6f47cf$export$1c50b783945d212a = class {
    constructor(symbolizer, options){
        var _a2, _b2, _c;
        this.symbolizer = symbolizer;
        this.offsetX = new $26aceb2bff6f47cf$var$NumberAttr(options.offsetX, 0);
        this.offsetY = new $26aceb2bff6f47cf$var$NumberAttr(options.offsetY, 0);
        this.justify = (_a2 = options.justify) != null ? _a2 : void 0;
        this.placements = (_b2 = options.placements) != null ? _b2 : [
            2 /* NE */ ,
            6 /* SW */ ,
            8 /* NW */ ,
            4 /* SE */ ,
            1 /* N */ ,
            3 /* E */ ,
            5 /* S */ ,
            7 /* W */ 
        ];
        this.ddValues = (_c = options.ddValues) != null ? _c : ()=>{
            return {};
        };
    }
    place(layout, geom, feature) {
        if (feature.geomType !== 1 /* Point */ ) return void 0;
        const anchor = geom[0][0];
        const placed = this.symbolizer.place(layout, [
            [
                new $26aceb2bff6f47cf$var$import_point_geometry3.default(0, 0)
            ]
        ], feature);
        if (!placed || placed.length === 0) return void 0;
        const first_label = placed[0];
        const fb = first_label.bboxes[0];
        let offsetXValue = this.offsetX;
        let offsetYValue = this.offsetY;
        let justifyValue = this.justify;
        let placements = this.placements;
        const { offsetX: ddOffsetX, offsetY: ddOffsetY, justify: ddJustify, placements: ddPlacements } = this.ddValues(layout.zoom, feature) || {};
        if (ddOffsetX) offsetXValue = new $26aceb2bff6f47cf$var$NumberAttr(ddOffsetX, 0);
        if (ddOffsetY) offsetYValue = new $26aceb2bff6f47cf$var$NumberAttr(ddOffsetY, 0);
        if (ddJustify) justifyValue = ddJustify;
        if (ddPlacements) placements = ddPlacements;
        const offsetX = offsetXValue.get(layout.zoom, feature);
        const offsetY = offsetYValue.get(layout.zoom, feature);
        const getBbox = (a2, o2)=>{
            return {
                minX: a2.x + o2.x + fb.minX,
                minY: a2.y + o2.y + fb.minY,
                maxX: a2.x + o2.x + fb.maxX,
                maxY: a2.y + o2.y + fb.maxY
            };
        };
        let origin = new $26aceb2bff6f47cf$var$import_point_geometry3.default(offsetX, offsetY);
        let justify;
        const draw = (ctx)=>{
            ctx.translate(origin.x, origin.y);
            first_label.draw(ctx, {
                justify: justify
            });
        };
        const placeLabelInPoint = (a2, o2)=>{
            const bbox = getBbox(a2, o2);
            if (!layout.index.bboxCollides(bbox, layout.order)) return [
                {
                    anchor: anchor,
                    bboxes: [
                        bbox
                    ],
                    draw: draw
                }
            ];
        };
        for (const placement of placements){
            const xAxisOffset = this.computeXAxisOffset(offsetX, fb, placement);
            const yAxisOffset = this.computeYAxisOffset(offsetY, fb, placement);
            justify = this.computeJustify(justifyValue, placement);
            origin = new $26aceb2bff6f47cf$var$import_point_geometry3.default(xAxisOffset, yAxisOffset);
            return placeLabelInPoint(anchor, origin);
        }
        return void 0;
    }
    computeXAxisOffset(offsetX, fb, placement) {
        const labelWidth = fb.maxX;
        const labelHalfWidth = labelWidth / 2;
        if ([
            1 /* N */ ,
            5 /* S */ 
        ].includes(placement)) return offsetX - labelHalfWidth;
        if ([
            8 /* NW */ ,
            7 /* W */ ,
            6 /* SW */ 
        ].includes(placement)) return offsetX - labelWidth;
        return offsetX;
    }
    computeYAxisOffset(offsetY, fb, placement) {
        const labelHalfHeight = Math.abs(fb.minY);
        const labelBottom = fb.maxY;
        const labelCenterHeight = (fb.minY + fb.maxY) / 2;
        if ([
            3 /* E */ ,
            7 /* W */ 
        ].includes(placement)) return offsetY - labelCenterHeight;
        if ([
            8 /* NW */ ,
            2 /* NE */ ,
            1 /* N */ 
        ].includes(placement)) return offsetY - labelBottom;
        if ([
            6 /* SW */ ,
            4 /* SE */ ,
            5 /* S */ 
        ].includes(placement)) return offsetY + labelHalfHeight;
        return offsetY;
    }
    computeJustify(fixedJustify, placement) {
        if (fixedJustify) return fixedJustify;
        if ([
            1 /* N */ ,
            5 /* S */ 
        ].includes(placement)) return 2 /* Center */ ;
        if ([
            2 /* NE */ ,
            3 /* E */ ,
            4 /* SE */ 
        ].includes(placement)) return 1 /* Left */ ;
        return 3 /* Right */ ;
    }
};
var $26aceb2bff6f47cf$export$b04698872800c8ee = class {
    constructor(options){
        this.symbolizer = new $26aceb2bff6f47cf$export$1c50b783945d212a(new $26aceb2bff6f47cf$export$5de04707afe90f07(options), options);
    }
    place(layout, geom, feature) {
        return this.symbolizer.place(layout, geom, feature);
    }
};
var $26aceb2bff6f47cf$export$fd6fd4f44bf46143 = /* @__PURE__ */ ((LineLabelPlacement2)=>{
    LineLabelPlacement2[LineLabelPlacement2["Above"] = 1] = "Above";
    LineLabelPlacement2[LineLabelPlacement2["Center"] = 2] = "Center";
    LineLabelPlacement2[LineLabelPlacement2["Below"] = 3] = "Below";
    return LineLabelPlacement2;
})($26aceb2bff6f47cf$export$fd6fd4f44bf46143 || {});
var $26aceb2bff6f47cf$export$78a4dca8da5a6362 = class {
    constructor(options){
        var _a2;
        this.font = new $26aceb2bff6f47cf$var$FontAttr(options);
        this.text = new $26aceb2bff6f47cf$var$TextAttr(options);
        this.fill = new $26aceb2bff6f47cf$var$StringAttr(options.fill, "black");
        this.stroke = new $26aceb2bff6f47cf$var$StringAttr(options.stroke, "black");
        this.width = new $26aceb2bff6f47cf$var$NumberAttr(options.width, 0);
        this.offset = new $26aceb2bff6f47cf$var$NumberAttr(options.offset, 0);
        this.position = (_a2 = options.position) != null ? _a2 : 1 /* Above */ ;
        this.maxLabelCodeUnits = new $26aceb2bff6f47cf$var$NumberAttr(options.maxLabelChars, 40);
        this.repeatDistance = new $26aceb2bff6f47cf$var$NumberAttr(options.repeatDistance, 250);
    }
    place(layout, geom, feature) {
        const name = this.text.get(layout.zoom, feature);
        if (!name) return void 0;
        if (name.length > this.maxLabelCodeUnits.get(layout.zoom, feature)) return void 0;
        const MIN_LABELABLE_DIM = 20;
        const fbbox = feature.bbox;
        if (fbbox.maxY - fbbox.minY < MIN_LABELABLE_DIM && fbbox.maxX - fbbox.minX < MIN_LABELABLE_DIM) return void 0;
        const font = this.font.get(layout.zoom, feature);
        layout.scratch.font = font;
        const metrics = layout.scratch.measureText(name);
        const width = metrics.width;
        const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
        let repeatDistance = this.repeatDistance.get(layout.zoom, feature);
        if (layout.overzoom > 4) repeatDistance *= 1 << layout.overzoom - 4;
        const cell_size = height * 2;
        const label_candidates = $26aceb2bff6f47cf$var$simpleLabel(geom, width, repeatDistance, cell_size);
        if (label_candidates.length === 0) return void 0;
        const labels = [];
        for (const candidate of label_candidates){
            const dx = candidate.end.x - candidate.start.x;
            const dy = candidate.end.y - candidate.start.y;
            const cells = $26aceb2bff6f47cf$var$lineCells(candidate.start, candidate.end, width, cell_size / 2);
            const bboxes = cells.map((c2)=>{
                return {
                    minX: c2.x - cell_size / 2,
                    minY: c2.y - cell_size / 2,
                    maxX: c2.x + cell_size / 2,
                    maxY: c2.y + cell_size / 2
                };
            });
            const draw = (ctx)=>{
                ctx.globalAlpha = 1;
                ctx.rotate(Math.atan2(dy, dx));
                if (dx < 0) {
                    ctx.scale(-1, -1);
                    ctx.translate(-width, 0);
                }
                let heightPlacement = 0;
                if (this.position === 3 /* Below */ ) heightPlacement += height;
                else if (this.position === 2 /* Center */ ) heightPlacement += height / 2;
                ctx.translate(0, heightPlacement - this.offset.get(layout.zoom, feature));
                ctx.font = font;
                const lineWidth = this.width.get(layout.zoom, feature);
                if (lineWidth) {
                    ctx.lineWidth = lineWidth;
                    ctx.strokeStyle = this.stroke.get(layout.zoom, feature);
                    ctx.strokeText(name, 0, 0);
                }
                ctx.fillStyle = this.fill.get(layout.zoom, feature);
                ctx.fillText(name, 0, 0);
            };
            labels.push({
                anchor: candidate.start,
                bboxes: bboxes,
                draw: draw,
                deduplicationKey: name,
                deduplicationDistance: repeatDistance
            });
        }
        return labels;
    }
};
var $26aceb2bff6f47cf$export$8511e0ed13901ff8 = class {
    constructor(options){
        this.symbolizer = new $26aceb2bff6f47cf$export$5de04707afe90f07(options);
    }
    place(layout, geom, feature) {
        const fbbox = feature.bbox;
        const area = (fbbox.maxY - fbbox.minY) * (fbbox.maxX - fbbox.minX);
        if (area < 2e4) return void 0;
        const placed = this.symbolizer.place(layout, [
            [
                new $26aceb2bff6f47cf$var$import_point_geometry3.default(0, 0)
            ]
        ], feature);
        if (!placed || placed.length === 0) return void 0;
        const first_label = placed[0];
        const fb = first_label.bboxes[0];
        const first_poly = geom[0];
        const found = (0, $26aceb2bff6f47cf$var$import_polylabel.default)([
            first_poly.map((c2)=>[
                    c2.x,
                    c2.y
                ])
        ]);
        const a2 = new $26aceb2bff6f47cf$var$import_point_geometry3.default(found[0], found[1]);
        const bbox = {
            minX: a2.x - (fb.maxX - fb.minX) / 2,
            minY: a2.y - (fb.maxY - fb.minY) / 2,
            maxX: a2.x + (fb.maxX - fb.minX) / 2,
            maxY: a2.y + (fb.maxY - fb.minY) / 2
        };
        const draw = (ctx)=>{
            ctx.translate(first_label.anchor.x - (fb.maxX - fb.minX) / 2, first_label.anchor.y);
            first_label.draw(ctx);
        };
        return [
            {
                anchor: a2,
                bboxes: [
                    bbox
                ],
                draw: draw
            }
        ];
    }
};
// src/default_style/style.ts
var $26aceb2bff6f47cf$var$doShading = (params, shade)=>{
    const shadeHsl = $26aceb2bff6f47cf$var$p(shade);
    const outParams = $26aceb2bff6f47cf$var$__spreadValues({}, params);
    for (const [key, value] of Object.entries(params)){
        const o2 = $26aceb2bff6f47cf$var$p(value);
        outParams[key] = $26aceb2bff6f47cf$var$z(shadeHsl[0], shadeHsl[1], o2[2], o2[3]);
    }
    return outParams;
};
var $26aceb2bff6f47cf$export$d80259effe069058 = (originalParams, shade)=>{
    let params = originalParams;
    if (shade) params = $26aceb2bff6f47cf$var$doShading(originalParams, shade);
    return [
        {
            dataLayer: "earth",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.earth
            })
        },
        {
            dataLayer: "natural",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.glacier
            }),
            filter: (z2, f2)=>{
                return f2.props.natural === "glacier";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.residential
            }),
            filter: (z2, f2)=>{
                return f2.props.landuse === "residential" || f2.props.place === "neighbourhood";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.hospital
            }),
            filter: (z2, f2)=>{
                return f2.props.amenity === "hospital";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.cemetery
            }),
            filter: (z2, f2)=>{
                return f2.props.landuse === "cemetery";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.school
            }),
            filter: (z2, f2)=>{
                return f2.props.amenity === "school" || f2.props.amenity === "kindergarten" || f2.props.amenity === "university" || f2.props.amenity === "college";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.industrial
            }),
            filter: (z2, f2)=>{
                return f2.props.landuse === "industrial";
            }
        },
        {
            dataLayer: "natural",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.wood
            }),
            filter: (z2, f2)=>{
                return f2.props.natural === "wood";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.grass
            }),
            filter: (z2, f2)=>{
                return f2.props.landuse === "grass";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.park
            }),
            filter: (z2, f2)=>{
                return f2.props.leisure === "park";
            }
        },
        {
            dataLayer: "water",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.water
            })
        },
        {
            dataLayer: "natural",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.sand
            }),
            filter: (z2, f2)=>{
                return f2.props.natural === "sand";
            }
        },
        {
            dataLayer: "buildings",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.buildings
            })
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.highwayCasing,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        5,
                        1.5
                    ],
                    [
                        11,
                        4
                    ],
                    [
                        16,
                        9
                    ],
                    [
                        20,
                        40
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "highway";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.majorRoadCasing,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        9,
                        3
                    ],
                    [
                        12,
                        4
                    ],
                    [
                        17,
                        8
                    ],
                    [
                        20,
                        22
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "major_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.mediumRoadCasing,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        13,
                        3
                    ],
                    [
                        17,
                        6
                    ],
                    [
                        20,
                        18
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "medium_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.minorRoadCasing,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        14,
                        2
                    ],
                    [
                        17,
                        5
                    ],
                    [
                        20,
                        15
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "minor_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.minorRoad,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        14,
                        1
                    ],
                    [
                        17,
                        3
                    ],
                    [
                        20,
                        13
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "minor_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.mediumRoad,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        13,
                        2
                    ],
                    [
                        17,
                        4
                    ],
                    [
                        20,
                        15
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "medium_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.majorRoad,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        9,
                        2
                    ],
                    [
                        12,
                        3
                    ],
                    [
                        17,
                        6
                    ],
                    [
                        20,
                        20
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "major_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.highway,
                width: $26aceb2bff6f47cf$export$b310ec824aaee37f(1.4, [
                    [
                        5,
                        0.5
                    ],
                    [
                        11,
                        2.5
                    ],
                    [
                        16,
                        7
                    ],
                    [
                        20,
                        30
                    ]
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "highway";
            }
        },
        {
            dataLayer: "boundaries",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: params.boundaries,
                width: 2,
                opacity: 0.4
            })
        },
        {
            dataLayer: "mask",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: params.mask
            })
        }
    ];
};
var $26aceb2bff6f47cf$export$fe153b1eddbceef9 = (originalParams, shade, language1, language2)=>{
    let params = originalParams;
    if (shade) params = $26aceb2bff6f47cf$var$doShading(originalParams, shade);
    let nametags = [
        "name"
    ];
    if (language1) nametags = language1;
    const languageStack = (symbolizer, fill)=>{
        if (!language2) return symbolizer;
        if (symbolizer instanceof $26aceb2bff6f47cf$export$b04698872800c8ee) return new $26aceb2bff6f47cf$export$32dabc0dbd81f023([
            symbolizer,
            new $26aceb2bff6f47cf$export$b04698872800c8ee({
                fill: fill,
                label_props: language2
            })
        ]);
        return new $26aceb2bff6f47cf$export$32dabc0dbd81f023([
            symbolizer,
            new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                fill: fill,
                label_props: language2
            })
        ]);
    };
    return [
        {
            dataLayer: "places",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: nametags,
                fill: params.countryLabel,
                lineHeight: 1.5,
                font: (z2, f2)=>{
                    if (z2 < 6) return "200 14px sans-serif";
                    return "200 20px sans-serif";
                },
                textTransform: "uppercase"
            }), params.countryLabel),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "country";
            }
        },
        {
            dataLayer: "places",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: nametags,
                fill: params.stateLabel,
                font: "300 16px sans-serif"
            }), params.stateLabel),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "state";
            }
        },
        {
            id: "cities_high",
            dataLayer: "places",
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "city";
            },
            minzoom: 7,
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: nametags,
                fill: params.cityLabel,
                font: (z2, f2)=>{
                    if ((f2 == null ? void 0 : f2.props["pmap:rank"]) === 1) {
                        if (z2 > 8) return "600 20px sans-serif";
                        return "600 12px sans-serif";
                    }
                    if (z2 > 8) return "600 16px sans-serif";
                    return "600 10px sans-serif";
                }
            }), params.cityLabel),
            sort: (a2, b)=>{
                return a2["pmap:rank"] - b["pmap:rank"];
            }
        },
        {
            id: "cities_low",
            dataLayer: "places",
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "city";
            },
            maxzoom: 6,
            symbolizer: new $26aceb2bff6f47cf$export$ad70caf87077791a([
                new $26aceb2bff6f47cf$export$8bf8f73f069748a0({
                    radius: 2,
                    fill: params.cityLabel
                }),
                languageStack(new $26aceb2bff6f47cf$export$b04698872800c8ee({
                    label_props: nametags,
                    fill: params.cityLabel,
                    offsetX: 2,
                    offsetY: 2,
                    font: (z2, f2)=>{
                        if ((f2 == null ? void 0 : f2.props["pmap:rank"]) === 1) {
                            if (z2 > 8) return "600 20px sans-serif";
                            return "600 12px sans-serif";
                        }
                        if (z2 > 8) return "600 16px sans-serif";
                        return "600 10px sans-serif";
                    }
                }), params.cityLabel)
            ]),
            sort: (a2, b)=>{
                return a2["pmap:rank"] - b["pmap:rank"];
            }
        },
        {
            id: "neighbourhood",
            dataLayer: "places",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: nametags,
                fill: params.neighbourhoodLabel,
                font: "500 10px sans-serif",
                textTransform: "uppercase"
            }), params.neighbourhoodLabel),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "neighbourhood";
            }
        },
        {
            dataLayer: "landuse",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$8511e0ed13901ff8({
                label_props: nametags,
                fill: params.landuseLabel,
                font: "300 12px sans-serif"
            }), params.landuseLabel)
        },
        {
            dataLayer: "water",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$8511e0ed13901ff8({
                label_props: nametags,
                fill: params.waterLabel,
                font: "italic 600 12px sans-serif"
            }), params.waterLabel)
        },
        {
            dataLayer: "natural",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$8511e0ed13901ff8({
                label_props: nametags,
                fill: params.naturalLabel,
                font: "italic 300 12px sans-serif"
            }), params.naturalLabel)
        },
        {
            dataLayer: "roads",
            symbolizer: languageStack(new $26aceb2bff6f47cf$export$78a4dca8da5a6362({
                label_props: nametags,
                fill: params.roadsLabel,
                font: "500 12px sans-serif"
            }), params.roadsLabel),
            minzoom: 12
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$a05ef6d6d469b5a7({
                label_props: [
                    "ref"
                ],
                font: "600 9px sans-serif",
                background: params.highway,
                padding: 2,
                fill: params.neighbourhoodLabel
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "highway";
            }
        },
        {
            dataLayer: "pois",
            symbolizer: new $26aceb2bff6f47cf$export$ad70caf87077791a([
                new $26aceb2bff6f47cf$export$8bf8f73f069748a0({
                    radius: 2,
                    fill: params.poisLabel
                }),
                languageStack(new $26aceb2bff6f47cf$export$b04698872800c8ee({
                    label_props: nametags,
                    fill: params.poisLabel,
                    offsetX: 2,
                    offsetY: 2,
                    font: "300 10px sans-serif"
                }), params.poisLabel)
            ])
        }
    ];
};
// src/labeler.ts
var $26aceb2bff6f47cf$var$import_point_geometry5 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
var $26aceb2bff6f47cf$var$import_rbush = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_rbush_min());
// src/view.ts
var $26aceb2bff6f47cf$var$import_point_geometry4 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
var $26aceb2bff6f47cf$export$fd4a354f605b536 = (geom, scale, translate)=>{
    const retval = [];
    for (const arr2 of geom){
        const loop = [];
        for (const coord of arr2)loop.push(coord.clone().mult(scale).add(translate));
        retval.push(loop);
    }
    return retval;
};
var $26aceb2bff6f47cf$export$4997ffc0176396a6 = (val, z2)=>{
    const dim = 1 << z2;
    if (val < 0) return dim + val;
    if (val >= dim) return val % dim;
    return val;
};
var $26aceb2bff6f47cf$export$27a5bd065ad55220 = class {
    constructor(tileCache, maxDataLevel, levelDiff){
        this.tileCache = tileCache;
        this.maxDataLevel = maxDataLevel;
        this.levelDiff = levelDiff;
    }
    dataTilesForBounds(display_zoom, bounds) {
        const fractional = $26aceb2bff6f47cf$var$__pow(2, display_zoom) / $26aceb2bff6f47cf$var$__pow(2, Math.ceil(display_zoom));
        const needed = [];
        let scale = 1;
        const dim = this.tileCache.tileSize;
        if (display_zoom < this.levelDiff) {
            scale = 1 / (1 << this.levelDiff - display_zoom) * fractional;
            needed.push({
                data_tile: {
                    z: 0,
                    x: 0,
                    y: 0
                },
                origin: new $26aceb2bff6f47cf$var$import_point_geometry4.default(0, 0),
                scale: scale,
                dim: dim * scale
            });
        } else if (display_zoom <= this.levelDiff + this.maxDataLevel) {
            const f2 = 1 << this.levelDiff;
            const basetile_size = 256 * fractional;
            const data_zoom = Math.ceil(display_zoom) - this.levelDiff;
            const mintile_x = Math.floor(bounds.minX / f2 / basetile_size);
            const mintile_y = Math.floor(bounds.minY / f2 / basetile_size);
            const maxtile_x = Math.floor(bounds.maxX / f2 / basetile_size);
            const maxtile_y = Math.floor(bounds.maxY / f2 / basetile_size);
            for(let tx = mintile_x; tx <= maxtile_x; tx++)for(let ty = mintile_y; ty <= maxtile_y; ty++){
                const origin = new $26aceb2bff6f47cf$var$import_point_geometry4.default(tx * f2 * basetile_size, ty * f2 * basetile_size);
                needed.push({
                    data_tile: {
                        z: data_zoom,
                        x: $26aceb2bff6f47cf$export$4997ffc0176396a6(tx, data_zoom),
                        y: $26aceb2bff6f47cf$export$4997ffc0176396a6(ty, data_zoom)
                    },
                    origin: origin,
                    scale: fractional,
                    dim: dim * fractional
                });
            }
        } else {
            const f2 = 1 << this.levelDiff;
            scale = (1 << Math.ceil(display_zoom) - this.maxDataLevel - this.levelDiff) * fractional;
            const mintile_x = Math.floor(bounds.minX / f2 / 256 / scale);
            const mintile_y = Math.floor(bounds.minY / f2 / 256 / scale);
            const maxtile_x = Math.floor(bounds.maxX / f2 / 256 / scale);
            const maxtile_y = Math.floor(bounds.maxY / f2 / 256 / scale);
            for(let tx = mintile_x; tx <= maxtile_x; tx++)for(let ty = mintile_y; ty <= maxtile_y; ty++){
                const origin = new $26aceb2bff6f47cf$var$import_point_geometry4.default(tx * f2 * 256 * scale, ty * f2 * 256 * scale);
                needed.push({
                    data_tile: {
                        z: this.maxDataLevel,
                        x: $26aceb2bff6f47cf$export$4997ffc0176396a6(tx, this.maxDataLevel),
                        y: $26aceb2bff6f47cf$export$4997ffc0176396a6(ty, this.maxDataLevel)
                    },
                    origin: origin,
                    scale: scale,
                    dim: dim * scale
                });
            }
        }
        return needed;
    }
    dataTileForDisplayTile(display_tile) {
        let data_tile;
        let scale = 1;
        let dim = this.tileCache.tileSize;
        let origin;
        if (display_tile.z < this.levelDiff) {
            data_tile = {
                z: 0,
                x: 0,
                y: 0
            };
            scale = 1 / (1 << this.levelDiff - display_tile.z);
            origin = new $26aceb2bff6f47cf$var$import_point_geometry4.default(0, 0);
            dim = dim * scale;
        } else if (display_tile.z <= this.levelDiff + this.maxDataLevel) {
            const f2 = 1 << this.levelDiff;
            data_tile = {
                z: display_tile.z - this.levelDiff,
                x: Math.floor(display_tile.x / f2),
                y: Math.floor(display_tile.y / f2)
            };
            origin = new $26aceb2bff6f47cf$var$import_point_geometry4.default(data_tile.x * f2 * 256, data_tile.y * f2 * 256);
        } else {
            scale = 1 << display_tile.z - this.maxDataLevel - this.levelDiff;
            const f2 = 1 << this.levelDiff;
            data_tile = {
                z: this.maxDataLevel,
                x: Math.floor(display_tile.x / f2 / scale),
                y: Math.floor(display_tile.y / f2 / scale)
            };
            origin = new $26aceb2bff6f47cf$var$import_point_geometry4.default(data_tile.x * f2 * scale * 256, data_tile.y * f2 * scale * 256);
            dim = dim * scale;
        }
        return {
            data_tile: data_tile,
            scale: scale,
            origin: origin,
            dim: dim
        };
    }
    getBbox(display_zoom, bounds) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            const needed = this.dataTilesForBounds(display_zoom, bounds);
            const result = yield Promise.all(needed.map((tt)=>this.tileCache.get(tt.data_tile)));
            return result.map((data, i3)=>{
                const tt = needed[i3];
                return {
                    data: data,
                    z: display_zoom,
                    data_tile: tt.data_tile,
                    scale: tt.scale,
                    dim: tt.dim,
                    origin: tt.origin
                };
            });
        });
    }
    getDisplayTile(display_tile) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            const tt = this.dataTileForDisplayTile(display_tile);
            const data = yield this.tileCache.get(tt.data_tile);
            return {
                data: data,
                z: display_tile.z,
                data_tile: tt.data_tile,
                scale: tt.scale,
                origin: tt.origin,
                dim: tt.dim
            };
        });
    }
    queryFeatures(lng, lat, display_zoom) {
        const rounded_zoom = Math.round(display_zoom);
        const data_zoom = Math.min(rounded_zoom - this.levelDiff, this.maxDataLevel);
        const brush_size = 16 / (1 << rounded_zoom - data_zoom);
        return this.tileCache.queryFeatures(lng, lat, data_zoom, brush_size);
    }
};
var $26aceb2bff6f47cf$export$e21a3c14d9a8d1f5 = (options)=>{
    const sourceToViews = (o2)=>{
        const level_diff = o2.levelDiff === void 0 ? 2 : o2.levelDiff;
        const maxDataZoom = o2.maxDataZoom || 14;
        let source;
        if (typeof o2.url === "string") {
            if (o2.url.endsWith(".pmtiles")) source = new $26aceb2bff6f47cf$export$e9f49e1da310a6d(o2.url, true);
            else source = new $26aceb2bff6f47cf$export$426e0ee1ebcb1498(o2.url, true);
        } else source = new $26aceb2bff6f47cf$export$e9f49e1da310a6d(o2.url, true);
        const cache = new $26aceb2bff6f47cf$export$68a5b7ba031e74ec(source, 256 << level_diff);
        return new $26aceb2bff6f47cf$export$27a5bd065ad55220(cache, maxDataZoom, level_diff);
    };
    const sources = /* @__PURE__ */ new Map();
    if (options.sources) for(const key in options.sources)sources.set(key, sourceToViews(options.sources[key]));
    else sources.set("", sourceToViews(options));
    return sources;
};
// src/labeler.ts
var $26aceb2bff6f47cf$export$8a4968a148ef38ba = (display_zoom, tile_width, bbox)=>{
    const res = 256;
    const f2 = tile_width / res;
    const minx = Math.floor(bbox.minX / res);
    const miny = Math.floor(bbox.minY / res);
    const maxx = Math.floor(bbox.maxX / res);
    const maxy = Math.floor(bbox.maxY / res);
    const leveldiff = Math.log2(f2);
    const retval = [];
    for(let x2 = minx; x2 <= maxx; x2++){
        const wrapped_x = x2 % (1 << display_zoom);
        for(let y = miny; y <= maxy; y++)retval.push({
            display: $26aceb2bff6f47cf$export$94be71509d558c0f({
                z: display_zoom,
                x: wrapped_x,
                y: y
            }),
            key: $26aceb2bff6f47cf$export$94be71509d558c0f({
                z: display_zoom - leveldiff,
                x: Math.floor(wrapped_x / f2),
                y: Math.floor(y / f2)
            })
        });
    }
    return retval;
};
var $26aceb2bff6f47cf$export$cf17b003b6192af3 = class {
    constructor(dim, maxLabeledTiles){
        this.tree = new $26aceb2bff6f47cf$var$import_rbush.default();
        this.current = /* @__PURE__ */ new Map();
        this.dim = dim;
        this.maxLabeledTiles = maxLabeledTiles;
    }
    hasPrefix(tileKey) {
        for (const key of this.current.keys()){
            if (key.startsWith(tileKey)) return true;
        }
        return false;
    }
    has(tileKey) {
        return this.current.has(tileKey);
    }
    size() {
        return this.current.size;
    }
    keys() {
        return this.current.keys();
    }
    searchBbox(bbox, order) {
        const labels = /* @__PURE__ */ new Set();
        for (const match of this.tree.search(bbox))if (match.indexedLabel.order <= order) labels.add(match.indexedLabel);
        return labels;
    }
    searchLabel(label, order) {
        const labels = /* @__PURE__ */ new Set();
        for (const bbox of label.bboxes){
            for (const match of this.tree.search(bbox))if (match.indexedLabel.order <= order) labels.add(match.indexedLabel);
        }
        return labels;
    }
    bboxCollides(bbox, order) {
        for (const match of this.tree.search(bbox)){
            if (match.indexedLabel.order <= order) return true;
        }
        return false;
    }
    labelCollides(label, order) {
        for (const bbox of label.bboxes)for (const match of this.tree.search(bbox)){
            if (match.indexedLabel.order <= order) return true;
        }
        return false;
    }
    deduplicationCollides(label) {
        if (!label.deduplicationKey || !label.deduplicationDistance) return false;
        const dist = label.deduplicationDistance;
        const test_bbox = {
            minX: label.anchor.x - dist,
            minY: label.anchor.y - dist,
            maxX: label.anchor.x + dist,
            maxY: label.anchor.y + dist
        };
        for (const collision of this.tree.search(test_bbox))if (collision.indexedLabel.deduplicationKey === label.deduplicationKey) {
            if (collision.indexedLabel.anchor.dist(label.anchor) < dist) return true;
        }
        return false;
    }
    makeEntry(tileKey) {
        if (this.current.get(tileKey)) console.log("consistency error 1");
        const newSet = /* @__PURE__ */ new Set();
        this.current.set(tileKey, newSet);
    }
    insert(label, order, tileKey) {
        const indexedLabel = {
            anchor: label.anchor,
            bboxes: label.bboxes,
            draw: label.draw,
            order: order,
            tileKey: tileKey,
            deduplicationKey: label.deduplicationKey,
            deduplicationDistance: label.deduplicationDistance
        };
        let entry = this.current.get(tileKey);
        if (!entry) {
            const newSet = /* @__PURE__ */ new Set();
            this.current.set(tileKey, newSet);
            entry = newSet;
        }
        entry.add(indexedLabel);
        let wrapsLeft = false;
        let wrapsRight = false;
        for (const bbox of label.bboxes){
            this.tree.insert({
                minX: bbox.minX,
                minY: bbox.minY,
                maxX: bbox.maxX,
                maxY: bbox.maxY,
                indexedLabel: indexedLabel
            });
            if (bbox.minX < 0) wrapsLeft = true;
            if (bbox.maxX > this.dim) wrapsRight = true;
        }
        if (wrapsLeft || wrapsRight) {
            const shift2 = wrapsLeft ? this.dim : -this.dim;
            const new_bboxes = [];
            for (const bbox of label.bboxes)new_bboxes.push({
                minX: bbox.minX + shift2,
                minY: bbox.minY,
                maxX: bbox.maxX + shift2,
                maxY: bbox.maxY
            });
            const duplicate_label = {
                anchor: new $26aceb2bff6f47cf$var$import_point_geometry5.default(label.anchor.x + shift2, label.anchor.y),
                bboxes: new_bboxes,
                draw: label.draw,
                order: order,
                tileKey: tileKey
            };
            const entry2 = this.current.get(tileKey);
            if (entry2) entry2.add(duplicate_label);
            for (const bbox of new_bboxes)this.tree.insert({
                minX: bbox.minX,
                minY: bbox.minY,
                maxX: bbox.maxX,
                maxY: bbox.maxY,
                indexedLabel: duplicate_label
            });
        }
    }
    pruneOrNoop(key_added) {
        const added = key_added.split(":");
        let max_key = void 0;
        let max_dist = 0;
        let keys_for_ds = 0;
        for (const existing_key of this.current.keys()){
            const existing = existing_key.split(":");
            if (existing[3] === added[3]) {
                keys_for_ds++;
                const dist = Math.sqrt($26aceb2bff6f47cf$var$__pow(+existing[0] - +added[0], 2) + $26aceb2bff6f47cf$var$__pow(+existing[1] - +added[1], 2));
                if (dist > max_dist) {
                    max_dist = dist;
                    max_key = existing_key;
                }
            }
            if (max_key && keys_for_ds > this.maxLabeledTiles) this.pruneKey(max_key);
        }
    }
    pruneKey(keyToRemove) {
        const indexed_labels = this.current.get(keyToRemove);
        if (!indexed_labels) return;
        const entries_to_delete = [];
        for (const entry of this.tree.all())if (indexed_labels.has(entry.indexedLabel)) entries_to_delete.push(entry);
        for (const entry of entries_to_delete)this.tree.remove(entry);
        this.current.delete(keyToRemove);
    }
    removeLabel(labelToRemove) {
        const entries_to_delete = [];
        for (const entry of this.tree.all())if (labelToRemove === entry.indexedLabel) entries_to_delete.push(entry);
        for (const entry of entries_to_delete)this.tree.remove(entry);
        const c2 = this.current.get(labelToRemove.tileKey);
        if (c2) c2.delete(labelToRemove);
    }
};
var $26aceb2bff6f47cf$export$66d167152c83103b = class {
    constructor(z2, scratch, labelRules2, maxLabeledTiles, callback){
        this.index = new $26aceb2bff6f47cf$export$cf17b003b6192af3(256 << z2, maxLabeledTiles);
        this.z = z2;
        this.scratch = scratch;
        this.labelRules = labelRules2;
        this.callback = callback;
    }
    layout(prepared_tilemap) {
        const start = performance.now();
        const keys_adding = /* @__PURE__ */ new Set();
        for (const [k, prepared_tiles] of prepared_tilemap)for (const prepared_tile of prepared_tiles){
            const key = `${$26aceb2bff6f47cf$export$94be71509d558c0f(prepared_tile.data_tile)}:${k}`;
            if (!this.index.has(key)) {
                this.index.makeEntry(key);
                keys_adding.add(key);
            }
        }
        const tiles_invalidated = /* @__PURE__ */ new Set();
        for (const [order, rule] of this.labelRules.entries()){
            if (rule.visible === false) continue;
            if (rule.minzoom && this.z < rule.minzoom) continue;
            if (rule.maxzoom && this.z > rule.maxzoom) continue;
            const dsName = rule.dataSource || "";
            const prepared_tiles = prepared_tilemap.get(dsName);
            if (!prepared_tiles) continue;
            for (const prepared_tile of prepared_tiles){
                const key = `${$26aceb2bff6f47cf$export$94be71509d558c0f(prepared_tile.data_tile)}:${dsName}`;
                if (!keys_adding.has(key)) continue;
                const layer = prepared_tile.data.get(rule.dataLayer);
                if (layer === void 0) continue;
                const feats = layer;
                if (rule.sort) feats.sort((a2, b)=>{
                    if (rule.sort) return rule.sort(a2.props, b.props);
                    return 0;
                });
                const layout = {
                    index: this.index,
                    zoom: this.z,
                    scratch: this.scratch,
                    order: order,
                    overzoom: this.z - prepared_tile.data_tile.z
                };
                for (const feature of feats){
                    if (rule.filter && !rule.filter(this.z, feature)) continue;
                    const transformed = $26aceb2bff6f47cf$export$fd4a354f605b536(feature.geom, prepared_tile.scale, prepared_tile.origin);
                    const labels = rule.symbolizer.place(layout, transformed, feature);
                    if (!labels) continue;
                    for (const label of labels){
                        let label_added = false;
                        if (label.deduplicationKey && this.index.deduplicationCollides(label)) continue;
                        if (this.index.labelCollides(label, Infinity)) {
                            if (!this.index.labelCollides(label, order)) {
                                const conflicts = this.index.searchLabel(label, Infinity);
                                for (const conflict of conflicts){
                                    this.index.removeLabel(conflict);
                                    for (const bbox of conflict.bboxes)this.findInvalidatedTiles(tiles_invalidated, prepared_tile.dim, bbox, key);
                                }
                                this.index.insert(label, order, key);
                                label_added = true;
                            }
                        } else {
                            this.index.insert(label, order, key);
                            label_added = true;
                        }
                        if (label_added) {
                            for (const bbox of label.bboxes)if (bbox.maxX > prepared_tile.origin.x + prepared_tile.dim || bbox.minX < prepared_tile.origin.x || bbox.minY < prepared_tile.origin.y || bbox.maxY > prepared_tile.origin.y + prepared_tile.dim) this.findInvalidatedTiles(tiles_invalidated, prepared_tile.dim, bbox, key);
                        }
                    }
                }
            }
        }
        for (const key of keys_adding)this.index.pruneOrNoop(key);
        if (tiles_invalidated.size > 0 && this.callback) this.callback(tiles_invalidated);
        return performance.now() - start;
    }
    findInvalidatedTiles(tiles_invalidated, dim, bbox, key) {
        const touched = $26aceb2bff6f47cf$export$8a4968a148ef38ba(this.z, dim, bbox);
        for (const s2 of touched)if (s2.key !== key && this.index.hasPrefix(s2.key)) tiles_invalidated.add(s2.display);
    }
    add(prepared_tilemap) {
        let all_added = true;
        for (const [k, prepared_tiles] of prepared_tilemap){
            for (const prepared_tile of prepared_tiles)if (!this.index.has(`${$26aceb2bff6f47cf$export$94be71509d558c0f(prepared_tile.data_tile)}:${k}`)) all_added = false;
        }
        if (all_added) return 0;
        const timing = this.layout(prepared_tilemap);
        return timing;
    }
};
var $26aceb2bff6f47cf$export$4627dfe67323a6ae = class {
    constructor(scratch, labelRules2, maxLabeledTiles, callback){
        this.labelers = /* @__PURE__ */ new Map();
        this.scratch = scratch;
        this.labelRules = labelRules2;
        this.maxLabeledTiles = maxLabeledTiles;
        this.callback = callback;
    }
    add(z2, prepared_tilemap) {
        let labeler = this.labelers.get(z2);
        if (labeler) return labeler.add(prepared_tilemap);
        labeler = new $26aceb2bff6f47cf$export$66d167152c83103b(z2, this.scratch, this.labelRules, this.maxLabeledTiles, this.callback);
        this.labelers.set(z2, labeler);
        return labeler.add(prepared_tilemap);
    }
    getIndex(z2) {
        const labeler = this.labelers.get(z2);
        if (labeler) return labeler.index;
    }
};
// src/painter.ts
var $26aceb2bff6f47cf$var$import_point_geometry6 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
function $26aceb2bff6f47cf$export$a4f0684a6ca45673(ctx, z2, prepared_tilemap, label_data, rules, bbox, origin, clip, debug) {
    const start = performance.now();
    ctx.save();
    ctx.miterLimit = 2;
    for (const rule of rules){
        if (rule.minzoom && z2 < rule.minzoom) continue;
        if (rule.maxzoom && z2 > rule.maxzoom) continue;
        const prepared_tiles = prepared_tilemap.get(rule.dataSource || "");
        if (!prepared_tiles) continue;
        for (const prepared_tile of prepared_tiles){
            const layer = prepared_tile.data.get(rule.dataLayer);
            if (layer === void 0) continue;
            if (rule.symbolizer.before) rule.symbolizer.before(ctx, prepared_tile.z);
            const po = prepared_tile.origin;
            const dim = prepared_tile.dim;
            const ps = prepared_tile.scale;
            ctx.save();
            if (clip) {
                ctx.beginPath();
                const minX = Math.max(po.x - origin.x, bbox.minX - origin.x);
                const minY = Math.max(po.y - origin.y, bbox.minY - origin.y);
                const maxX = Math.min(po.x - origin.x + dim, bbox.maxX - origin.x);
                const maxY = Math.min(po.y - origin.y + dim, bbox.maxY - origin.y);
                ctx.rect(minX, minY, maxX - minX, maxY - minY);
                ctx.clip();
            }
            ctx.translate(po.x - origin.x, po.y - origin.y);
            for (const feature of layer){
                let geom = feature.geom;
                const fbox = feature.bbox;
                if (fbox.maxX * ps + po.x < bbox.minX || fbox.minX * ps + po.x > bbox.maxX || fbox.minY * ps + po.y > bbox.maxY || fbox.maxY * ps + po.y < bbox.minY) continue;
                if (rule.filter && !rule.filter(prepared_tile.z, feature)) continue;
                if (ps !== 1) geom = $26aceb2bff6f47cf$export$fd4a354f605b536(geom, ps, new $26aceb2bff6f47cf$var$import_point_geometry6.default(0, 0));
                rule.symbolizer.draw(ctx, geom, prepared_tile.z, feature);
            }
            ctx.restore();
        }
    }
    if (clip) {
        ctx.beginPath();
        ctx.rect(bbox.minX - origin.x, bbox.minY - origin.y, bbox.maxX - bbox.minX, bbox.maxY - bbox.minY);
        ctx.clip();
    }
    if (label_data) {
        const matches = label_data.searchBbox(bbox, Infinity);
        for (const label of matches){
            ctx.save();
            ctx.translate(label.anchor.x - origin.x, label.anchor.y - origin.y);
            label.draw(ctx);
            ctx.restore();
            if (debug) {
                ctx.lineWidth = 0.5;
                ctx.strokeStyle = debug;
                ctx.fillStyle = debug;
                ctx.globalAlpha = 1;
                ctx.fillRect(label.anchor.x - origin.x - 2, label.anchor.y - origin.y - 2, 4, 4);
                for (const bbox2 of label.bboxes)ctx.strokeRect(bbox2.minX - origin.x, bbox2.minY - origin.y, bbox2.maxX - bbox2.minX, bbox2.maxY - bbox2.minY);
            }
        }
    }
    ctx.restore();
    return performance.now() - start;
}
// src/xray.ts
var $26aceb2bff6f47cf$var$xray_symbolizers = (dataSource, dataLayer, color)=>{
    return [
        {
            dataSource: dataSource,
            dataLayer: dataLayer,
            symbolizer: new $26aceb2bff6f47cf$export$8bf8f73f069748a0({
                opacity: 0.2,
                fill: color,
                radius: 4
            }),
            filter: (z2, f2)=>{
                return f2.geomType === 1 /* Point */ ;
            }
        },
        {
            dataSource: dataSource,
            dataLayer: dataLayer,
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                opacity: 0.2,
                color: color,
                width: 2
            }),
            filter: (z2, f2)=>{
                return f2.geomType === 2 /* Line */ ;
            }
        },
        {
            dataSource: dataSource,
            dataLayer: dataLayer,
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                opacity: 0.2,
                fill: color,
                stroke: color,
                width: 1
            }),
            filter: (z2, f2)=>{
                return f2.geomType === 3 /* Polygon */ ;
            }
        }
    ];
};
var $26aceb2bff6f47cf$var$xray_rules = (prepared_tilemap, xray)=>{
    let rules = [];
    for (const [dataSource, tiles] of prepared_tilemap){
        for (const tile of tiles)for (const dataLayer of tile.data.keys()){
            if (dataSource === xray.dataSource && dataLayer === xray.dataLayer) ;
            else rules = rules.concat($26aceb2bff6f47cf$var$xray_symbolizers(dataSource, dataLayer, "steelblue"));
        }
    }
    rules = rules.concat($26aceb2bff6f47cf$var$xray_symbolizers(xray.dataSource || "", xray.dataLayer, "red"));
    return rules;
};
// src/frontends/static.ts
var $26aceb2bff6f47cf$var$R2 = 6378137;
var $26aceb2bff6f47cf$var$MAX_LATITUDE2 = 85.0511287798;
var $26aceb2bff6f47cf$var$MAXCOORD2 = $26aceb2bff6f47cf$var$R2 * Math.PI;
var $26aceb2bff6f47cf$var$project2 = (latlng)=>{
    const d = Math.PI / 180;
    const constrained_lat = Math.max(Math.min($26aceb2bff6f47cf$var$MAX_LATITUDE2, latlng.y), -$26aceb2bff6f47cf$var$MAX_LATITUDE2);
    const sin = Math.sin(constrained_lat * d);
    return new $26aceb2bff6f47cf$var$import_point_geometry7.default($26aceb2bff6f47cf$var$R2 * latlng.x * d, $26aceb2bff6f47cf$var$R2 * Math.log((1 + sin) / (1 - sin)) / 2);
};
var $26aceb2bff6f47cf$var$unproject = (point)=>{
    const d = 180 / Math.PI;
    return {
        lat: (2 * Math.atan(Math.exp(point.y / $26aceb2bff6f47cf$var$R2)) - Math.PI / 2) * d,
        lng: point.x * d / $26aceb2bff6f47cf$var$R2
    };
};
var $26aceb2bff6f47cf$var$instancedProject = (origin, display_zoom)=>{
    return (latlng)=>{
        const projected = $26aceb2bff6f47cf$var$project2(latlng);
        const normalized = new $26aceb2bff6f47cf$var$import_point_geometry7.default((projected.x + $26aceb2bff6f47cf$var$MAXCOORD2) / ($26aceb2bff6f47cf$var$MAXCOORD2 * 2), 1 - (projected.y + $26aceb2bff6f47cf$var$MAXCOORD2) / ($26aceb2bff6f47cf$var$MAXCOORD2 * 2));
        return normalized.mult((1 << display_zoom) * 256).sub(origin);
    };
};
var $26aceb2bff6f47cf$var$instancedUnproject = (origin, display_zoom)=>{
    return (point)=>{
        const normalized = new $26aceb2bff6f47cf$var$import_point_geometry7.default(point.x, point.y).add(origin).div((1 << display_zoom) * 256);
        const projected = new $26aceb2bff6f47cf$var$import_point_geometry7.default(normalized.x * ($26aceb2bff6f47cf$var$MAXCOORD2 * 2) - $26aceb2bff6f47cf$var$MAXCOORD2, (1 - normalized.y) * ($26aceb2bff6f47cf$var$MAXCOORD2 * 2) - $26aceb2bff6f47cf$var$MAXCOORD2);
        return $26aceb2bff6f47cf$var$unproject(projected);
    };
};
var $26aceb2bff6f47cf$export$dbd6ca799c1daca5 = (degrees_lng, css_pixels)=>{
    const d = css_pixels * (360 / degrees_lng);
    return Math.log2(d / 256);
};
var $26aceb2bff6f47cf$export$c1b9a1d3af45b7b6 = class {
    constructor(options){
        const theme = options.dark ? $26aceb2bff6f47cf$export$55ce6f3a06c59543 : $26aceb2bff6f47cf$export$a43af521ac8c3202;
        this.paint_rules = options.paint_rules || $26aceb2bff6f47cf$export$d80259effe069058(theme, options.shade);
        this.label_rules = options.label_rules || $26aceb2bff6f47cf$export$fe153b1eddbceef9(theme, options.shade, options.language1, options.language2);
        this.backgroundColor = options.backgroundColor;
        this.views = $26aceb2bff6f47cf$export$e21a3c14d9a8d1f5(options);
        this.debug = options.debug || "";
        this.xray = options.xray;
    }
    drawContext(ctx, width, height, latlng, display_zoom) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            const center = $26aceb2bff6f47cf$var$project2(latlng);
            const normalized_center = new $26aceb2bff6f47cf$var$import_point_geometry7.default((center.x + $26aceb2bff6f47cf$var$MAXCOORD2) / ($26aceb2bff6f47cf$var$MAXCOORD2 * 2), 1 - (center.y + $26aceb2bff6f47cf$var$MAXCOORD2) / ($26aceb2bff6f47cf$var$MAXCOORD2 * 2));
            const origin = normalized_center.clone().mult($26aceb2bff6f47cf$var$__pow(2, display_zoom) * 256).sub(new $26aceb2bff6f47cf$var$import_point_geometry7.default(width / 2, height / 2));
            const bbox = {
                minX: origin.x,
                minY: origin.y,
                maxX: origin.x + width,
                maxY: origin.y + height
            };
            const promises = [];
            for (const [k, v] of this.views){
                const promise = v.getBbox(display_zoom, bbox);
                promises.push({
                    key: k,
                    promise: promise
                });
            }
            const tile_responses = yield Promise.all(promises.map((o2)=>{
                return o2.promise.then((v)=>{
                    return {
                        status: "fulfilled",
                        value: v,
                        key: o2.key
                    };
                }, (error)=>{
                    return {
                        status: "rejected",
                        value: [],
                        reason: error,
                        key: o2.key
                    };
                });
            }));
            const prepared_tilemap = /* @__PURE__ */ new Map();
            for (const tile_response of tile_responses)if (tile_response.status === "fulfilled") prepared_tilemap.set(tile_response.key, tile_response.value);
            const start = performance.now();
            const labeler = new $26aceb2bff6f47cf$export$66d167152c83103b(display_zoom, ctx, this.label_rules, 16, void 0);
            const layout_time = labeler.add(prepared_tilemap);
            if (this.backgroundColor) {
                ctx.save();
                ctx.fillStyle = this.backgroundColor;
                ctx.fillRect(0, 0, width, height);
                ctx.restore();
            }
            let paint_rules = this.paint_rules;
            if (this.xray) paint_rules = $26aceb2bff6f47cf$var$xray_rules(prepared_tilemap, this.xray);
            const p2 = $26aceb2bff6f47cf$export$a4f0684a6ca45673(ctx, display_zoom, prepared_tilemap, this.xray ? null : labeler.index, paint_rules, bbox, origin, true, this.debug);
            if (this.debug) {
                ctx.save();
                ctx.translate(-origin.x, -origin.y);
                ctx.strokeStyle = this.debug;
                ctx.fillStyle = this.debug;
                ctx.font = "12px sans-serif";
                let idx = 0;
                for (const [k, v] of prepared_tilemap){
                    for (const prepared_tile of v){
                        ctx.strokeRect(prepared_tile.origin.x, prepared_tile.origin.y, prepared_tile.dim, prepared_tile.dim);
                        const dt = prepared_tile.data_tile;
                        ctx.fillText(`${k + (k ? " " : "") + dt.z} ${dt.x} ${dt.y}`, prepared_tile.origin.x + 4, prepared_tile.origin.y + 14 * (1 + idx));
                    }
                    idx++;
                }
                ctx.restore();
            }
            return {
                elapsed: performance.now() - start,
                project: $26aceb2bff6f47cf$var$instancedProject(origin, display_zoom),
                unproject: $26aceb2bff6f47cf$var$instancedUnproject(origin, display_zoom)
            };
        });
    }
    drawCanvas(_0, _1, _2) {
        return $26aceb2bff6f47cf$var$__async(this, arguments, function*(canvas, latlng, display_zoom, options = {}) {
            const dpr = window.devicePixelRatio;
            const width = canvas.clientWidth;
            const height = canvas.clientHeight;
            if (!(canvas.width === width * dpr && canvas.height === height * dpr)) {
                canvas.width = width * dpr;
                canvas.height = height * dpr;
            }
            if (options.lang) canvas.lang = options.lang;
            const ctx = canvas.getContext("2d");
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            return this.drawContext(ctx, width, height, latlng, display_zoom);
        });
    }
    drawContextBounds(ctx, top_left, bottom_right, width, height) {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            const delta_degrees = bottom_right.x - top_left.x;
            const center = new $26aceb2bff6f47cf$var$import_point_geometry7.default((top_left.x + bottom_right.x) / 2, (top_left.y + bottom_right.y) / 2);
            return this.drawContext(ctx, width, height, center, $26aceb2bff6f47cf$export$dbd6ca799c1daca5(delta_degrees, width));
        });
    }
    drawCanvasBounds(_0, _1, _2, _3) {
        return $26aceb2bff6f47cf$var$__async(this, arguments, function*(canvas, top_left, bottom_right, width, options = {}) {
            const delta_degrees = bottom_right.x - top_left.x;
            const center = new $26aceb2bff6f47cf$var$import_point_geometry7.default((top_left.x + bottom_right.x) / 2, (top_left.y + bottom_right.y) / 2);
            return this.drawCanvas(canvas, center, $26aceb2bff6f47cf$export$dbd6ca799c1daca5(delta_degrees, width), options);
        });
    }
};
// src/frontends/leaflet.ts
var $26aceb2bff6f47cf$var$import_point_geometry8 = $26aceb2bff6f47cf$var$__toESM($26aceb2bff6f47cf$var$require_point_geometry());
var $26aceb2bff6f47cf$var$timer = (duration)=>{
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            resolve();
        }, duration);
    });
};
var $26aceb2bff6f47cf$var$reflect = (promise)=>{
    return promise.then((v)=>{
        return {
            status: "fulfilled",
            value: v
        };
    }, (error)=>{
        return {
            status: "rejected",
            reason: error
        };
    });
};
var $26aceb2bff6f47cf$export$9099b29bdc58680 = (options = {})=>{
    class LeafletLayer extends L.GridLayer {
        constructor(options2 = {}){
            if (options2.noWrap && !options2.bounds) options2.bounds = [
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ];
            if (options2.attribution == null) options2.attribution = '<a href="https://protomaps.com">Protomaps</a> \xA9 <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>';
            super(options2);
            const theme = options2.dark ? $26aceb2bff6f47cf$export$55ce6f3a06c59543 : $26aceb2bff6f47cf$export$a43af521ac8c3202;
            this.paint_rules = options2.paint_rules || $26aceb2bff6f47cf$export$d80259effe069058(theme, options2.shade);
            this.label_rules = options2.label_rules || $26aceb2bff6f47cf$export$fe153b1eddbceef9(theme, options2.shade, options2.language1, options2.language2);
            this.backgroundColor = options2.backgroundColor;
            this.lastRequestedZ = void 0;
            this.xray = options2.xray;
            this.tasks = options2.tasks || [];
            this.views = $26aceb2bff6f47cf$export$e21a3c14d9a8d1f5(options2);
            this.debug = options2.debug;
            const scratch = document.createElement("canvas").getContext("2d");
            this.scratch = scratch;
            this.onTilesInvalidated = (tiles)=>{
                for (const t2 of tiles)this.rerenderTile(t2);
            };
            this.labelers = new $26aceb2bff6f47cf$export$4627dfe67323a6ae(this.scratch, this.label_rules, 16, this.onTilesInvalidated);
            this.tile_size = 256 * window.devicePixelRatio;
            this.tileDelay = options2.tileDelay || 3;
            this.lang = options2.lang;
            this.inspector = this.inspect(this);
        }
        setDefaultStyle(darkOption, shade, language1, language2) {
            const theme = darkOption ? $26aceb2bff6f47cf$export$55ce6f3a06c59543 : $26aceb2bff6f47cf$export$a43af521ac8c3202;
            this.paint_rules = $26aceb2bff6f47cf$export$d80259effe069058(theme, shade);
            this.label_rules = $26aceb2bff6f47cf$export$fe153b1eddbceef9(theme, shade, language1, language2);
        }
        renderTile(coords, element, key, done = ()=>{}) {
            return $26aceb2bff6f47cf$var$__async(this, null, function*() {
                this.lastRequestedZ = coords.z;
                const promises = [];
                for (const [k, v] of this.views){
                    const promise = v.getDisplayTile(coords);
                    promises.push({
                        key: k,
                        promise: promise
                    });
                }
                const tile_responses = yield Promise.all(promises.map((o2)=>{
                    return o2.promise.then((v)=>{
                        return {
                            status: "fulfilled",
                            value: v,
                            key: o2.key
                        };
                    }, (error)=>{
                        return {
                            status: "rejected",
                            reason: error,
                            key: o2.key
                        };
                    });
                }));
                const prepared_tilemap = /* @__PURE__ */ new Map();
                for (const tile_response of tile_responses)if (tile_response.status === "fulfilled") prepared_tilemap.set(tile_response.key, [
                    tile_response.value
                ]);
                else {
                    if (tile_response.reason.name === "AbortError") ;
                    else console.error(tile_response.reason);
                }
                if (element.key !== key) return;
                if (this.lastRequestedZ !== coords.z) return;
                yield Promise.all(this.tasks.map($26aceb2bff6f47cf$var$reflect));
                if (element.key !== key) return;
                if (this.lastRequestedZ !== coords.z) return;
                const layout_time = this.labelers.add(coords.z, prepared_tilemap);
                if (element.key !== key) return;
                if (this.lastRequestedZ !== coords.z) return;
                const label_data = this.labelers.getIndex(coords.z);
                if (!this._map) return;
                const center = this._map.getCenter().wrap();
                const pixelBounds = this._getTiledPixelBounds(center);
                const tileRange = this._pxBoundsToTileRange(pixelBounds);
                const tileCenter = tileRange.getCenter();
                const priority = coords.distanceTo(tileCenter) * this.tileDelay;
                yield $26aceb2bff6f47cf$var$timer(priority);
                if (element.key !== key) return;
                if (this.lastRequestedZ !== coords.z) return;
                const BUF = 16;
                const bbox = {
                    minX: 256 * coords.x - BUF,
                    minY: 256 * coords.y - BUF,
                    maxX: 256 * (coords.x + 1) + BUF,
                    maxY: 256 * (coords.y + 1) + BUF
                };
                const origin = new $26aceb2bff6f47cf$var$import_point_geometry8.default(256 * coords.x, 256 * coords.y);
                element.width = this.tile_size;
                element.height = this.tile_size;
                const ctx = element.getContext("2d");
                ctx.setTransform(this.tile_size / 256, 0, 0, this.tile_size / 256, 0, 0);
                ctx.clearRect(0, 0, 256, 256);
                if (this.backgroundColor) {
                    ctx.save();
                    ctx.fillStyle = this.backgroundColor;
                    ctx.fillRect(0, 0, 256, 256);
                    ctx.restore();
                }
                let painting_time = 0;
                let paint_rules = this.paint_rules;
                if (this.xray) paint_rules = $26aceb2bff6f47cf$var$xray_rules(prepared_tilemap, this.xray);
                painting_time = $26aceb2bff6f47cf$export$a4f0684a6ca45673(ctx, coords.z, prepared_tilemap, this.xray ? null : label_data, paint_rules, bbox, origin, false, this.debug);
                if (this.debug) {
                    ctx.save();
                    ctx.fillStyle = this.debug;
                    ctx.font = "600 12px sans-serif";
                    ctx.fillText(`${coords.z} ${coords.x} ${coords.y}`, 4, 14);
                    ctx.font = "12px sans-serif";
                    let ypos = 28;
                    for (const [k, v] of prepared_tilemap){
                        const dt = v[0].data_tile;
                        ctx.fillText(`${k + (k ? " " : "") + dt.z} ${dt.x} ${dt.y}`, 4, ypos);
                        ypos += 14;
                    }
                    ctx.font = "600 10px sans-serif";
                    if (painting_time > 8) {
                        ctx.fillText(`${painting_time.toFixed()} ms paint`, 4, ypos);
                        ypos += 14;
                    }
                    if (layout_time > 8) ctx.fillText(`${layout_time.toFixed()} ms layout`, 4, ypos);
                    ctx.strokeStyle = this.debug;
                    ctx.lineWidth = 0.5;
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.lineTo(0, 256);
                    ctx.stroke();
                    ctx.lineWidth = 0.5;
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.lineTo(256, 0);
                    ctx.stroke();
                    ctx.restore();
                }
                done();
            });
        }
        rerenderTile(key) {
            for(const unwrapped_k in this._tiles){
                const wrapped_coord = this._wrapCoords(this._keyToTileCoords(unwrapped_k));
                if (key === this._tileCoordsToKey(wrapped_coord)) this.renderTile(wrapped_coord, this._tiles[unwrapped_k].el, key);
            }
        }
        clearLayout() {
            this.labelers = new $26aceb2bff6f47cf$export$4627dfe67323a6ae(this.scratch, this.label_rules, 16, this.onTilesInvalidated);
        }
        rerenderTiles() {
            for(const unwrapped_k in this._tiles){
                const wrapped_coord = this._wrapCoords(this._keyToTileCoords(unwrapped_k));
                const key = this._tileCoordsToKey(wrapped_coord);
                this.renderTile(wrapped_coord, this._tiles[unwrapped_k].el, key);
            }
        }
        createTile(coords, showTile) {
            const element = L.DomUtil.create("canvas", "leaflet-tile");
            element.lang = this.lang;
            const key = this._tileCoordsToKey(coords);
            element.key = key;
            this.renderTile(coords, element, key, ()=>{
                showTile(null, element);
            });
            return element;
        }
        _removeTile(key) {
            const tile = this._tiles[key];
            if (!tile) return;
            tile.el.removed = true;
            tile.el.key = void 0;
            L.DomUtil.removeClass(tile.el, "leaflet-tile-loaded");
            tile.el.width = tile.el.height = 0;
            L.DomUtil.remove(tile.el);
            delete this._tiles[key];
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        }
        queryFeatures(lng, lat) {
            const featuresBySourceName = /* @__PURE__ */ new Map();
            for (const [sourceName, view] of this.views)featuresBySourceName.set(sourceName, view.queryFeatures(lng, lat, this._map.getZoom()));
            return featuresBySourceName;
        }
        inspect(layer) {
            return (ev)=>{
                const typeGlyphs = [
                    "\u25CE",
                    "\u27CD",
                    "\u25FB"
                ];
                const wrapped = layer._map.wrapLatLng(ev.latlng);
                const resultsBySourceName = layer.queryFeatures(wrapped.lng, wrapped.lat);
                let content = "";
                let firstRow = true;
                for (const [sourceName, results] of resultsBySourceName)for (const result of results){
                    if (this.xray && this.xray !== true) {
                        if (!((this.xray.dataSource || "") === sourceName && this.xray.dataLayer === result.layerName)) continue;
                    }
                    content = `${content}<div style="margin-top:${firstRow ? 0 : 0.5}em">${typeGlyphs[result.feature.geomType - 1]} <b>${sourceName} ${sourceName ? "/" : ""} ${result.layerName}</b> ${result.feature.id || ""}</div>`;
                    for(const prop in result.feature.props)content = `${content}<div style="font-size:0.9em">${prop} = ${result.feature.props[prop]}</div>`;
                    firstRow = false;
                }
                if (firstRow) content = "No features.";
                L.popup().setLatLng(ev.latlng).setContent(`<div style="max-height:400px;overflow-y:scroll;padding-right:8px">${content}</div>`).openOn(layer._map);
            };
        }
        addInspector(map) {
            return map.on("click", this.inspector);
        }
        removeInspector(map) {
            return map.off("click", this.inspector);
        }
    }
    return new LeafletLayer(options);
};
// node_modules/potpack/index.mjs
function $26aceb2bff6f47cf$var$potpack(boxes) {
    let area = 0;
    let maxWidth = 0;
    for (const box of boxes){
        area += box.w * box.h;
        maxWidth = Math.max(maxWidth, box.w);
    }
    boxes.sort((a2, b)=>b.h - a2.h);
    const startWidth = Math.max(Math.ceil(Math.sqrt(area / 0.95)), maxWidth);
    const spaces = [
        {
            x: 0,
            y: 0,
            w: startWidth,
            h: Infinity
        }
    ];
    let width = 0;
    let height = 0;
    for (const box of boxes)for(let i3 = spaces.length - 1; i3 >= 0; i3--){
        const space = spaces[i3];
        if (box.w > space.w || box.h > space.h) continue;
        box.x = space.x;
        box.y = space.y;
        height = Math.max(height, box.y + box.h);
        width = Math.max(width, box.x + box.w);
        if (box.w === space.w && box.h === space.h) {
            const last = spaces.pop();
            if (i3 < spaces.length) spaces[i3] = last;
        } else if (box.h === space.h) {
            space.x += box.w;
            space.w -= box.w;
        } else if (box.w === space.w) {
            space.y += box.h;
            space.h -= box.h;
        } else {
            spaces.push({
                x: space.x + box.w,
                y: space.y,
                w: space.w - box.w,
                h: box.h
            });
            space.y += box.h;
            space.h -= box.h;
        }
        break;
    }
    return {
        w: width,
        h: height,
        fill: area / (width * height) || 0
    };
}
// src/task.ts
var $26aceb2bff6f47cf$export$89abf52a030e56ee = (name, url, weight)=>{
    const ff = new FontFace(name, `url(${url})`, {
        weight: weight
    });
    document.fonts.add(ff);
    return ff.load();
};
var $26aceb2bff6f47cf$var$mkimg = (src)=>$26aceb2bff6f47cf$var$__async(void 0, null, function*() {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject("Invalid SVG");
            img.src = src;
        });
    });
var $26aceb2bff6f47cf$var$MISSING = `
<svg width="20px" height="20px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" fill="#cccccc"/>
    <g transform="translate(5,5)">
        <path fill="none" stroke="#666666" stroke-width="7" d="m11,12a8.5,8 0 1,1 17,0q0,4-4,6t-4.5,4.5-.4,4v.2m0,3v7"/>
    </g>
</svg>
`;
var $26aceb2bff6f47cf$export$a9bf29f8d87ebbee = class {
    constructor(src){
        this.src = src;
        this.canvas = document.createElement("canvas");
        this.mapping = /* @__PURE__ */ new Map();
        this.missingBox = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
    }
    load() {
        return $26aceb2bff6f47cf$var$__async(this, null, function*() {
            let src = this.src;
            const scale = window.devicePixelRatio;
            if (src.endsWith(".html")) {
                const c2 = yield fetch(src);
                src = yield c2.text();
            }
            const tree = new window.DOMParser().parseFromString(src, "text/html");
            const icons = Array.from(tree.body.children);
            const missingImg = yield $26aceb2bff6f47cf$var$mkimg(`data:image/svg+xml;base64,${btoa($26aceb2bff6f47cf$var$MISSING)}`);
            const boxes = [
                {
                    w: missingImg.width * scale,
                    h: missingImg.height * scale,
                    img: missingImg,
                    id: ""
                }
            ];
            const serializer = new XMLSerializer();
            for (const ps of icons){
                const svg64 = btoa(serializer.serializeToString(ps));
                const image64 = `data:image/svg+xml;base64,${svg64}`;
                const img = yield $26aceb2bff6f47cf$var$mkimg(image64);
                boxes.push({
                    w: img.width * scale,
                    h: img.height * scale,
                    img: img,
                    id: ps.id
                });
            }
            const packresult = $26aceb2bff6f47cf$var$potpack(boxes);
            this.canvas.width = packresult.w;
            this.canvas.height = packresult.h;
            const ctx = this.canvas.getContext("2d");
            if (ctx) {
                for (const box of boxes)if (box.x !== void 0 && box.y !== void 0) {
                    ctx.drawImage(box.img, box.x, box.y, box.w, box.h);
                    if (box.id) this.mapping.set(box.id, {
                        x: box.x,
                        y: box.y,
                        w: box.w,
                        h: box.h
                    });
                    else this.missingBox = {
                        x: box.x,
                        y: box.y,
                        w: box.w,
                        h: box.h
                    };
                }
            }
            return this;
        });
    }
    get(name) {
        let result = this.mapping.get(name);
        if (!result) result = this.missingBox;
        return result;
    }
};
// src/compat/json_style.ts
function $26aceb2bff6f47cf$var$number(val, defaultValue) {
    return typeof val === "number" ? val : defaultValue;
}
function $26aceb2bff6f47cf$export$7200eb76f79cdd1a(arr2) {
    if (arr2.includes("$type")) return (z2)=>true;
    if (arr2[0] === "==") return (z2, f2)=>f2.props[arr2[1]] === arr2[2];
    if (arr2[0] === "!=") return (z2, f2)=>f2.props[arr2[1]] !== arr2[2];
    if (arr2[0] === "!") {
        const sub = $26aceb2bff6f47cf$export$7200eb76f79cdd1a(arr2[1]);
        return (z2, f2)=>!sub(z2, f2);
    }
    if (arr2[0] === "<") return (z2, f2)=>$26aceb2bff6f47cf$var$number(f2.props[arr2[1]], Infinity) < arr2[2];
    if (arr2[0] === "<=") return (z2, f2)=>$26aceb2bff6f47cf$var$number(f2.props[arr2[1]], Infinity) <= arr2[2];
    if (arr2[0] === ">") return (z2, f2)=>$26aceb2bff6f47cf$var$number(f2.props[arr2[1]], -Infinity) > arr2[2];
    if (arr2[0] === ">=") return (z2, f2)=>$26aceb2bff6f47cf$var$number(f2.props[arr2[1]], -Infinity) >= arr2[2];
    if (arr2[0] === "in") return (z2, f2)=>arr2.slice(2, arr2.length).includes(f2.props[arr2[1]]);
    if (arr2[0] === "!in") return (z2, f2)=>!arr2.slice(2, arr2.length).includes(f2.props[arr2[1]]);
    if (arr2[0] === "has") return (z2, f2)=>f2.props.hasOwnProperty(arr2[1]);
    if (arr2[0] === "!has") return (z2, f2)=>!f2.props.hasOwnProperty(arr2[1]);
    if (arr2[0] === "all") {
        const parts = arr2.slice(1, arr2.length).map((e2)=>$26aceb2bff6f47cf$export$7200eb76f79cdd1a(e2));
        return (z2, f2)=>parts.every((p2)=>{
                return p2(z2, f2);
            });
    }
    if (arr2[0] === "any") {
        const parts = arr2.slice(1, arr2.length).map((e2)=>$26aceb2bff6f47cf$export$7200eb76f79cdd1a(e2));
        return (z2, f2)=>parts.some((p2)=>{
                return p2(z2, f2);
            });
    }
    console.log("Unimplemented filter: ", arr2[0]);
    return (f2)=>false;
}
function $26aceb2bff6f47cf$export$afc09e6106bade65(obj) {
    if (obj.base && obj.stops) return (z2)=>{
        return $26aceb2bff6f47cf$export$b310ec824aaee37f(obj.base, obj.stops)(z2 - 1);
    };
    if (obj[0] === "interpolate" && obj[1][0] === "exponential" && obj[2][0] === "zoom") {
        const slice = obj.slice(3);
        const stops = [];
        for(let i3 = 0; i3 < slice.length; i3 += 2)stops.push([
            slice[i3],
            slice[i3 + 1]
        ]);
        return (z2)=>{
            return $26aceb2bff6f47cf$export$b310ec824aaee37f(obj[1][1], stops)(z2 - 1);
        };
    }
    if (obj[0] === "step" && obj[1][0] === "get") {
        const slice = obj.slice(2);
        const prop = obj[1][1];
        return (z2, f2)=>{
            const val = f2 == null ? void 0 : f2.props[prop];
            if (typeof val === "number") {
                if (val < slice[1]) return slice[0];
                for(let i3 = 1; i3 < slice.length; i3 += 2){
                    if (val <= slice[i3]) return slice[i3 + 1];
                }
            }
            return slice[slice.length - 1];
        };
    }
    console.log("Unimplemented numeric fn: ", obj);
    return (z2)=>1;
}
function $26aceb2bff6f47cf$export$56a2b81dc0a61595(obj, defaultValue = 0) {
    if (!obj) return defaultValue;
    if (typeof obj === "number") return obj;
    return (z2, f2)=>f2 ? $26aceb2bff6f47cf$export$afc09e6106bade65(obj)(z2, f2) : defaultValue;
}
function $26aceb2bff6f47cf$export$d8ffa30c8ea0f308(width_obj, gap_obj) {
    const w = $26aceb2bff6f47cf$export$56a2b81dc0a61595(width_obj, 1);
    const g = $26aceb2bff6f47cf$export$56a2b81dc0a61595(gap_obj);
    return (z2, f2)=>{
        const tmp = typeof w === "number" ? w : w(z2, f2);
        if (g) return tmp + (typeof g === "number" ? g : g(z2, f2));
        return tmp;
    };
}
function $26aceb2bff6f47cf$export$155316a870a9d61e(obj, fontsubmap) {
    const fontfaces = [];
    for (const wanted_face of obj["text-font"])if (fontsubmap.hasOwnProperty(wanted_face)) fontfaces.push(fontsubmap[wanted_face]);
    if (fontfaces.length === 0) fontfaces.push({
        face: "sans-serif"
    });
    const text_size = obj["text-size"];
    let weight = "";
    if (fontfaces.length && fontfaces[0].weight) weight = `${fontfaces[0].weight} `;
    let style = "";
    if (fontfaces.length && fontfaces[0].style) style = `${fontfaces[0].style} `;
    if (typeof text_size === "number") return (z2)=>`${style}${weight}${text_size}px ${fontfaces.map((f2)=>f2.face).join(", ")}`;
    if (text_size.stops) {
        let base = 1.4;
        if (text_size.base) base = text_size.base;
        else text_size.base = base;
        const t2 = $26aceb2bff6f47cf$export$afc09e6106bade65(text_size);
        return (z2, f2)=>{
            return `${style}${weight}${t2(z2, f2)}px ${fontfaces.map((f3)=>f3.face).join(", ")}`;
        };
    }
    if (text_size[0] === "step") {
        const t2 = $26aceb2bff6f47cf$export$afc09e6106bade65(text_size);
        return (z2, f2)=>{
            return `${style}${weight}${t2(z2, f2)}px ${fontfaces.map((f3)=>f3.face).join(", ")}`;
        };
    }
    console.log("Can't parse font: ", obj);
    return (z2)=>"12px sans-serif";
}
function $26aceb2bff6f47cf$export$6d60d997ca19eca9(obj, fontsubmap) {
    const paint_rules = [];
    const label_rules = [];
    const refs = /* @__PURE__ */ new Map();
    for (const layer of obj.layers){
        refs.set(layer.id, layer);
        if (layer.layout && layer.layout.visibility === "none") continue;
        if (layer.ref) {
            const referenced = refs.get(layer.ref);
            layer.type = referenced.type;
            layer.filter = referenced.filter;
            layer.source = referenced.source;
            layer["source-layer"] = referenced["source-layer"];
        }
        const sourceLayer = layer["source-layer"];
        let symbolizer;
        let filter = void 0;
        if (layer.filter) filter = $26aceb2bff6f47cf$export$7200eb76f79cdd1a(layer.filter);
        if (layer.type === "fill") paint_rules.push({
            dataLayer: layer["source-layer"],
            filter: filter,
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: layer.paint["fill-color"],
                opacity: layer.paint["fill-opacity"]
            })
        });
        else if (layer.type === "fill-extrusion") paint_rules.push({
            dataLayer: layer["source-layer"],
            filter: filter,
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: layer.paint["fill-extrusion-color"],
                opacity: layer.paint["fill-extrusion-opacity"]
            })
        });
        else if (layer.type === "line") {
            if (layer.paint["line-dasharray"]) paint_rules.push({
                dataLayer: layer["source-layer"],
                filter: filter,
                symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                    width: $26aceb2bff6f47cf$export$d8ffa30c8ea0f308(layer.paint["line-width"], layer.paint["line-gap-width"]),
                    dash: layer.paint["line-dasharray"],
                    dashColor: layer.paint["line-color"]
                })
            });
            else paint_rules.push({
                dataLayer: layer["source-layer"],
                filter: filter,
                symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                    color: layer.paint["line-color"],
                    width: $26aceb2bff6f47cf$export$d8ffa30c8ea0f308(layer.paint["line-width"], layer.paint["line-gap-width"])
                })
            });
        } else if (layer.type === "symbol") {
            if (layer.layout["symbol-placement"] === "line") label_rules.push({
                dataLayer: layer["source-layer"],
                filter: filter,
                symbolizer: new $26aceb2bff6f47cf$export$78a4dca8da5a6362({
                    font: $26aceb2bff6f47cf$export$155316a870a9d61e(layer.layout, fontsubmap),
                    fill: layer.paint["text-color"],
                    width: layer.paint["text-halo-width"],
                    stroke: layer.paint["text-halo-color"],
                    textTransform: layer.layout["text-transform"],
                    label_props: layer.layout["text-field"] ? [
                        layer.layout["text-field"]
                    ] : void 0
                })
            });
            else label_rules.push({
                dataLayer: layer["source-layer"],
                filter: filter,
                symbolizer: new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                    font: $26aceb2bff6f47cf$export$155316a870a9d61e(layer.layout, fontsubmap),
                    fill: layer.paint["text-color"],
                    stroke: layer.paint["text-halo-color"],
                    width: layer.paint["text-halo-width"],
                    textTransform: layer.layout["text-transform"],
                    label_props: layer.layout["text-field"] ? [
                        layer.layout["text-field"]
                    ] : void 0
                })
            });
        } else if (layer.type === "circle") paint_rules.push({
            dataLayer: layer["source-layer"],
            filter: filter,
            symbolizer: new $26aceb2bff6f47cf$export$8bf8f73f069748a0({
                radius: layer.paint["circle-radius"],
                fill: layer.paint["circle-color"],
                stroke: layer.paint["circle-stroke-color"],
                width: layer.paint["circle-stroke-width"]
            })
        });
    }
    label_rules.reverse();
    return {
        paint_rules: paint_rules,
        label_rules: label_rules,
        tasks: []
    };
}
// src/extra_styles/toner.ts
var $26aceb2bff6f47cf$export$3e29f10ff37f92be = (variant)=>{
    const halftone = $26aceb2bff6f47cf$export$77b453ec516f35c5(4, 4, (c2)=>{
        const ctx = c2.getContext("2d");
        if (ctx) {
            ctx.beginPath();
            ctx.rect(0, 0, 1, 1);
            ctx.rect(2, 2, 1, 1);
            ctx.fillStyle = "black";
            ctx.fill();
        }
    });
    let background = "black";
    if (variant === "lite") background = "#d9d9d9";
    const lang = [
        "name:en",
        "name"
    ];
    const paint_rules = [
        {
            dataLayer: "earth",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: "white"
            })
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                pattern: halftone
            }),
            filter: (z2, f2)=>{
                return f2.props.leisure === "park";
            }
        },
        {
            dataLayer: "water",
            symbolizer: new $26aceb2bff6f47cf$export$b225ea0cbaf5a20({
                fill: background
            })
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "#dddddd"
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "minor_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "white",
                width: $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(16, [
                    7,
                    9,
                    17,
                    20
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "medium_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "#cccccc",
                width: $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(10, [
                    0.2,
                    0.2,
                    0.2,
                    0.4,
                    0.8,
                    1.5,
                    4,
                    7,
                    13,
                    16
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "medium_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "white",
                width: $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(11, [
                    1.25,
                    5,
                    5,
                    5,
                    8,
                    11,
                    18,
                    22,
                    30
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "major_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "black",
                width: $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(9, [
                    0.15,
                    0.5,
                    0.7,
                    1,
                    1.5,
                    1.9,
                    5,
                    7,
                    12,
                    18,
                    26
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "major_road";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "white",
                width: $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(7, [
                    2.25,
                    3.25,
                    4.25,
                    5,
                    6,
                    7,
                    8,
                    9,
                    11,
                    14,
                    24,
                    42,
                    49
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "highway";
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "black",
                width: $26aceb2bff6f47cf$export$29d5d0b2414dfc5c(6, [
                    0.1,
                    1.5,
                    1.5,
                    1.5,
                    2,
                    2.5,
                    3,
                    3,
                    4,
                    6,
                    9,
                    15,
                    28,
                    35
                ])
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "highway";
            }
        },
        {
            dataLayer: "transit",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "#888888",
                dashColor: "#888888",
                dash: [
                    1,
                    4
                ],
                dashWidth: 3
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "railway";
            },
            minzoom: 14
        },
        {
            dataLayer: "transit",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "#888888"
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "railway";
            },
            minzoom: 14
        },
        {
            dataLayer: "buildings",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "#888888",
                width: 0.5
            })
        },
        {
            dataLayer: "boundaries",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "black",
                width: 1
            }),
            maxzoom: 6
        },
        {
            dataLayer: "boundaries",
            symbolizer: new $26aceb2bff6f47cf$export$95549896bf56cede({
                color: "white",
                width: 2.5,
                dash: [
                    3,
                    1
                ],
                dashWidth: 0.3,
                dashColor: "black"
            }),
            minzoom: 7
        }
    ];
    const label_rules = [
        {
            dataLayer: "places",
            symbolizer: new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: lang,
                fill: "black",
                stroke: "white",
                width: 1.5,
                fontFamily: "Inter",
                fontWeight: 300,
                fontSize: 15,
                justify: 2 /* Center */ 
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "country";
            }
        },
        {
            dataLayer: "places",
            symbolizer: new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: lang,
                fill: "black",
                stroke: "white",
                width: 2,
                fontFamily: "Inter",
                fontWeight: 300,
                fontSize: 12,
                justify: 2 /* Center */ 
            }),
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "state";
            }
        },
        {
            dataLayer: "places",
            symbolizer: new $26aceb2bff6f47cf$export$ad70caf87077791a([
                new $26aceb2bff6f47cf$export$8bf8f73f069748a0({
                    radius: 2,
                    fill: "black",
                    stroke: "white",
                    width: 2
                }),
                new $26aceb2bff6f47cf$export$b04698872800c8ee({
                    label_props: lang,
                    offsetX: 3,
                    fill: "black",
                    stroke: "white",
                    width: 1.5,
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: (z2, f2)=>{
                        if ((f2 == null ? void 0 : f2.props["pmap:rank"]) === 1) return 15;
                        return 13;
                    }
                })
            ]),
            sort: (a2, b)=>{
                return a2["pmap:rank"] - b["pmap:rank"];
            },
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "city";
            },
            maxzoom: 8
        },
        {
            dataLayer: "places",
            symbolizer: new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: lang,
                justify: 2 /* Center */ ,
                fill: "black",
                stroke: "white",
                width: 2,
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: (z2, f2)=>{
                    if ((f2 == null ? void 0 : f2.props["pmap:rank"]) === 1) return 15;
                    return 13;
                }
            }),
            sort: (a2, b)=>{
                return a2["pmap:rank"] - b["pmap:rank"];
            },
            filter: (z2, f2)=>{
                return f2.props["pmap:kind"] === "city";
            },
            minzoom: 9
        },
        {
            dataLayer: "water",
            symbolizer: new $26aceb2bff6f47cf$export$8511e0ed13901ff8({
                label_props: lang,
                fill: "white",
                stroke: "black",
                width: 3,
                font: "italic 400 12px Inter"
            })
        },
        {
            dataLayer: "landuse",
            symbolizer: new $26aceb2bff6f47cf$export$8511e0ed13901ff8({
                fill: "black",
                stroke: "white",
                width: 2,
                font: "italic 400 12px Inter"
            })
        },
        {
            dataLayer: "physical_point",
            symbolizer: new $26aceb2bff6f47cf$export$53d5ad1ff34f479a({
                label_props: lang,
                fill: "white",
                stroke: "black",
                width: 3,
                font: "italic 600 12px Inter",
                textTransform: "uppercase",
                justify: 2 /* Center */ 
            }),
            filter: (z2, f2)=>{
                return [
                    "ocean",
                    "sea"
                ].includes(f2.props.place);
            }
        },
        {
            dataLayer: "roads",
            symbolizer: new $26aceb2bff6f47cf$export$78a4dca8da5a6362({
                fill: "black",
                stroke: "white",
                width: 2,
                font: "600 14px Inter",
                offset: 4
            })
        }
    ];
    return {
        tasks: [
            $26aceb2bff6f47cf$export$89abf52a030e56ee("Inter", "https://cdn.protomaps.com/fonts/woff2/Inter.var.woff2", "100 900")
        ],
        paint_rules: paint_rules,
        label_rules: label_rules,
        attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>.'
    };
};
 /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ 

/*! Version: 0.90.0
Copyright (c) 2016 Dominik Moritz */ 
var $8JYDX = parcelRequire("8JYDX");
/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/ const $34ddf7307461b754$var$METERS_TO_FEET = 3.2808399;
/**
 * Add one or more CSS classes to an element.
 * @param {HTMLElement} el - The element to add classes to.
 * @param {string} names - Space-separated class names.
 */ function $34ddf7307461b754$var$addClasses(el, names) {
    names.split(" ").forEach((className)=>{
        el.classList.add(className);
    });
}
/**
 * Remove one or more CSS classes from an element.
 * @param {HTMLElement} el - The element to remove classes from.
 * @param {string} names - Space-separated class names.
 */ function $34ddf7307461b754$var$removeClasses(el, names) {
    names.split(" ").forEach((className)=>{
        el.classList.remove(className);
    });
}
/**
 * Create a DOM element with a class name and optionally append it to a parent.
 * @param {string} tag - The element tag name.
 * @param {string} [className] - Space-separated class names.
 * @param {HTMLElement} [parent] - Optional parent to append the element to.
 * @returns {HTMLElement}
 */ function $34ddf7307461b754$var$createElement(tag, className, parent) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    parent?.append(el);
    return el;
}
/**
 * Shallow clone options to prevent prototype pollution.
 * Clones arrays and plain objects, keeps functions/classes as references.
 * @param {Object} options - The options object to clone.
 * @returns {Object} A shallow clone of the options object.
 */ function $34ddf7307461b754$var$cloneOptions(options) {
    const cloned = {};
    for(const key in options){
        const val = options[key];
        if (Array.isArray(val)) cloned[key] = [
            ...val
        ];
        else if (val?.constructor === Object) cloned[key] = {
            ...val
        };
        else cloned[key] = val;
    }
    return cloned;
}
/**
 * Compatible with Circle but a true marker instead of a path
 */ const $34ddf7307461b754$export$b42842b40b0e9990 = (0, $8JYDX.Marker).extend({
    initialize (latlng, options) {
        (0, $8JYDX.Util).setOptions(this, options);
        this._latlng = latlng;
        this.createIcon();
    },
    /**
   * Create a styled circle location marker
   */ createIcon () {
        const opt = this.options;
        const style = [
            [
                "stroke",
                opt.color
            ],
            [
                "stroke-width",
                opt.weight
            ],
            [
                "fill",
                opt.fillColor
            ],
            [
                "fill-opacity",
                opt.fillOpacity
            ],
            [
                "opacity",
                opt.opacity
            ]
        ].filter(([, v])=>v !== undefined).map(([k, v])=>`${k}="${v}"`).join(" ");
        const icon = this._getIconSVG(opt, style);
        this._locationIcon = new (0, $8JYDX.DivIcon)({
            className: icon.className,
            html: icon.svg,
            iconSize: [
                icon.w,
                icon.h
            ]
        });
        this.setIcon(this._locationIcon);
    },
    /**
   * Return the raw svg for the shape
   *
   * Split so can be easily overridden
   */ _getIconSVG (options, style) {
        const r = options.radius;
        const w = options.weight;
        const s = r + w;
        const s2 = s * 2;
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + `<circle r="${r}" ${style} /></svg>`;
        return {
            className: "leaflet-control-locate-location",
            svg: svg,
            w: s2,
            h: s2
        };
    },
    setStyle (style) {
        (0, $8JYDX.Util).setOptions(this, style);
        this.createIcon();
    }
});
const $34ddf7307461b754$export$c05b54df9e1e8513 = $34ddf7307461b754$export$b42842b40b0e9990.extend({
    initialize (latlng, heading, options) {
        (0, $8JYDX.Util).setOptions(this, options);
        this._latlng = latlng;
        this._heading = heading;
        this.createIcon();
    },
    setHeading (heading) {
        this._heading = heading;
    },
    /**
   * Create a styled arrow compass marker
   */ _getIconSVG (options, style) {
        const r = options.radius;
        const s = r + options.weight + options.depth;
        const s2 = s * 2;
        const path = this._arrowPoints(r, options.width, options.depth, this._heading);
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + `<path d="${path}" ${style} /></svg>`;
        return {
            className: "leaflet-control-locate-heading",
            svg: svg,
            w: s2,
            h: s2
        };
    },
    _arrowPoints (radius, width, depth, heading) {
        const \u03C6 = (heading - 90) * Math.PI / 180;
        const ux = Math.cos(\u03C6);
        const uy = Math.sin(\u03C6);
        const vx = -Math.sin(\u03C6);
        const vy = Math.cos(\u03C6);
        const h = width / 2;
        // Base center on circle
        const Cx = radius * ux;
        const Cy = radius * uy;
        // Base corners
        const B1x = Cx + h * vx;
        const B1y = Cy + h * vy;
        const B2x = Cx - h * vx;
        const B2y = Cy - h * vy;
        // Tip outward
        const Tx = Cx + depth * ux;
        const Ty = Cy + depth * uy;
        return `M ${B1x},${B1y} L ${B2x},${B2y} L ${Tx},${Ty} Z`;
    }
});
const $34ddf7307461b754$export$acde3ad4f992a4ae = (0, $8JYDX.Control).extend({
    options: {
        /** Position of the control */ position: "topleft",
        /** The layer that the user's location should be drawn on. By default creates a new layer. */ layer: undefined,
        /**
     * Automatically sets the map view (zoom and pan) to the user's location as it updates.
     * While the map is following the user's location, the control is in the `following` state,
     * which changes the style of the control and the circle marker.
     *
     * Possible values:
     *  - false: never updates the map view when location changes.
     *  - 'once': set the view when the location is first determined
     *  - 'always': always updates the map view when location changes.
     *              The map view follows the user's location.
     *  - 'untilPan': like 'always', except stops updating the
     *                view if the user has manually panned the map.
     *                The map view follows the user's location until she pans.
     *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
     *                view if the user has manually panned the map.
     *                The map view follows the user's location until she pans.
     */ setView: "untilPanOrZoom",
        /**
     * Keep the current map zoom level when setting the view and only pan.
     * Can be set to:
     * - `true`: Always keep current zoom level
     * - `false`: Allow zooming (default)
     * - `[minZoom, maxZoom]`: Keep zoom only when current zoom is within the specified range
     */ keepCurrentZoomLevel: false,
        /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */ initialZoomLevel: false,
        /**
     * This callback can be used to override the viewport tracking
     * This function should return a LatLngBounds object.
     *
     * For example to extend the viewport to ensure that a particular LatLng is visible:
     *
     * getLocationBounds: function(locationEvent) {
     *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
     * },
     */ getLocationBounds (locationEvent) {
            return locationEvent.bounds;
        },
        /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */ flyTo: false,
        /**
     * The user location can be inside and outside the current view when the user clicks on the
     * control that is already active. Both cases can be configures separately.
     * Possible values are:
     *  - 'setView': zoom and pan to the current location
     *  - 'stop': stop locating and remove the location marker
     */ clickBehavior: {
            /** What should happen if the user clicks on the control while the location is within the current view. */ inView: "stop",
            /** What should happen if the user clicks on the control while the location is outside the current view. */ outOfView: "setView",
            /**
       * What should happen if the user clicks on the control while the location is within the current view
       * and we could be following but are not. Defaults to a special value which inherits from 'inView';
       */ inViewNotFollowing: "inView"
        },
        /**
     * If set, save the map bounds just before centering to the user's
     * location. When control is disabled, set the view back to the
     * bounds that were saved.
     */ returnToPrevBounds: false,
        /**
     * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
     * until the locate API returns a new location before they see where they are again.
     */ cacheLocation: true,
        /** If set, a circle that shows the location accuracy is drawn. */ drawCircle: true,
        /** If set, the marker at the users' location is drawn. */ drawMarker: true,
        /** If set and supported then show the compass heading */ showCompass: true,
        /**
     * iOS-only compass accuracy threshold (degrees).
     * Show compass only when `webkitCompassAccuracy <= value`.
     * `-1` (uncalibrated) is always rejected.
     * Set to `false` to disable filtering. No effect on Android.
     */ compassAccuracyThreshold: 45,
        /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */ markerClass: $34ddf7307461b754$export$b42842b40b0e9990,
        /** The class us be used to create the compass bearing arrow */ compassClass: $34ddf7307461b754$export$c05b54df9e1e8513,
        /** Accuracy circle style properties. NOTE these styles should match the css animations styles */ circleStyle: {
            className: "leaflet-control-locate-circle",
            color: "#136AEC",
            fillColor: "#136AEC",
            fillOpacity: 0.15,
            weight: 0
        },
        /** Inner marker style properties. Only works if your marker class supports `setStyle`. */ markerStyle: {
            className: "leaflet-control-locate-marker",
            color: "#fff",
            fillColor: "#2A93EE",
            fillOpacity: 1,
            weight: 3,
            opacity: 1,
            radius: 9
        },
        /** Compass */ compassStyle: {
            fillColor: "#2A93EE",
            fillOpacity: 1,
            weight: 0,
            color: "#fff",
            opacity: 1,
            radius: 9,
            width: 9,
            depth: 6 // Length of the arrow
        },
        /**
     * Changes to accuracy circle and inner marker while following.
     * It is only necessary to provide the properties that should change.
     */ followCircleStyle: {},
        followMarkerStyle: {
        },
        followCompassStyle: {},
        /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */ icon: "leaflet-control-locate-location-arrow",
        iconLoading: "leaflet-control-locate-spinner",
        /** The element to be created for icons. For example span or i */ iconElementTag: "span",
        /** The element to be created for the text. For example small or span */ textElementTag: "small",
        /** Padding around the accuracy circle. */ circlePadding: [
            0,
            0
        ],
        /** Use metric units. */ metric: true,
        /**
     * This callback can be used in case you would like to override button creation behavior.
     * This is useful for DOM manipulation frameworks such as angular etc.
     * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
     */ createButtonCallback (container, options) {
            const link = $34ddf7307461b754$var$createElement("a", "leaflet-bar-part leaflet-bar-part-single", container);
            link.title = options.strings.title;
            link.href = "#";
            link.setAttribute("role", "button");
            link.setAttribute("aria-label", options.strings.title);
            const icon = $34ddf7307461b754$var$createElement(options.iconElementTag, options.icon, link);
            // Add common class for all icons to enable color status changes
            icon.classList.add("leaflet-locate-icon");
            if (options.strings.text !== undefined) {
                const text = $34ddf7307461b754$var$createElement(options.textElementTag, "leaflet-locate-text", link);
                text.textContent = options.strings.text;
                link.classList.add("leaflet-locate-text-active");
                link.parentNode.style.display = "flex";
            }
            return {
                link: link,
                icon: icon
            };
        },
        /** This event is called in case of any location error that is not a time out error. */ onLocationError (err) {
            alert(err.message);
        },
        /**
     * This event is called when the user's location is outside the bounds set on the map.
     * The event is called repeatedly when the location changes.
     */ onLocationOutsideMapBounds (control) {
            control.stop();
            alert(control.options.strings.outsideMapBoundsMsg);
        },
        /** Display a pop-up when the user click on the inner marker. */ showPopup: true,
        strings: {
            title: "Show me where I am",
            metersUnit: "meters",
            feetUnit: "feet",
            popup: "You are within {distance} {unit} from this point",
            outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
        },
        /** The default options passed to leaflets locate method. */ locateOptions: {
            maxZoom: Infinity,
            watch: true,
            setView: false // have to set this to false because we have to
        }
    },
    initialize (options = {}) {
        // Clone default options to prevent prototype pollution
        this.options = $34ddf7307461b754$var$cloneOptions(this.options);
        // Merge user-provided options
        for(const key in options){
            const userVal = options[key];
            const defaultVal = this.options[key];
            if (userVal?.constructor === Object && defaultVal?.constructor === Object) Object.assign(defaultVal, userVal);
            else this.options[key] = userVal;
        }
        // Follow styles inherit from base styles
        this.options.followMarkerStyle = {
            ...this.options.markerStyle,
            ...this.options.followMarkerStyle
        };
        this.options.followCircleStyle = {
            ...this.options.circleStyle,
            ...this.options.followCircleStyle
        };
        this.options.followCompassStyle = {
            ...this.options.compassStyle,
            ...this.options.followCompassStyle
        };
    },
    /**
   * Add control to map. Returns the container for the control.
   */ onAdd (map) {
        const container = $34ddf7307461b754$var$createElement("div", "leaflet-control-locate leaflet-bar leaflet-control");
        this._container = container;
        this._map = map;
        this._layer = this.options.layer || new (0, $8JYDX.LayerGroup)();
        this._layer.addTo(map);
        this._event = undefined;
        this._compassHeading = null;
        this._prevBounds = null;
        const linkAndIcon = this.options.createButtonCallback(container, this.options);
        this._link = linkAndIcon.link;
        this._icon = linkAndIcon.icon;
        this._linkClickHandler = (ev)=>{
            ev.stopPropagation();
            ev.preventDefault();
            this._onClick();
        };
        this._linkDblClickHandler = (ev)=>ev.stopPropagation();
        this._link.addEventListener("click", this._linkClickHandler);
        this._link.addEventListener("dblclick", this._linkDblClickHandler);
        this._resetVariables();
        this._map.on("unload", this._unload, this);
        return container;
    },
    /**
   * Called when control is removed from the map.
   */ onRemove () {
        if (this._link && this._linkClickHandler) this._link.removeEventListener("click", this._linkClickHandler);
        if (this._link && this._linkDblClickHandler) this._link.removeEventListener("dblclick", this._linkDblClickHandler);
        if (this._map) this._map.off("unload", this._unload, this);
        this._linkClickHandler = null;
        this._linkDblClickHandler = null;
        this.stop();
    },
    /**
   * This method is called when the user clicks on the control.
   */ _onClick () {
        this._justClicked = true;
        const wasFollowing = this._isFollowing();
        this._userPanned = false;
        this._userZoomed = false;
        if (this._active && !this._event) // click while requesting
        this.stop();
        else if (this._active) {
            const behaviors = this.options.clickBehavior;
            let behavior = behaviors.outOfView;
            if (this._map.getBounds().contains(this._event.latlng)) behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
            // Allow inheriting from another behavior
            if (behaviors[behavior]) behavior = behaviors[behavior];
            switch(behavior){
                case "setView":
                    this.setView();
                    break;
                case "stop":
                    this.stop();
                    if (this.options.returnToPrevBounds) {
                        const f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                        f.bind(this._map)(this._prevBounds);
                    }
                    break;
            }
        } else {
            if (this.options.returnToPrevBounds) this._prevBounds = this._map.getBounds();
            this.start();
        }
        this._updateContainerStyle();
    },
    /**
   * Starts the plugin:
   * - activates the engine
   * - draws the marker (if coordinates available)
   */ start () {
        this._activate();
        if (this._event) {
            this._drawMarker(this._map);
            // if we already have a location but the user clicked on the control
            if (this.options.setView) this.setView();
        }
        this._updateContainerStyle();
    },
    /**
   * Stops the plugin:
   * - deactivates the engine
   * - reinitializes the button
   * - removes the marker
   */ stop () {
        this._deactivate();
        this._cleanClasses();
        this._resetVariables();
        this._removeMarker();
    },
    /**
   * Keep the control active but stop following the location
   */ stopFollowing () {
        this._userPanned = true;
        this._updateContainerStyle();
        this._drawMarker();
    },
    /**
   * This method launches the location engine.
   * It is called before the marker is updated,
   * event if it does not mean that the event will be ready.
   *
   * Override it if you want to add more functionalities.
   * It should set the this._active to true and do nothing if
   * this._active is true.
   */ _activate () {
        if (this._active || !this._map) return;
        this._map.locate(this.options.locateOptions);
        this._map.fire("locateactivate", this);
        this._active = true;
        // bind event listeners
        this._map.on("locationfound", this._onLocationFound, this);
        this._map.on("locationerror", this._onLocationError, this);
        this._map.on("dragstart", this._onDrag, this);
        this._map.on("zoomstart", this._onZoom, this);
        this._map.on("zoomend", this._onZoomEnd, this);
        this._activateCompass();
    },
    /**
   * Request DeviceOrientation permission (if needed) and bind compass events.
   * Fails gracefully — geolocation continues without compass.
   */ async _activateCompass () {
        if (!this.options.showCompass) return;
        const oriAbs = "ondeviceorientationabsolute" in window;
        if (!oriAbs && !("ondeviceorientation" in window)) return;
        const eventName = oriAbs ? "deviceorientationabsolute" : "deviceorientation";
        const deviceOrientationEvent = window.DeviceOrientationEvent;
        if (typeof deviceOrientationEvent !== "undefined" && typeof deviceOrientationEvent.requestPermission === "function") try {
            const permissionState = await deviceOrientationEvent.requestPermission();
            if (permissionState !== "granted") return;
        } catch (err) {
            // Permission denied or not supported (e.g. iOS Chrome / WKWebView)
            // Compass will not be shown but geolocation continues normally
            console.warn("DeviceOrientation permission denied or unavailable:", err);
            return;
        }
        this._compassEventName = eventName;
        (0, $8JYDX.DomEvent).on(window, eventName, this._onDeviceOrientation, this);
    },
    /**
   * Called to stop the location engine.
   *
   * Override it to shutdown any functionalities you added on start.
   */ _deactivate () {
        if (!this._active || !this._map) return;
        this._map.stopLocate();
        this._map.fire("locatedeactivate", this);
        this._active = false;
        if (!this.options.cacheLocation) this._event = undefined;
        // unbind event listeners
        this._map.off("locationfound", this._onLocationFound, this);
        this._map.off("locationerror", this._onLocationError, this);
        this._map.off("dragstart", this._onDrag, this);
        this._map.off("zoomstart", this._onZoom, this);
        this._map.off("zoomend", this._onZoomEnd, this);
        this._deactivateCompass();
    },
    /**
   * Remove compass event listener and reset compass heading state.
   * Symmetric counterpart to _activateCompass().
   */ _deactivateCompass () {
        if (!this._compassEventName) return;
        this._compassHeading = null;
        (0, $8JYDX.DomEvent).off(window, this._compassEventName, this._onDeviceOrientation, this);
        this._compassEventName = null;
    },
    /**
   * Check if the current zoom level should be kept based on keepCurrentZoomLevel option.
   * @returns {boolean} true if zoom should be kept, false otherwise
   */ _shouldKeepCurrentZoom () {
        const option = this.options.keepCurrentZoomLevel;
        // If option is an array [minZoom, maxZoom], check if current zoom is within range
        if (Array.isArray(option) && option.length === 2) {
            const currentZoom = this._map.getZoom();
            const [minZoom, maxZoom] = option;
            return currentZoom >= minZoom && currentZoom <= maxZoom;
        }
        // Only return true if explicitly set to true
        return option === true;
    },
    /**
   * Pan and/or zoom the map to the current location.
   * Respects keepCurrentZoomLevel and initialZoomLevel options.
   */ setView () {
        this._drawMarker();
        if (this._isOutsideMapBounds()) {
            this._event = undefined; // clear the current location so we can get back into the bounds
            this.options.onLocationOutsideMapBounds(this);
            return;
        }
        const { latlng: latlng } = this._event;
        const fly = this.options.flyTo;
        let method, args;
        if (this._justClicked && this.options.initialZoomLevel !== false) {
            method = fly ? "flyTo" : "setView";
            args = [
                latlng,
                this.options.initialZoomLevel
            ];
        } else if (this._shouldKeepCurrentZoom()) {
            method = fly ? "flyTo" : "panTo";
            args = [
                latlng
            ];
        } else {
            method = fly ? "flyToBounds" : "fitBounds";
            args = [
                this.options.getLocationBounds(this._event),
                {
                    padding: this.options.circlePadding,
                    maxZoom: this.options.locateOptions.maxZoom
                }
            ];
        }
        this._setViewIgnoringEvents(method, args);
    },
    /**
   * Execute a map view method while ignoring zoom/pan events to prevent breaking following mode.
   * @param {string} method - The map method name to call ('flyTo', 'setView', 'panTo', 'fitBounds', 'flyToBounds')
   * @param {Array} args - Arguments to pass to the method
   */ _setViewIgnoringEvents (method, args) {
        this._ignoreEvent = true;
        this._map[method](...args);
        requestAnimationFrame(()=>{
            // Wait until after the next animFrame because flyTo/flyToBounds can be async
            this._ignoreEvent = false;
        });
    },
    /**
   *
   */ _drawCompass () {
        if (!this._event) return;
        const latlng = this._event.latlng;
        if (this.options.showCompass && latlng && this._compassHeading !== null) {
            const cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
            if (!this._compass) this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
            else {
                this._compass.setLatLng(latlng);
                this._compass.setHeading(this._compassHeading);
                // If the compassClass can be updated with setStyle, update it.
                if (this._compass.setStyle) this._compass.setStyle(cStyle);
            }
        //
        }
        if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
            this._compass.removeFrom(this._layer);
            this._compass = null;
        }
    },
    /**
   * Draw the marker and accuracy circle on the map.
   *
   * Uses the event retrieved from onLocationFound from the map.
   */ _drawMarker () {
        if (!this._event) return;
        const latlng = this._event.latlng;
        const accuracy = this._event.accuracy ?? 0;
        const isFollowing = this._isFollowing();
        // Draw accuracy circle
        if (this.options.drawCircle) {
            const style = isFollowing ? this.options.followCircleStyle : this.options.circleStyle;
            if (this._circle) this._circle.setLatLng(latlng).setRadius(accuracy).setStyle(style);
            else {
                const options = {
                    ...style,
                    radius: accuracy
                };
                this._circle = new (0, $8JYDX.Circle)(latlng, options).addTo(this._layer);
            }
        }
        // Draw location marker
        if (this.options.drawMarker) {
            const style = isFollowing ? this.options.followMarkerStyle : this.options.markerStyle;
            if (this._marker) {
                this._marker.setLatLng(latlng);
                if (this._marker.setStyle) this._marker.setStyle(style);
            } else this._marker = new this.options.markerClass(latlng, style).addTo(this._layer);
        }
        // Draw compass
        this._drawCompass();
        // Bind popup to marker and compass
        this._bindPopup(latlng, accuracy);
    },
    /**
   * Bind popup with location information to marker and compass.
   * @param {L.LatLng} latlng - The location to bind the popup to.
   * @param {number} accuracy - The accuracy radius in meters.
   */ _bindPopup (latlng, accuracy) {
        const t = this.options.strings.popup;
        if (!this.options.showPopup || !t) return;
        // Format distance for display
        let distance;
        let unit;
        let altitude;
        if (this.options.metric) {
            distance = accuracy.toFixed(0);
            unit = this.options.strings.metersUnit;
            altitude = this._event?.altitude != null ? this._event.altitude.toFixed(1) : "N/A";
        } else {
            distance = (accuracy * $34ddf7307461b754$var$METERS_TO_FEET).toFixed(0);
            unit = this.options.strings.feetUnit;
            altitude = this._event?.altitude != null ? (this._event.altitude * $34ddf7307461b754$var$METERS_TO_FEET).toFixed(1) : "N/A";
        }
        // Speed in m/s (raw value from Geolocation API), heading in degrees
        const speed = this._event?.speed != null ? this._event.speed.toFixed(2) : "N/A";
        const heading = this._event?.heading != null ? this._event.heading.toFixed(0) : "N/A";
        // Collect template data
        const data = {
            distance: distance,
            unit: unit,
            lat: latlng.lat.toFixed(6),
            lng: latlng.lng.toFixed(6),
            altitude: altitude,
            speed: speed,
            heading: heading
        };
        // Generate popup text
        let popupText;
        if (typeof t === "string") popupText = (0, $8JYDX.Util).template(t, data);
        else if (typeof t === "function") popupText = t(data);
        else popupText = t;
        // Bind to marker and compass
        if (this._marker) this._marker.bindPopup(popupText)._popup.setLatLng(latlng);
        if (this._compass) this._compass.bindPopup(popupText)._popup.setLatLng(latlng);
    },
    /**
   * Remove the marker from map.
   */ _removeMarker () {
        this._layer.clearLayers();
        this._marker = undefined;
        this._circle = undefined;
        this._compass = undefined;
    },
    /**
   * Unload the plugin and all event listeners.
   * Kind of the opposite of onAdd.
   */ _unload () {
        this.stop();
        // May become undefined during HMR
        if (this._map) this._map.off("unload", this._unload, this);
    },
    /**
   * Sets the compass heading
   */ _setCompassHeading (angle) {
        if (Number.isFinite(angle)) {
            this._compassHeading = Math.round(angle);
            requestAnimationFrame(()=>this._drawCompass());
        } else {
            this._compassHeading = null;
            this._drawCompass();
        }
    },
    /**
   * If the compass fails calibration just fail safely and remove the compass
   */ _onCompassNeedsCalibration () {
        this._setCompassHeading();
    },
    /**
   * Process and normalise compass events.
   *
   * On iOS, optionally filters out inaccurate readings based on `compassAccuracyThreshold`.
   * Android has no equivalent accuracy field and is therefore not filtered.
   */ _onDeviceOrientation (e) {
        if (!this._active) return;
        if (e.webkitCompassHeading != null) {
            // iOS: webkitCompassHeading is relative to device top.
            const threshold = this.options.compassAccuracyThreshold;
            const filterEnabled = typeof threshold === "number" && e.webkitCompassAccuracy != null;
            // -1 means uncalibrated, always reject when filtering is on.
            const tooInaccurate = filterEnabled && (e.webkitCompassAccuracy < 0 || e.webkitCompassAccuracy > threshold);
            if (tooInaccurate) {
                this._setCompassHeading();
                return;
            }
            // Compensate using current screen orientation when available.
            const screenAngle = window.screen?.orientation?.angle ?? 0;
            this._setCompassHeading((e.webkitCompassHeading + screenAngle) % 360);
        } else if (e.alpha !== null) // Android: no standardized accuracy field, reading is shown as-is.
        this._setCompassHeading(360 - e.alpha);
    },
    /**
   * Calls deactivate and dispatches an error.
   */ _onLocationError (err) {
        // Handle timeout errors in watch mode differently
        if (err.code === 3 && this.options.locateOptions.watch) {
            this._timeoutCount = (this._timeoutCount || 0) + 1;
            // Fire event for developers to handle timeouts
            this._map.fire("locationtimeout", {
                error: err,
                control: this,
                count: this._timeoutCount
            });
            // Visual feedback after repeated timeouts
            if (this._timeoutCount >= 3 && this._container) $34ddf7307461b754$var$addClasses(this._container, "locate-timeout");
            return;
        }
        // Reset timeout counter for other errors
        this._timeoutCount = 0;
        this.stop();
        this.options.onLocationError(err, this);
    },
    /**
   * Stores the received event and updates the marker.
   */ _onLocationFound (e) {
        // no need to do anything if the location has not changed
        if (this._event?.latlng?.lat === e.latlng.lat && this._event?.latlng?.lng === e.latlng.lng && this._event?.accuracy === e.accuracy) return;
        if (!this._active) // we may have a stray event
        return;
        // Reset timeout counter on successful location
        this._timeoutCount = 0;
        if (this._container) $34ddf7307461b754$var$removeClasses(this._container, "locate-timeout");
        this._event = e;
        this._drawMarker();
        this._updateContainerStyle();
        // Fire event with location data and control reference
        this._map.fire("locatelocationfound", {
            ...e,
            control: this
        });
        switch(this.options.setView){
            case "once":
                if (this._justClicked) this.setView();
                break;
            case "untilPan":
                if (!this._userPanned) this.setView();
                break;
            case "untilPanOrZoom":
                if (!this._userPanned && !this._userZoomed) this.setView();
                break;
            case "always":
                this.setView();
                break;
        }
        this._justClicked = false;
    },
    /**
   * When the user drags. Need a separate event so we can bind and unbind event listeners.
   */ _onDrag () {
        // only react to drags once we have a location
        if (this._event && !this._ignoreEvent) {
            this._userPanned = true;
            this._updateContainerStyle();
            this._drawMarker();
        }
    },
    /**
   * When the user zooms. Need a separate event so we can bind and unbind event listeners.
   */ _onZoom () {
        // only react to drags once we have a location
        if (this._event && !this._ignoreEvent) {
            this._userZoomed = true;
            this._updateContainerStyle();
            this._drawMarker();
        }
    },
    /**
   * After a zoom ends update the compass and handle sideways zooms
   */ _onZoomEnd () {
        if (this._event) this._drawCompass();
        if (this._event && !this._ignoreEvent) // If we have zoomed in and out and ended up sideways treat it as a pan
        {
            if (this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng())) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        }
    },
    /**
   * Compute whether the map is following the user location with pan and zoom.
   */ _isFollowing () {
        if (!this._active) return false;
        if (this.options.setView === "always") return true;
        else if (this.options.setView === "untilPan") return !this._userPanned;
        else if (this.options.setView === "untilPanOrZoom") return !this._userPanned && !this._userZoomed;
        return false;
    },
    /**
   * Check if location is in map bounds
   */ _isOutsideMapBounds () {
        if (this._event === undefined) return false;
        return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
    },
    /**
   * Toggles button class between following and active.
   */ _updateContainerStyle () {
        if (!this._container) return;
        if (this._active && !this._event) // active but don't have a location yet
        this._setClasses("requesting");
        else if (this._isFollowing()) this._setClasses("following");
        else if (this._active) this._setClasses("active");
        else this._cleanClasses();
    },
    /**
   * Sets the CSS classes for the state.
   */ _setClasses (state) {
        switch(state){
            case "requesting":
                $34ddf7307461b754$var$removeClasses(this._container, "active following");
                $34ddf7307461b754$var$addClasses(this._container, "requesting");
                $34ddf7307461b754$var$removeClasses(this._icon, this.options.icon);
                $34ddf7307461b754$var$addClasses(this._icon, this.options.iconLoading);
                break;
            case "active":
                $34ddf7307461b754$var$removeClasses(this._container, "requesting following");
                $34ddf7307461b754$var$addClasses(this._container, "active");
                $34ddf7307461b754$var$removeClasses(this._icon, this.options.iconLoading);
                $34ddf7307461b754$var$addClasses(this._icon, this.options.icon);
                break;
            case "following":
                $34ddf7307461b754$var$removeClasses(this._container, "requesting");
                $34ddf7307461b754$var$addClasses(this._container, "active following");
                $34ddf7307461b754$var$removeClasses(this._icon, this.options.iconLoading);
                $34ddf7307461b754$var$addClasses(this._icon, this.options.icon);
                break;
        }
    },
    /**
   * Removes all classes from button.
   */ _cleanClasses () {
        $34ddf7307461b754$var$removeClasses(this._container, "requesting active following");
        $34ddf7307461b754$var$removeClasses(this._icon, this.options.iconLoading);
        $34ddf7307461b754$var$addClasses(this._icon, this.options.icon);
    },
    /**
   * Reinitializes state variables.
   */ _resetVariables () {
        // whether locate is active or not
        this._active = false;
        // true if the control was clicked for the first time
        // we need this so we can pan and zoom once we have the location
        this._justClicked = false;
        // timeout counter for visual feedback
        this._timeoutCount = 0;
        // remove timeout styling
        if (this._container) $34ddf7307461b754$var$removeClasses(this._container, "locate-timeout");
        // true if the user has panned the map after clicking the control
        this._userPanned = false;
        // true if the user has zoomed the map after clicking the control
        this._userZoomed = false;
    }
});
function $34ddf7307461b754$export$5200e0c7549d7bff(options) {
    return new $34ddf7307461b754$export$acde3ad4f992a4ae(options);
}


var $4bc7c168524048ab$exports = {};
$4bc7c168524048ab$exports = import.meta.resolve("lEW0T");


var $768f7fcf18edb3ec$exports = {};
$768f7fcf18edb3ec$exports = import.meta.resolve("es75N");


// Create a basic Leaflet map
const $e362cf30b89a5978$var$map = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map('map').setView([
    51.4700,
    0.2592
], 12);
const $e362cf30b89a5978$var$accessToken = "1b6f5f2a9ad19a57";
const $e362cf30b89a5978$var$layer = (0, $26aceb2bff6f47cf$export$9099b29bdc58680)({
    attribution: 'Map imagery \xa9 <a href="https://protomaps.com">Protomaps</a> \xa9 <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
    url: 'https://api.protomaps.com/tiles/v2/{z}/{x}/{y}.pbf?key=' + $e362cf30b89a5978$var$accessToken
});
$e362cf30b89a5978$var$layer.addTo($e362cf30b89a5978$var$map);
const $e362cf30b89a5978$var$urlFragment = decodeURIComponent(window.location.hash).replace('#', '');
if ([
    ...$e362cf30b89a5978$var$urlFragment
].length == 3) {
    const location = (0, (/*@__PURE__*/$parcel$interopDefault($c1d2be53a502beb1$exports))).coordFromHash($e362cf30b89a5978$var$urlFragment);
    $e362cf30b89a5978$var$map.setView([
        location[0],
        location[1]
    ], 12);
} else new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Hash($e362cf30b89a5978$var$map);
// Geolocator
const $e362cf30b89a5978$var$control = new (0, $34ddf7307461b754$export$acde3ad4f992a4ae)({
    drawCircle: false,
    follow: false,
    showPopup: false,
    markerStyle: {
        opacity: 0
    }
});
$e362cf30b89a5978$var$control.addTo($e362cf30b89a5978$var$map);
// Add Pelias geocoding plugin
const $e362cf30b89a5978$var$pelias = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.Geocoder('ge-1793afb81c0a7784', {
    url: 'https://api.geocode.earth/v1',
    markers: false,
    pointIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4bc7c168524048ab$exports))),
    polygonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($768f7fcf18edb3ec$exports))),
    expanded: true,
    fullWidth: false
}).addTo($e362cf30b89a5978$var$map);
$e362cf30b89a5978$var$map.on('moveend', $e362cf30b89a5978$var$getEmoji);
$e362cf30b89a5978$var$getEmoji();
if (document.getElementById('map').className.indexOf('leaflet-touch') > 0) document.body.className += ' leaflet-touch';
function $e362cf30b89a5978$var$getEmoji() {
    const center = $e362cf30b89a5978$var$map.getCenter();
    const lat = center.lat;
    const lng = center.lng;
    const emoji = (0, (/*@__PURE__*/$parcel$interopDefault($c1d2be53a502beb1$exports))).coordAt(lat, lng);
    window.location.replace("#" + emoji);
    const link = document.createElement('a');
    link.setAttribute('href', '#' + emoji);
    const emojis = $e362cf30b89a5978$var$splitEmoji(emoji);
    for(let i = 0; i < emojis.length; i++){
        const emojiEl = document.createElement('span');
        emojiEl.className = 'emoji-character';
        emojiEl.textContent = emojis[i];
        link.appendChild(emojiEl);
    }
    document.getElementById('emojis').innerHTML = link.outerHTML;
    $e362cf30b89a5978$var$setTitle(emoji);
}
/**
 * Utility for splitting the string of emoji returned by geohash.coordAt()
 * to an array of emoji that we can iterate through. We can't use standard
 * string.split('') because some emoji are two code points long.
 * 
 * @example
 * splitEmoji("😴😄😃⛔🎠🚓🚇") // ['😴', '😄', '😃', '⛔', '🎠', '🚓', '🚇']
 * 
 * @todo
 * (bug) This incorrectly splits '🗃📠🏾' into two segments instead of 3.
 *
 * @param {string} emojiHash 
 * @returns string[] array of emojis
 */ function $e362cf30b89a5978$var$splitEmoji(emojiHash) {
    return [
        ...new Intl.Segmenter().segment(emojiHash)
    ].map((x)=>x.segment);
}
function $e362cf30b89a5978$var$setTitle(emoji) {
    document.title = emoji + " \xb7 what3emojis map";
}


//# sourceMappingURL=map.44a13b2a.js.map
